{
  "title": "World, Robinson projection, low resolution",
  "version": "2.0.1",
  "type": "FeatureCollection",
  "copyright": "Copyright (c) 2022 Highsoft AS, Based on data from Natural Earth",
  "copyrightShort": "Natural Earth",
  "copyrightUrl": "http://www.naturalearthdata.com",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:EPSG:54030"
    }
  },
  "features": [
    {
      "type": "Feature",
      "id": "FO",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.48,
        "hc-middle-y": 0.51,
        "hc-key": "fo",
        "hc-a2": "FO",
        "name": "Faroe Islands",
        "labelrank": "6",
        "country-abbrev": "Faeroe Is.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "FRO",
        "iso-a2": "FO",
        "woe-id": "23424816",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3629,
              9204
            ],
            [
              3637,
              9204
            ],
            [
              3632,
              9197
            ],
            [
              3619,
              9205
            ],
            [
              3629,
              9204
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "US",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.61,
        "hc-middle-y": 0.67,
        "hc-key": "us",
        "hc-a2": "US",
        "name": "United States of America",
        "labelrank": "2",
        "country-abbrev": "U.S.A.",
        "subregion": "Northern America",
        "region-wb": "North America",
        "iso-a3": "USA",
        "iso-a2": "US",
        "woe-id": "23424977",
        "continent": "North America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46,
                8976
              ],
              [
                63,
                8999
              ],
              [
                77,
                8984
              ],
              [
                56,
                8939
              ],
              [
                33,
                8941
              ],
              [
                46,
                8976
              ]
            ]
          ],
          [
            [
              [
                -938,
                8918
              ],
              [
                -974,
                8897
              ],
              [
                -999,
                8893
              ],
              [
                -977,
                8909
              ],
              [
                -938,
                8918
              ]
            ]
          ],
          [
            [
              [
                -428,
                9061
              ],
              [
                -387,
                9075
              ],
              [
                -422,
                9038
              ],
              [
                -497,
                9018
              ],
              [
                -494,
                9033
              ],
              [
                -428,
                9061
              ]
            ]
          ],
          [
            [
              [
                544,
                7872
              ],
              [
                546,
                7887
              ],
              [
                538,
                7891
              ],
              [
                523,
                7938
              ],
              [
                509,
                7984
              ],
              [
                506,
                7986
              ],
              [
                502,
                7990
              ],
              [
                472,
                8000
              ],
              [
                435,
                7965
              ],
              [
                397,
                7992
              ],
              [
                395,
                8025
              ],
              [
                356,
                8072
              ],
              [
                301,
                8072
              ],
              [
                296,
                8055
              ],
              [
                203,
                8055
              ],
              [
                97,
                8100
              ],
              [
                103,
                8108
              ],
              [
                23,
                8101
              ],
              [
                24,
                8123
              ],
              [
                1,
                8152
              ],
              [
                -61,
                8181
              ],
              [
                -73,
                8280
              ],
              [
                -67,
                8307
              ],
              [
                -85,
                8350
              ],
              [
                -77,
                8405
              ],
              [
                -45,
                8443
              ],
              [
                -31,
                8495
              ],
              [
                -5,
                8521
              ],
              [
                77,
                8644
              ],
              [
                86,
                8698
              ],
              [
                145,
                8695
              ],
              [
                165,
                8729
              ],
              [
                984,
                8729
              ],
              [
                1051,
                8711
              ],
              [
                1078,
                8693
              ],
              [
                1133,
                8691
              ],
              [
                1037,
                8646
              ],
              [
                1085,
                8651
              ],
              [
                1083,
                8638
              ],
              [
                1162,
                8670
              ],
              [
                1175,
                8635
              ],
              [
                1252,
                8646
              ],
              [
                1260,
                8633
              ],
              [
                1273,
                8636
              ],
              [
                1270,
                8629
              ],
              [
                1281,
                8613
              ],
              [
                1223,
                8620
              ],
              [
                1217,
                8590
              ],
              [
                1248,
                8609
              ],
              [
                1273,
                8592
              ],
              [
                1262,
                8550
              ],
              [
                1276,
                8535
              ],
              [
                1272,
                8502
              ],
              [
                1263,
                8488
              ],
              [
                1258,
                8485
              ],
              [
                1254,
                8488
              ],
              [
                1242,
                8476
              ],
              [
                1241,
                8475
              ],
              [
                1241,
                8475
              ],
              [
                1221,
                8453
              ],
              [
                1273,
                8446
              ],
              [
                1366,
                8486
              ],
              [
                1378,
                8499
              ],
              [
                1376,
                8501
              ],
              [
                1376,
                8505
              ],
              [
                1377,
                8507
              ],
              [
                1379,
                8511
              ],
              [
                1452,
                8514
              ],
              [
                1480,
                8547
              ],
              [
                1492,
                8552
              ],
              [
                1496,
                8557
              ],
              [
                1517,
                8570
              ],
              [
                1535,
                8575
              ],
              [
                1536,
                8575
              ],
              [
                1633,
                8579
              ],
              [
                1682,
                8612
              ],
              [
                1734,
                8671
              ],
              [
                1772,
                8657
              ],
              [
                1755,
                8607
              ],
              [
                1758,
                8601
              ],
              [
                1764,
                8601
              ],
              [
                1759,
                8589
              ],
              [
                1767,
                8585
              ],
              [
                1769,
                8569
              ],
              [
                1710,
                8542
              ],
              [
                1703,
                8551
              ],
              [
                1640,
                8512
              ],
              [
                1613,
                8476
              ],
              [
                1640,
                8452
              ],
              [
                1521,
                8424
              ],
              [
                1562,
                8427
              ],
              [
                1498,
                8404
              ],
              [
                1419,
                8313
              ],
              [
                1409,
                8362
              ],
              [
                1381,
                8271
              ],
              [
                1396,
                8272
              ],
              [
                1391,
                8221
              ],
              [
                1356,
                8182
              ],
              [
                1337,
                8183
              ],
              [
                1302,
                8152
              ],
              [
                1190,
                8083
              ],
              [
                1159,
                8032
              ],
              [
                1158,
                7995
              ],
              [
                1176,
                7882
              ],
              [
                1155,
                7821
              ],
              [
                1130,
                7817
              ],
              [
                1092,
                7909
              ],
              [
                1106,
                7962
              ],
              [
                1071,
                8008
              ],
              [
                1036,
                7989
              ],
              [
                1003,
                8024
              ],
              [
                954,
                8014
              ],
              [
                916,
                8020
              ],
              [
                843,
                7968
              ],
              [
                819,
                7994
              ],
              [
                795,
                7986
              ],
              [
                738,
                7992
              ],
              [
                621,
                7930
              ],
              [
                606,
                7849
              ],
              [
                571,
                7853
              ],
              [
                544,
                7872
              ]
            ]
          ],
          [
            [
              [
                157,
                8729
              ],
              [
                155,
                8728
              ],
              [
                155,
                8729
              ],
              [
                157,
                8729
              ]
            ]
          ],
          [
            [
              [
                81,
                9059
              ],
              [
                48,
                9041
              ],
              [
                22,
                9022
              ],
              [
                33,
                9056
              ],
              [
                81,
                9059
              ],
              [
                84,
                9067
              ],
              [
                40,
                9067
              ],
              [
                25,
                9097
              ],
              [
                -60,
                9133
              ],
              [
                -95,
                9129
              ],
              [
                -136,
                9146
              ],
              [
                -122,
                9159
              ],
              [
                -179,
                9157
              ],
              [
                -210,
                9122
              ],
              [
                -244,
                9129
              ],
              [
                -291,
                9109
              ],
              [
                -340,
                9105
              ],
              [
                -262,
                9165
              ],
              [
                -412,
                9095
              ],
              [
                -392,
                9092
              ],
              [
                -453,
                9061
              ],
              [
                -519,
                9043
              ],
              [
                -618,
                8998
              ],
              [
                -692,
                8981
              ],
              [
                -889,
                8929
              ],
              [
                -746,
                8982
              ],
              [
                -704,
                8981
              ],
              [
                -691,
                8996
              ],
              [
                -568,
                9043
              ],
              [
                -497,
                9090
              ],
              [
                -569,
                9073
              ],
              [
                -579,
                9096
              ],
              [
                -639,
                9078
              ],
              [
                -599,
                9112
              ],
              [
                -590,
                9133
              ],
              [
                -638,
                9122
              ],
              [
                -653,
                9141
              ],
              [
                -706,
                9123
              ],
              [
                -724,
                9137
              ],
              [
                -673,
                9140
              ],
              [
                -619,
                9159
              ],
              [
                -633,
                9182
              ],
              [
                -504,
                9243
              ],
              [
                -485,
                9236
              ],
              [
                -395,
                9259
              ],
              [
                -354,
                9300
              ],
              [
                -427,
                9282
              ],
              [
                -498,
                9288
              ],
              [
                -466,
                9312
              ],
              [
                -499,
                9325
              ],
              [
                -372,
                9354
              ],
              [
                -367,
                9338
              ],
              [
                -291,
                9344
              ],
              [
                -276,
                9371
              ],
              [
                -321,
                9373
              ],
              [
                -309,
                9390
              ],
              [
                -337,
                9414
              ],
              [
                -302,
                9431
              ],
              [
                -253,
                9433
              ],
              [
                -178,
                9462
              ],
              [
                -51,
                9493
              ],
              [
                -4,
                9495
              ],
              [
                41,
                9509
              ],
              [
                73,
                9494
              ],
              [
                129,
                9495
              ],
              [
                119,
                9482
              ],
              [
                196,
                9483
              ],
              [
                279,
                9467
              ],
              [
                316,
                9471
              ],
              [
                353,
                9456
              ],
              [
                266,
                9385
              ],
              [
                82,
                9222
              ],
              [
                -5,
                9140
              ],
              [
                36,
                9132
              ],
              [
                43,
                9091
              ],
              [
                127,
                9122
              ],
              [
                137,
                9073
              ],
              [
                128,
                9008
              ],
              [
                150,
                8983
              ],
              [
                131,
                8961
              ],
              [
                110,
                8952
              ],
              [
                90,
                8943
              ],
              [
                76,
                8951
              ],
              [
                91,
                8985
              ],
              [
                65,
                9020
              ],
              [
                105,
                9037
              ],
              [
                106,
                9065
              ],
              [
                71,
                9034
              ],
              [
                81,
                9059
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "FR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.28,
        "hc-middle-y": 0.05,
        "hc-key": "fr",
        "hc-a2": "FR",
        "name": "France",
        "labelrank": "2",
        "country-abbrev": "Fr.",
        "subregion": "Western Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "FRA",
        "iso-a2": "FR",
        "woe-id": "-90",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4103,
                8488
              ],
              [
                4107,
                8468
              ],
              [
                4097,
                8440
              ],
              [
                4076,
                8473
              ],
              [
                4103,
                8488
              ]
            ]
          ],
          [
            [
              [
                9359,
                6052
              ],
              [
                9389,
                6053
              ],
              [
                9339,
                5998
              ],
              [
                9291,
                6051
              ],
              [
                9290,
                6078
              ],
              [
                9336,
                6028
              ],
              [
                9359,
                6052
              ]
            ]
          ],
          [
            [
              [
                1698,
                7545
              ],
              [
                1701,
                7547
              ],
              [
                1701,
                7544
              ],
              [
                1698,
                7545
              ]
            ]
          ],
          [
            [
              [
                4041,
                8531
              ],
              [
                4040,
                8529
              ],
              [
                4039,
                8529
              ],
              [
                4038,
                8529
              ],
              [
                4037,
                8528
              ],
              [
                3999,
                8504
              ],
              [
                3933,
                8521
              ],
              [
                3905,
                8499
              ],
              [
                3909,
                8480
              ],
              [
                3889,
                8476
              ],
              [
                3872,
                8480
              ],
              [
                3872,
                8480
              ],
              [
                3872,
                8481
              ],
              [
                3864,
                8483
              ],
              [
                3864,
                8487
              ],
              [
                3855,
                8486
              ],
              [
                3810,
                8489
              ],
              [
                3756,
                8515
              ],
              [
                3766,
                8523
              ],
              [
                3779,
                8617
              ],
              [
                3727,
                8672
              ],
              [
                3671,
                8694
              ],
              [
                3670,
                8713
              ],
              [
                3718,
                8724
              ],
              [
                3731,
                8710
              ],
              [
                3765,
                8719
              ],
              [
                3754,
                8756
              ],
              [
                3805,
                8739
              ],
              [
                3857,
                8774
              ],
              [
                3857,
                8799
              ],
              [
                3885,
                8807
              ],
              [
                3933,
                8765
              ],
              [
                3982,
                8749
              ],
              [
                3988,
                8745
              ],
              [
                3999,
                8746
              ],
              [
                4055,
                8727
              ],
              [
                4038,
                8676
              ],
              [
                3996,
                8638
              ],
              [
                3999,
                8627
              ],
              [
                4001,
                8630
              ],
              [
                4004,
                8630
              ],
              [
                4016,
                8631
              ],
              [
                4016,
                8621
              ],
              [
                4024,
                8613
              ],
              [
                4012,
                8582
              ],
              [
                4041,
                8531
              ]
            ]
          ],
          [
            [
              [
                1973,
                7056
              ],
              [
                1981,
                7071
              ],
              [
                2014,
                7060
              ],
              [
                2056,
                7019
              ],
              [
                2056,
                7005
              ],
              [
                2011,
                6934
              ],
              [
                1956,
                6940
              ],
              [
                1977,
                6983
              ],
              [
                1962,
                7039
              ],
              [
                1973,
                7056
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.50,
        "hc-key": "cn",
        "hc-a2": "CN",
        "name": "China",
        "labelrank": "2",
        "country-abbrev": "China",
        "subregion": "Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "CHN",
        "iso-a2": "CN",
        "woe-id": "23424781",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                7507,
                7581
              ],
              [
                7480,
                7549
              ],
              [
                7448,
                7564
              ],
              [
                7442,
                7592
              ],
              [
                7473,
                7620
              ],
              [
                7514,
                7619
              ],
              [
                7507,
                7581
              ]
            ]
          ],
          [
            [
              [
                6127,
                8390
              ],
              [
                6127,
                8390
              ],
              [
                6133,
                8392
              ],
              [
                6169,
                8412
              ],
              [
                6178,
                8400
              ],
              [
                6204,
                8424
              ],
              [
                6243,
                8428
              ],
              [
                6294,
                8471
              ],
              [
                6299,
                8507
              ],
              [
                6249,
                8579
              ],
              [
                6309,
                8599
              ],
              [
                6306,
                8661
              ],
              [
                6364,
                8647
              ],
              [
                6383,
                8656
              ],
              [
                6369,
                8707
              ],
              [
                6403,
                8732
              ],
              [
                6408,
                8733
              ],
              [
                6416,
                8735
              ],
              [
                6432,
                8712
              ],
              [
                6518,
                8678
              ],
              [
                6558,
                8637
              ],
              [
                6576,
                8586
              ],
              [
                6649,
                8579
              ],
              [
                6728,
                8549
              ],
              [
                6785,
                8491
              ],
              [
                6952,
                8483
              ],
              [
                7030,
                8455
              ],
              [
                7076,
                8454
              ],
              [
                7115,
                8475
              ],
              [
                7196,
                8481
              ],
              [
                7247,
                8527
              ],
              [
                7216,
                8555
              ],
              [
                7216,
                8579
              ],
              [
                7277,
                8566
              ],
              [
                7291,
                8593
              ],
              [
                7324,
                8596
              ],
              [
                7334,
                8628
              ],
              [
                7421,
                8650
              ],
              [
                7356,
                8690
              ],
              [
                7332,
                8690
              ],
              [
                7330,
                8690
              ],
              [
                7329,
                8683
              ],
              [
                7281,
                8680
              ],
              [
                7262,
                8696
              ],
              [
                7257,
                8760
              ],
              [
                7296,
                8748
              ],
              [
                7317,
                8780
              ],
              [
                7319,
                8845
              ],
              [
                7280,
                8869
              ],
              [
                7289,
                8887
              ],
              [
                7350,
                8898
              ],
              [
                7438,
                8877
              ],
              [
                7485,
                8846
              ],
              [
                7527,
                8806
              ],
              [
                7600,
                8749
              ],
              [
                7642,
                8745
              ],
              [
                7715,
                8702
              ],
              [
                7737,
                8679
              ],
              [
                7781,
                8680
              ],
              [
                7819,
                8706
              ],
              [
                7847,
                8681
              ],
              [
                7858,
                8626
              ],
              [
                7855,
                8581
              ],
              [
                7841,
                8590
              ],
              [
                7826,
                8587
              ],
              [
                7803,
                8569
              ],
              [
                7832,
                8540
              ],
              [
                7844,
                8484
              ],
              [
                7779,
                8464
              ],
              [
                7796,
                8440
              ],
              [
                7742,
                8451
              ],
              [
                7739,
                8423
              ],
              [
                7704,
                8392
              ],
              [
                7666,
                8377
              ],
              [
                7630,
                8342
              ],
              [
                7622,
                8368
              ],
              [
                7632,
                8408
              ],
              [
                7588,
                8423
              ],
              [
                7557,
                8387
              ],
              [
                7554,
                8360
              ],
              [
                7516,
                8357
              ],
              [
                7543,
                8319
              ],
              [
                7567,
                8320
              ],
              [
                7603,
                8280
              ],
              [
                7632,
                8308
              ],
              [
                7702,
                8291
              ],
              [
                7656,
                8254
              ],
              [
                7635,
                8219
              ],
              [
                7634,
                8186
              ],
              [
                7674,
                8170
              ],
              [
                7718,
                8107
              ],
              [
                7760,
                8079
              ],
              [
                7779,
                8039
              ],
              [
                7751,
                8025
              ],
              [
                7785,
                8003
              ],
              [
                7800,
                7940
              ],
              [
                7784,
                7942
              ],
              [
                7775,
                7897
              ],
              [
                7753,
                7851
              ],
              [
                7770,
                7833
              ],
              [
                7690,
                7756
              ],
              [
                7679,
                7733
              ],
              [
                7624,
                7728
              ],
              [
                7610,
                7704
              ],
              [
                7584,
                7736
              ],
              [
                7587,
                7701
              ],
              [
                7538,
                7689
              ],
              [
                7486,
                7657
              ],
              [
                7479,
                7629
              ],
              [
                7465,
                7676
              ],
              [
                7419,
                7691
              ],
              [
                7407,
                7677
              ],
              [
                7361,
                7697
              ],
              [
                7347,
                7732
              ],
              [
                7305,
                7749
              ],
              [
                7266,
                7716
              ],
              [
                7215,
                7726
              ],
              [
                7206,
                7712
              ],
              [
                7186,
                7706
              ],
              [
                7199,
                7663
              ],
              [
                7179,
                7679
              ],
              [
                7147,
                7674
              ],
              [
                7135,
                7698
              ],
              [
                7108,
                7702
              ],
              [
                7114,
                7737
              ],
              [
                7092,
                7742
              ],
              [
                7077,
                7776
              ],
              [
                7047,
                7768
              ],
              [
                7041,
                7815
              ],
              [
                7068,
                7846
              ],
              [
                7054,
                7910
              ],
              [
                7008,
                7948
              ],
              [
                7003,
                7936
              ],
              [
                6954,
                7980
              ],
              [
                6929,
                7968
              ],
              [
                6905,
                7978
              ],
              [
                6852,
                7924
              ],
              [
                6821,
                7918
              ],
              [
                6769,
                7941
              ],
              [
                6734,
                7901
              ],
              [
                6726,
                7927
              ],
              [
                6704,
                7922
              ],
              [
                6651,
                7931
              ],
              [
                6634,
                7923
              ],
              [
                6561,
                7976
              ],
              [
                6543,
                7973
              ],
              [
                6486,
                8017
              ],
              [
                6452,
                8012
              ],
              [
                6369,
                8055
              ],
              [
                6346,
                8101
              ],
              [
                6380,
                8110
              ],
              [
                6351,
                8138
              ],
              [
                6346,
                8172
              ],
              [
                6323,
                8182
              ],
              [
                6299,
                8216
              ],
              [
                6286,
                8215
              ],
              [
                6264,
                8222
              ],
              [
                6230,
                8254
              ],
              [
                6179,
                8276
              ],
              [
                6173,
                8280
              ],
              [
                6188,
                8284
              ],
              [
                6170,
                8334
              ],
              [
                6139,
                8337
              ],
              [
                6124,
                8370
              ],
              [
                6131,
                8375
              ],
              [
                6127,
                8390
              ]
            ]
          ],
          [
            [
              [
                7706,
                8391
              ],
              [
                7706,
                8391
              ],
              [
                7706,
                8390
              ],
              [
                7706,
                8389
              ],
              [
                7706,
                8391
              ]
            ]
          ],
          [
            [
              [
                6127,
                8391
              ],
              [
                6127,
                8390
              ],
              [
                6127,
                8390
              ],
              [
                6127,
                8390
              ],
              [
                6127,
                8391
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PT",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.49,
        "hc-key": "pt",
        "hc-a2": "PT",
        "name": "Portugal",
        "labelrank": "2",
        "country-abbrev": "Port.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "PRT",
        "iso-a2": "PT",
        "woe-id": "23424925",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                3576,
                8282
              ],
              [
                3525,
                8276
              ],
              [
                3534,
                8321
              ],
              [
                3512,
                8342
              ],
              [
                3540,
                8419
              ],
              [
                3540,
                8463
              ],
              [
                3607,
                8462
              ],
              [
                3618,
                8448
              ],
              [
                3595,
                8427
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3574,
                8379
              ],
              [
                3592,
                8354
              ],
              [
                3576,
                8282
              ]
            ]
          ],
          [
            [
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3596,
                8389
              ],
              [
                3595,
                8390
              ]
            ]
          ],
          [
            [
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SW",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.83,
        "hc-middle-y": 0.54,
        "hc-key": "sw",
        "hc-a2": "SW",
        "name": "Serranilla Bank",
        "labelrank": "5",
        "country-abbrev": "S.B.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "-99",
        "iso-a2": "SW",
        "woe-id": "-99",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1169,
              7461
            ],
            [
              1169,
              7460
            ],
            [
              1168,
              7460
            ],
            [
              1169,
              7461
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SH",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.50,
        "hc-key": "sh",
        "hc-a2": "SH",
        "name": "Scarborough Reef",
        "labelrank": "6",
        "country-abbrev": "S.R.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "-99",
        "iso-a2": "SH",
        "woe-id": "-99",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7772,
              7433
            ],
            [
              7772,
              7433
            ],
            [
              7772,
              7433
            ],
            [
              7772,
              7433
            ],
            [
              7772,
              7433
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "EC",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.70,
        "hc-middle-y": 0.35,
        "hc-key": "ec",
        "hc-a2": "EC",
        "name": "Ecuador",
        "labelrank": "3",
        "country-abbrev": "Ecu.",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "ECU",
        "iso-a2": "EC",
        "woe-id": "23424801",
        "continent": "South America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                723,
                6840
              ],
              [
                777,
                6821
              ],
              [
                768,
                6813
              ],
              [
                733,
                6836
              ],
              [
                723,
                6840
              ]
            ]
          ],
          [
            [
              [
                1083,
                6720
              ],
              [
                1101,
                6748
              ],
              [
                1062,
                6761
              ],
              [
                1061,
                6809
              ],
              [
                1090,
                6852
              ],
              [
                1089,
                6878
              ],
              [
                1132,
                6905
              ],
              [
                1178,
                6875
              ],
              [
                1218,
                6868
              ],
              [
                1253,
                6846
              ],
              [
                1243,
                6791
              ],
              [
                1206,
                6751
              ],
              [
                1150,
                6719
              ],
              [
                1128,
                6657
              ],
              [
                1077,
                6693
              ],
              [
                1083,
                6720
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PH",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.37,
        "hc-middle-y": 0.06,
        "hc-key": "ph",
        "hc-a2": "PH",
        "name": "Philippines",
        "labelrank": "2",
        "country-abbrev": "Phil.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "PHL",
        "iso-a2": "PH",
        "woe-id": "23424934",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                7986,
                7236
              ],
              [
                8000,
                7272
              ],
              [
                8017,
                7220
              ],
              [
                7976,
                7198
              ],
              [
                7952,
                7229
              ],
              [
                7976,
                7273
              ],
              [
                7986,
                7236
              ]
            ]
          ],
          [
            [
              [
                7929,
                7318
              ],
              [
                7972,
                7291
              ],
              [
                7956,
                7262
              ],
              [
                7935,
                7251
              ],
              [
                7929,
                7318
              ]
            ]
          ],
          [
            [
              [
                7864,
                7376
              ],
              [
                7897,
                7367
              ],
              [
                7909,
                7356
              ],
              [
                7904,
                7320
              ],
              [
                7864,
                7376
              ]
            ]
          ],
          [
            [
              [
                8016,
                7292
              ],
              [
                8034,
                7302
              ],
              [
                8005,
                7333
              ],
              [
                8048,
                7321
              ],
              [
                8059,
                7278
              ],
              [
                8036,
                7283
              ],
              [
                8013,
                7258
              ],
              [
                8016,
                7292
              ]
            ]
          ],
          [
            [
              [
                8066,
                7065
              ],
              [
                8018,
                7098
              ],
              [
                8015,
                7143
              ],
              [
                7969,
                7150
              ],
              [
                7959,
                7105
              ],
              [
                7911,
                7062
              ],
              [
                7912,
                7082
              ],
              [
                7946,
                7107
              ],
              [
                7953,
                7157
              ],
              [
                7989,
                7185
              ],
              [
                8007,
                7164
              ],
              [
                8035,
                7199
              ],
              [
                8061,
                7197
              ],
              [
                8059,
                7235
              ],
              [
                8089,
                7191
              ],
              [
                8103,
                7130
              ],
              [
                8091,
                7092
              ],
              [
                8075,
                7133
              ],
              [
                8062,
                7107
              ],
              [
                8066,
                7065
              ]
            ]
          ],
          [
            [
              [
                7994,
                7380
              ],
              [
                7978,
                7319
              ],
              [
                7963,
                7368
              ],
              [
                7948,
                7359
              ],
              [
                7912,
                7388
              ],
              [
                7904,
                7376
              ],
              [
                7852,
                7420
              ],
              [
                7834,
                7479
              ],
              [
                7855,
                7472
              ],
              [
                7846,
                7561
              ],
              [
                7892,
                7553
              ],
              [
                7886,
                7575
              ],
              [
                7905,
                7557
              ],
              [
                7921,
                7508
              ],
              [
                7893,
                7441
              ],
              [
                7911,
                7396
              ],
              [
                7936,
                7402
              ],
              [
                7994,
                7380
              ]
            ]
          ],
          [
            [
              [
                7851,
                7284
              ],
              [
                7849,
                7290
              ],
              [
                7858,
                7310
              ],
              [
                7851,
                7284
              ],
              [
                7851,
                7284
              ]
            ]
          ],
          [
            [
              [
                7851,
                7284
              ],
              [
                7866,
                7253
              ],
              [
                7829,
                7230
              ],
              [
                7822,
                7208
              ],
              [
                7785,
                7176
              ],
              [
                7846,
                7263
              ],
              [
                7851,
                7284
              ],
              [
                7851,
                7284
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BU",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.46,
        "hc-middle-y": 0.67,
        "hc-key": "bu",
        "hc-a2": "BU",
        "name": "Bajo Nuevo Bank (Petrel Is.)",
        "labelrank": "8",
        "country-abbrev": null,
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "-99",
        "iso-a2": "BU",
        "woe-id": "-99",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1123,
              7458
            ],
            [
              1123,
              7458
            ],
            [
              1123,
              7458
            ],
            [
              1123,
              7458
            ],
            [
              1123,
              7458
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MV",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.60,
        "hc-middle-y": 0.59,
        "hc-key": "mv",
        "hc-a2": "MV",
        "name": "Maldives",
        "labelrank": "5",
        "country-abbrev": "Mald.",
        "subregion": "Southern Asia",
        "region-wb": "South Asia",
        "iso-a3": "MDV",
        "iso-a2": "MV",
        "woe-id": "23424899",
        "continent": "Seven seas (open ocean)"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6308,
              7053
            ],
            [
              6299,
              7057
            ],
            [
              6304,
              7063
            ],
            [
              6309,
              7059
            ],
            [
              6308,
              7053
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SP",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.51,
        "hc-key": "sp",
        "hc-a2": "SP",
        "name": "Spratly Islands",
        "labelrank": "6",
        "country-abbrev": "Spratly Is.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "-99",
        "iso-a2": "SP",
        "woe-id": "23424921",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7727,
              7266
            ],
            [
              7727,
              7267
            ],
            [
              7727,
              7267
            ],
            [
              7727,
              7267
            ],
            [
              7727,
              7266
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GB",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.60,
        "hc-middle-y": 0.06,
        "hc-key": "gb",
        "hc-a2": "GB",
        "name": "United Kingdom",
        "labelrank": "2",
        "country-abbrev": "U.K.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "GBR",
        "iso-a2": "GB",
        "woe-id": "-90",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                2070,
                4862
              ],
              [
                2053,
                4851
              ],
              [
                2050,
                4886
              ],
              [
                2120,
                4883
              ],
              [
                2114,
                4856
              ],
              [
                2070,
                4862
              ]
            ]
          ],
          [
            [
              [
                4897,
                8195
              ],
              [
                4896,
                8194
              ],
              [
                4894,
                8196
              ],
              [
                4893,
                8196
              ],
              [
                4893,
                8196
              ],
              [
                4893,
                8196
              ],
              [
                4891,
                8196
              ],
              [
                4891,
                8196
              ],
              [
                4891,
                8197
              ],
              [
                4890,
                8198
              ],
              [
                4893,
                8198
              ],
              [
                4897,
                8199
              ],
              [
                4897,
                8199
              ],
              [
                4894,
                8198
              ],
              [
                4897,
                8195
              ]
            ],
            [
              [
                4892,
                8197
              ],
              [
                4892,
                8197
              ],
              [
                4892,
                8197
              ],
              [
                4892,
                8197
              ],
              [
                4892,
                8197
              ]
            ]
          ],
          [
            [
              [
                3641,
                8241
              ],
              [
                3641,
                8240
              ],
              [
                3640,
                8241
              ],
              [
                3641,
                8241
              ]
            ]
          ],
          [
            [
              [
                4870,
                8182
              ],
              [
                4867,
                8183
              ],
              [
                4862,
                8183
              ],
              [
                4864,
                8185
              ],
              [
                4870,
                8182
              ]
            ]
          ],
          [
            [
              [
                3606,
                8953
              ],
              [
                3636,
                8961
              ],
              [
                3654,
                8938
              ],
              [
                3632,
                8917
              ],
              [
                3578,
                8931
              ],
              [
                3606,
                8953
              ]
            ]
          ],
          [
            [
              [
                3765,
                8971
              ],
              [
                3777,
                8937
              ],
              [
                3809,
                8918
              ],
              [
                3821,
                8880
              ],
              [
                3862,
                8858
              ],
              [
                3831,
                8821
              ],
              [
                3851,
                8808
              ],
              [
                3774,
                8788
              ],
              [
                3711,
                8790
              ],
              [
                3699,
                8774
              ],
              [
                3651,
                8774
              ],
              [
                3690,
                8811
              ],
              [
                3722,
                8811
              ],
              [
                3657,
                8835
              ],
              [
                3689,
                8851
              ],
              [
                3691,
                8885
              ],
              [
                3719,
                8892
              ],
              [
                3730,
                8921
              ],
              [
                3715,
                8946
              ],
              [
                3665,
                8946
              ],
              [
                3681,
                8968
              ],
              [
                3648,
                8961
              ],
              [
                3652,
                9001
              ],
              [
                3615,
                9065
              ],
              [
                3639,
                9077
              ],
              [
                3640,
                9035
              ],
              [
                3674,
                9081
              ],
              [
                3717,
                9082
              ],
              [
                3775,
                9128
              ],
              [
                3698,
                9056
              ],
              [
                3762,
                9039
              ],
              [
                3722,
                8989
              ],
              [
                3765,
                8971
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.41,
        "hc-middle-y": 0.71,
        "hc-key": "gr",
        "hc-a2": "GR",
        "name": "Greece",
        "labelrank": "3",
        "country-abbrev": "Greece",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "GRC",
        "iso-a2": "GR",
        "woe-id": "23424833",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4632,
                8321
              ],
              [
                4646,
                8302
              ],
              [
                4617,
                8291
              ],
              [
                4637,
                8300
              ],
              [
                4632,
                8321
              ]
            ]
          ],
          [
            [
              [
                4671,
                8210
              ],
              [
                4649,
                8197
              ],
              [
                4604,
                8194
              ],
              [
                4564,
                8208
              ],
              [
                4565,
                8221
              ],
              [
                4671,
                8210
              ]
            ]
          ],
          [
            [
              [
                4467,
                8415
              ],
              [
                4470,
                8417
              ],
              [
                4467,
                8415
              ],
              [
                4464,
                8417
              ],
              [
                4465,
                8419
              ],
              [
                4467,
                8420
              ],
              [
                4470,
                8421
              ],
              [
                4493,
                8430
              ],
              [
                4524,
                8439
              ],
              [
                4572,
                8447
              ],
              [
                4596,
                8435
              ],
              [
                4628,
                8453
              ],
              [
                4639,
                8441
              ],
              [
                4624,
                8416
              ],
              [
                4596,
                8385
              ],
              [
                4607,
                8421
              ],
              [
                4551,
                8414
              ],
              [
                4574,
                8395
              ],
              [
                4517,
                8395
              ],
              [
                4545,
                8360
              ],
              [
                4529,
                8345
              ],
              [
                4568,
                8325
              ],
              [
                4580,
                8296
              ],
              [
                4546,
                8313
              ],
              [
                4531,
                8297
              ],
              [
                4550,
                8253
              ],
              [
                4501,
                8265
              ],
              [
                4480,
                8308
              ],
              [
                4472,
                8354
              ],
              [
                4438,
                8380
              ],
              [
                4457,
                8392
              ],
              [
                4467,
                8415
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "DK",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.31,
        "hc-middle-y": 0.55,
        "hc-key": "dk",
        "hc-a2": "DK",
        "name": "Denmark",
        "labelrank": "4",
        "country-abbrev": "Den.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "DNK",
        "iso-a2": "DK",
        "woe-id": "23424796",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4155,
                8947
              ],
              [
                4124,
                8974
              ],
              [
                4155,
                8991
              ],
              [
                4169,
                8972
              ],
              [
                4155,
                8947
              ]
            ]
          ],
          [
            [
              [
                4079,
                8943
              ],
              [
                4062,
                8947
              ],
              [
                4057,
                8947
              ],
              [
                4039,
                9006
              ],
              [
                4103,
                9049
              ],
              [
                4101,
                9007
              ],
              [
                4122,
                8956
              ],
              [
                4106,
                8944
              ],
              [
                4089,
                8965
              ],
              [
                4079,
                8943
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GL",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.34,
        "hc-key": "gl",
        "hc-a2": "GL",
        "name": "Greenland",
        "labelrank": "3",
        "country-abbrev": "Grlnd.",
        "subregion": "Northern America",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "GRL",
        "iso-a2": "GL",
        "woe-id": "23424828",
        "continent": "North America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                2476,
                9479
              ],
              [
                2513,
                9474
              ],
              [
                2533,
                9452
              ],
              [
                2491,
                9443
              ],
              [
                2463,
                9458
              ],
              [
                2476,
                9479
              ]
            ]
          ],
          [
            [
              [
                3039,
                9847
              ],
              [
                3165,
                9851
              ],
              [
                3298,
                9844
              ],
              [
                3380,
                9829
              ],
              [
                3355,
                9822
              ],
              [
                3203,
                9818
              ],
              [
                3308,
                9814
              ],
              [
                3267,
                9801
              ],
              [
                3375,
                9816
              ],
              [
                3374,
                9803
              ],
              [
                3331,
                9788
              ],
              [
                3419,
                9805
              ],
              [
                3488,
                9810
              ],
              [
                3576,
                9802
              ],
              [
                3480,
                9775
              ],
              [
                3402,
                9771
              ],
              [
                3393,
                9730
              ],
              [
                3360,
                9732
              ],
              [
                3346,
                9709
              ],
              [
                3360,
                9693
              ],
              [
                3406,
                9688
              ],
              [
                3356,
                9680
              ],
              [
                3324,
                9660
              ],
              [
                3364,
                9660
              ],
              [
                3371,
                9635
              ],
              [
                3414,
                9623
              ],
              [
                3363,
                9600
              ],
              [
                3318,
                9595
              ],
              [
                3331,
                9575
              ],
              [
                3288,
                9569
              ],
              [
                3251,
                9580
              ],
              [
                3198,
                9569
              ],
              [
                3252,
                9562
              ],
              [
                3290,
                9485
              ],
              [
                3244,
                9481
              ],
              [
                3200,
                9511
              ],
              [
                3196,
                9480
              ],
              [
                3265,
                9471
              ],
              [
                3159,
                9425
              ],
              [
                3079,
                9409
              ],
              [
                3012,
                9404
              ],
              [
                2929,
                9348
              ],
              [
                2843,
                9321
              ],
              [
                2824,
                9325
              ],
              [
                2764,
                9296
              ],
              [
                2751,
                9259
              ],
              [
                2695,
                9219
              ],
              [
                2664,
                9161
              ],
              [
                2612,
                9123
              ],
              [
                2582,
                9137
              ],
              [
                2572,
                9164
              ],
              [
                2513,
                9159
              ],
              [
                2489,
                9232
              ],
              [
                2454,
                9272
              ],
              [
                2468,
                9301
              ],
              [
                2442,
                9340
              ],
              [
                2489,
                9367
              ],
              [
                2449,
                9372
              ],
              [
                2511,
                9424
              ],
              [
                2541,
                9421
              ],
              [
                2564,
                9455
              ],
              [
                2502,
                9479
              ],
              [
                2516,
                9513
              ],
              [
                2483,
                9511
              ],
              [
                2490,
                9555
              ],
              [
                2515,
                9604
              ],
              [
                2482,
                9625
              ],
              [
                2488,
                9644
              ],
              [
                2389,
                9664
              ],
              [
                2271,
                9655
              ],
              [
                2228,
                9682
              ],
              [
                2286,
                9701
              ],
              [
                2224,
                9715
              ],
              [
                2240,
                9725
              ],
              [
                2352,
                9740
              ],
              [
                2397,
                9741
              ],
              [
                2438,
                9765
              ],
              [
                2395,
                9774
              ],
              [
                2551,
                9808
              ],
              [
                2706,
                9823
              ],
              [
                2800,
                9813
              ],
              [
                2776,
                9826
              ],
              [
                2892,
                9816
              ],
              [
                2853,
                9832
              ],
              [
                2917,
                9841
              ],
              [
                3036,
                9840
              ],
              [
                3039,
                9847
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.50,
        "hc-key": "pr",
        "hc-a2": "PR",
        "name": "Puerto Rico",
        "labelrank": "5",
        "country-abbrev": "P.R.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "PRI",
        "iso-a2": "PR",
        "woe-id": "23424935",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1621,
              7549
            ],
            [
              1563,
              7541
            ],
            [
              1563,
              7561
            ],
            [
              1615,
              7558
            ],
            [
              1621,
              7549
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "UM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.48,
        "hc-middle-y": 0.50,
        "hc-key": "um",
        "hc-a2": "UM",
        "name": "United States Minor Outlying Islands",
        "labelrank": "5",
        "country-abbrev": "U.S. MOI",
        "subregion": "Seven seas (open ocean)",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "UMI",
        "iso-a2": "UM",
        "woe-id": "28289407",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1300,
              7559
            ],
            [
              1301,
              7559
            ],
            [
              1301,
              7558
            ],
            [
              1300,
              7558
            ],
            [
              1300,
              7559
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "VI",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.47,
        "hc-middle-y": 0.16,
        "hc-key": "vi",
        "hc-a2": "VI",
        "name": "United States Virgin Islands",
        "labelrank": "6",
        "country-abbrev": "V.I. (U.S.)",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "VIR",
        "iso-a2": "VI",
        "woe-id": "23424985",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1642,
              7534
            ],
            [
              1648,
              7533
            ],
            [
              1636,
              7530
            ],
            [
              1637,
              7534
            ],
            [
              1642,
              7534
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.28,
        "hc-middle-y": 0.55,
        "hc-key": "ca",
        "hc-a2": "CA",
        "name": "Canada",
        "labelrank": "2",
        "country-abbrev": "Can.",
        "subregion": "Northern America",
        "region-wb": "North America",
        "iso-a3": "CAN",
        "iso-a2": "CA",
        "woe-id": "23424775",
        "continent": "North America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                1535,
                8575
              ],
              [
                1517,
                8570
              ],
              [
                1496,
                8557
              ],
              [
                1478,
                8548
              ],
              [
                1480,
                8547
              ],
              [
                1385,
                8532
              ],
              [
                1379,
                8511
              ],
              [
                1377,
                8507
              ],
              [
                1376,
                8505
              ],
              [
                1375,
                8501
              ],
              [
                1378,
                8499
              ],
              [
                1299,
                8488
              ],
              [
                1251,
                8465
              ],
              [
                1241,
                8475
              ],
              [
                1241,
                8475
              ],
              [
                1242,
                8476
              ],
              [
                1261,
                8476
              ],
              [
                1258,
                8485
              ],
              [
                1263,
                8488
              ],
              [
                1272,
                8502
              ],
              [
                1297,
                8514
              ],
              [
                1337,
                8568
              ],
              [
                1380,
                8568
              ],
              [
                1365,
                8613
              ],
              [
                1341,
                8621
              ],
              [
                1327,
                8598
              ],
              [
                1282,
                8612
              ],
              [
                1339,
                8620
              ],
              [
                1270,
                8629
              ],
              [
                1273,
                8636
              ],
              [
                1260,
                8633
              ],
              [
                1272,
                8690
              ],
              [
                1237,
                8681
              ],
              [
                1240,
                8720
              ],
              [
                1182,
                8717
              ],
              [
                1133,
                8691
              ],
              [
                1078,
                8693
              ],
              [
                1051,
                8711
              ],
              [
                984,
                8729
              ],
              [
                165,
                8729
              ],
              [
                163,
                8732
              ],
              [
                157,
                8729
              ],
              [
                155,
                8729
              ],
              [
                136,
                8743
              ],
              [
                141,
                8735
              ],
              [
                135,
                8707
              ],
              [
                98,
                8713
              ],
              [
                69,
                8739
              ],
              [
                43,
                8789
              ],
              [
                65,
                8801
              ],
              [
                89,
                8790
              ],
              [
                75,
                8812
              ],
              [
                102,
                8875
              ],
              [
                78,
                8850
              ],
              [
                88,
                8890
              ],
              [
                64,
                8892
              ],
              [
                95,
                8920
              ],
              [
                97,
                8941
              ],
              [
                110,
                8952
              ],
              [
                150,
                8983
              ],
              [
                128,
                9008
              ],
              [
                137,
                9073
              ],
              [
                127,
                9122
              ],
              [
                43,
                9091
              ],
              [
                36,
                9132
              ],
              [
                -5,
                9140
              ],
              [
                82,
                9222
              ],
              [
                266,
                9385
              ],
              [
                353,
                9456
              ],
              [
                403,
                9454
              ],
              [
                404,
                9439
              ],
              [
                450,
                9432
              ],
              [
                521,
                9457
              ],
              [
                534,
                9448
              ],
              [
                654,
                9476
              ],
              [
                616,
                9457
              ],
              [
                716,
                9475
              ],
              [
                723,
                9445
              ],
              [
                803,
                9462
              ],
              [
                939,
                9429
              ],
              [
                980,
                9425
              ],
              [
                928,
                9396
              ],
              [
                1015,
                9393
              ],
              [
                1078,
                9410
              ],
              [
                1091,
                9379
              ],
              [
                1124,
                9423
              ],
              [
                1181,
                9432
              ],
              [
                1201,
                9403
              ],
              [
                1265,
                9392
              ],
              [
                1347,
                9395
              ],
              [
                1354,
                9414
              ],
              [
                1422,
                9412
              ],
              [
                1386,
                9385
              ],
              [
                1405,
                9380
              ],
              [
                1427,
                9404
              ],
              [
                1488,
                9420
              ],
              [
                1466,
                9427
              ],
              [
                1493,
                9450
              ],
              [
                1458,
                9463
              ],
              [
                1492,
                9509
              ],
              [
                1558,
                9531
              ],
              [
                1577,
                9511
              ],
              [
                1562,
                9495
              ],
              [
                1573,
                9431
              ],
              [
                1561,
                9410
              ],
              [
                1619,
                9442
              ],
              [
                1602,
                9373
              ],
              [
                1634,
                9382
              ],
              [
                1639,
                9405
              ],
              [
                1666,
                9404
              ],
              [
                1710,
                9426
              ],
              [
                1717,
                9460
              ],
              [
                1784,
                9457
              ],
              [
                1795,
                9423
              ],
              [
                1762,
                9414
              ],
              [
                1769,
                9384
              ],
              [
                1751,
                9369
              ],
              [
                1689,
                9348
              ],
              [
                1678,
                9368
              ],
              [
                1673,
                9323
              ],
              [
                1641,
                9355
              ],
              [
                1563,
                9313
              ],
              [
                1519,
                9334
              ],
              [
                1524,
                9313
              ],
              [
                1569,
                9310
              ],
              [
                1520,
                9275
              ],
              [
                1468,
                9272
              ],
              [
                1424,
                9236
              ],
              [
                1355,
                9215
              ],
              [
                1340,
                9197
              ],
              [
                1296,
                9180
              ],
              [
                1236,
                9127
              ],
              [
                1217,
                9084
              ],
              [
                1253,
                9085
              ],
              [
                1242,
                9039
              ],
              [
                1225,
                9020
              ],
              [
                1278,
                9032
              ],
              [
                1329,
                9017
              ],
              [
                1348,
                8988
              ],
              [
                1415,
                8959
              ],
              [
                1476,
                8953
              ],
              [
                1448,
                8888
              ],
              [
                1478,
                8866
              ],
              [
                1437,
                8876
              ],
              [
                1462,
                8816
              ],
              [
                1478,
                8808
              ],
              [
                1536,
                8854
              ],
              [
                1533,
                8878
              ],
              [
                1553,
                8920
              ],
              [
                1541,
                8938
              ],
              [
                1596,
                8955
              ],
              [
                1574,
                8990
              ],
              [
                1586,
                9007
              ],
              [
                1616,
                8966
              ],
              [
                1654,
                8988
              ],
              [
                1680,
                9037
              ],
              [
                1679,
                9057
              ],
              [
                1646,
                9089
              ],
              [
                1715,
                9129
              ],
              [
                1702,
                9156
              ],
              [
                1734,
                9189
              ],
              [
                1744,
                9220
              ],
              [
                1824,
                9205
              ],
              [
                1854,
                9215
              ],
              [
                1897,
                9187
              ],
              [
                1887,
                9179
              ],
              [
                1942,
                9157
              ],
              [
                1909,
                9112
              ],
              [
                1951,
                9069
              ],
              [
                2025,
                9104
              ],
              [
                2060,
                9146
              ],
              [
                2101,
                9026
              ],
              [
                2081,
                9015
              ],
              [
                2116,
                8954
              ],
              [
                2176,
                8938
              ],
              [
                2134,
                8915
              ],
              [
                2089,
                8905
              ],
              [
                2076,
                8887
              ],
              [
                2167,
                8921
              ],
              [
                2204,
                8897
              ],
              [
                2199,
                8857
              ],
              [
                2148,
                8819
              ],
              [
                2089,
                8807
              ],
              [
                2040,
                8774
              ],
              [
                1854,
                8776
              ],
              [
                1815,
                8742
              ],
              [
                1757,
                8720
              ],
              [
                1717,
                8683
              ],
              [
                1661,
                8644
              ],
              [
                1604,
                8624
              ],
              [
                1599,
                8619
              ],
              [
                1689,
                8654
              ],
              [
                1750,
                8700
              ],
              [
                1847,
                8737
              ],
              [
                1901,
                8727
              ],
              [
                1893,
                8707
              ],
              [
                1855,
                8691
              ],
              [
                1862,
                8628
              ],
              [
                1880,
                8645
              ],
              [
                1927,
                8630
              ],
              [
                1957,
                8591
              ],
              [
                1864,
                8555
              ],
              [
                1862,
                8564
              ],
              [
                1794,
                8517
              ],
              [
                1767,
                8585
              ],
              [
                1759,
                8589
              ],
              [
                1764,
                8601
              ],
              [
                1758,
                8604
              ],
              [
                1755,
                8607
              ],
              [
                1772,
                8657
              ],
              [
                1734,
                8671
              ],
              [
                1682,
                8612
              ],
              [
                1633,
                8579
              ],
              [
                1536,
                8575
              ],
              [
                1536,
                8575
              ],
              [
                1535,
                8575
              ]
            ],
            [
              [
                98,
                8786
              ],
              [
                108,
                8782
              ],
              [
                130,
                8750
              ],
              [
                134,
                8778
              ],
              [
                98,
                8786
              ]
            ]
          ],
          [
            [
              [
                1919,
                8764
              ],
              [
                1978,
                8742
              ],
              [
                1963,
                8731
              ],
              [
                1928,
                8743
              ],
              [
                1919,
                8764
              ]
            ]
          ],
          [
            [
              [
                1928,
                9412
              ],
              [
                1926,
                9387
              ],
              [
                1871,
                9377
              ],
              [
                1900,
                9411
              ],
              [
                1928,
                9412
              ]
            ]
          ],
          [
            [
              [
                1668,
                9647
              ],
              [
                1680,
                9631
              ],
              [
                1659,
                9612
              ],
              [
                1614,
                9607
              ],
              [
                1600,
                9622
              ],
              [
                1668,
                9647
              ]
            ]
          ],
          [
            [
              [
                1382,
                9718
              ],
              [
                1356,
                9722
              ],
              [
                1431,
                9732
              ],
              [
                1421,
                9712
              ],
              [
                1385,
                9696
              ],
              [
                1337,
                9691
              ],
              [
                1324,
                9705
              ],
              [
                1382,
                9718
              ]
            ]
          ],
          [
            [
              [
                1955,
                8663
              ],
              [
                1971,
                8677
              ],
              [
                1995,
                8647
              ],
              [
                1983,
                8625
              ],
              [
                2003,
                8616
              ],
              [
                1958,
                8596
              ],
              [
                1948,
                8618
              ],
              [
                1977,
                8646
              ],
              [
                1955,
                8663
              ]
            ]
          ],
          [
            [
              [
                7,
                8883
              ],
              [
                -9,
                8887
              ],
              [
                11,
                8921
              ],
              [
                49,
                8920
              ],
              [
                7,
                8883
              ]
            ]
          ],
          [
            [
              [
                1439,
                9450
              ],
              [
                1436,
                9426
              ],
              [
                1411,
                9417
              ],
              [
                1327,
                9436
              ],
              [
                1389,
                9445
              ],
              [
                1417,
                9464
              ],
              [
                1439,
                9450
              ]
            ]
          ],
          [
            [
              [
                1926,
                9563
              ],
              [
                1929,
                9584
              ],
              [
                1989,
                9582
              ],
              [
                2011,
                9556
              ],
              [
                1943,
                9554
              ],
              [
                1926,
                9563
              ]
            ]
          ],
          [
            [
              [
                1706,
                9759
              ],
              [
                1712,
                9733
              ],
              [
                1750,
                9723
              ],
              [
                1698,
                9696
              ],
              [
                1681,
                9719
              ],
              [
                1706,
                9759
              ]
            ]
          ],
          [
            [
              [
                1576,
                9718
              ],
              [
                1598,
                9748
              ],
              [
                1659,
                9727
              ],
              [
                1646,
                9707
              ],
              [
                1576,
                9718
              ]
            ]
          ],
          [
            [
              [
                2193,
                9402
              ],
              [
                2257,
                9358
              ],
              [
                2217,
                9343
              ],
              [
                2219,
                9325
              ],
              [
                2146,
                9305
              ],
              [
                2140,
                9335
              ],
              [
                2100,
                9354
              ],
              [
                2084,
                9306
              ],
              [
                2121,
                9290
              ],
              [
                2130,
                9255
              ],
              [
                2106,
                9231
              ],
              [
                2049,
                9231
              ],
              [
                2036,
                9256
              ],
              [
                2024,
                9238
              ],
              [
                2059,
                9206
              ],
              [
                2053,
                9195
              ],
              [
                1991,
                9208
              ],
              [
                1924,
                9240
              ],
              [
                1902,
                9291
              ],
              [
                1846,
                9289
              ],
              [
                1788,
                9269
              ],
              [
                1792,
                9300
              ],
              [
                1821,
                9318
              ],
              [
                1875,
                9311
              ],
              [
                1923,
                9318
              ],
              [
                1912,
                9341
              ],
              [
                1989,
                9380
              ],
              [
                1992,
                9410
              ],
              [
                1911,
                9425
              ],
              [
                1918,
                9473
              ],
              [
                1861,
                9432
              ],
              [
                1882,
                9464
              ],
              [
                1847,
                9455
              ],
              [
                1718,
                9470
              ],
              [
                1681,
                9468
              ],
              [
                1657,
                9482
              ],
              [
                1662,
                9528
              ],
              [
                1719,
                9567
              ],
              [
                1766,
                9584
              ],
              [
                1835,
                9585
              ],
              [
                1768,
                9557
              ],
              [
                1752,
                9531
              ],
              [
                1827,
                9574
              ],
              [
                1913,
                9583
              ],
              [
                1918,
                9544
              ],
              [
                1937,
                9538
              ],
              [
                1980,
                9554
              ],
              [
                2030,
                9546
              ],
              [
                2062,
                9517
              ],
              [
                2095,
                9515
              ],
              [
                2108,
                9496
              ],
              [
                2153,
                9486
              ],
              [
                2164,
                9439
              ],
              [
                2114,
                9422
              ],
              [
                2193,
                9402
              ]
            ]
          ],
          [
            [
              [
                1252,
                9698
              ],
              [
                1227,
                9673
              ],
              [
                1150,
                9667
              ],
              [
                1134,
                9650
              ],
              [
                1103,
                9641
              ],
              [
                1049,
                9657
              ],
              [
                1190,
                9692
              ],
              [
                1252,
                9698
              ]
            ]
          ],
          [
            [
              [
                2230,
                8683
              ],
              [
                2216,
                8646
              ],
              [
                2196,
                8639
              ],
              [
                2196,
                8670
              ],
              [
                2126,
                8652
              ],
              [
                2140,
                8676
              ],
              [
                2034,
                8687
              ],
              [
                2062,
                8713
              ],
              [
                2154,
                8815
              ],
              [
                2195,
                8825
              ],
              [
                2183,
                8796
              ],
              [
                2157,
                8772
              ],
              [
                2155,
                8748
              ],
              [
                2199,
                8754
              ],
              [
                2226,
                8738
              ],
              [
                2206,
                8713
              ],
              [
                2233,
                8714
              ],
              [
                2198,
                8681
              ],
              [
                2230,
                8683
              ]
            ]
          ],
          [
            [
              [
                1644,
                9223
              ],
              [
                1586,
                9204
              ],
              [
                1605,
                9227
              ],
              [
                1593,
                9247
              ],
              [
                1560,
                9238
              ],
              [
                1565,
                9272
              ],
              [
                1610,
                9328
              ],
              [
                1631,
                9328
              ],
              [
                1643,
                9311
              ],
              [
                1715,
                9262
              ],
              [
                1686,
                9249
              ],
              [
                1635,
                9272
              ],
              [
                1609,
                9255
              ],
              [
                1618,
                9228
              ],
              [
                1644,
                9223
              ]
            ]
          ],
          [
            [
              [
                1377,
                9482
              ],
              [
                1325,
                9450
              ],
              [
                1313,
                9464
              ],
              [
                1272,
                9455
              ],
              [
                1306,
                9439
              ],
              [
                1249,
                9428
              ],
              [
                1187,
                9441
              ],
              [
                1109,
                9426
              ],
              [
                1001,
                9418
              ],
              [
                1008,
                9441
              ],
              [
                955,
                9445
              ],
              [
                959,
                9471
              ],
              [
                1069,
                9474
              ],
              [
                1051,
                9490
              ],
              [
                966,
                9485
              ],
              [
                955,
                9500
              ],
              [
                988,
                9511
              ],
              [
                961,
                9519
              ],
              [
                1047,
                9559
              ],
              [
                1129,
                9573
              ],
              [
                1185,
                9553
              ],
              [
                1221,
                9562
              ],
              [
                1247,
                9535
              ],
              [
                1299,
                9581
              ],
              [
                1325,
                9563
              ],
              [
                1327,
                9583
              ],
              [
                1371,
                9579
              ],
              [
                1321,
                9552
              ],
              [
                1294,
                9492
              ],
              [
                1335,
                9471
              ],
              [
                1377,
                9482
              ]
            ]
          ],
          [
            [
              [
                1464,
                9587
              ],
              [
                1530,
                9589
              ],
              [
                1536,
                9573
              ],
              [
                1505,
                9526
              ],
              [
                1437,
                9508
              ],
              [
                1418,
                9536
              ],
              [
                1386,
                9552
              ],
              [
                1464,
                9587
              ]
            ]
          ],
          [
            [
              [
                1597,
                9545
              ],
              [
                1543,
                9529
              ],
              [
                1553,
                9556
              ],
              [
                1590,
                9585
              ],
              [
                1652,
                9598
              ],
              [
                1715,
                9589
              ],
              [
                1646,
                9557
              ],
              [
                1589,
                9555
              ],
              [
                1597,
                9545
              ]
            ]
          ],
          [
            [
              [
                809,
                9529
              ],
              [
                929,
                9585
              ],
              [
                930,
                9603
              ],
              [
                1012,
                9609
              ],
              [
                1102,
                9595
              ],
              [
                1116,
                9576
              ],
              [
                1030,
                9558
              ],
              [
                956,
                9538
              ],
              [
                918,
                9515
              ],
              [
                844,
                9502
              ],
              [
                843,
                9521
              ],
              [
                809,
                9529
              ]
            ]
          ],
          [
            [
              [
                1516,
                9623
              ],
              [
                1549,
                9642
              ],
              [
                1480,
                9638
              ],
              [
                1462,
                9655
              ],
              [
                1484,
                9688
              ],
              [
                1507,
                9650
              ],
              [
                1570,
                9675
              ],
              [
                1627,
                9667
              ],
              [
                1569,
                9623
              ],
              [
                1516,
                9623
              ]
            ]
          ],
          [
            [
              [
                1427,
                9652
              ],
              [
                1388,
                9624
              ],
              [
                1327,
                9624
              ],
              [
                1203,
                9604
              ],
              [
                1180,
                9612
              ],
              [
                1282,
                9630
              ],
              [
                1163,
                9622
              ],
              [
                1131,
                9629
              ],
              [
                1253,
                9675
              ],
              [
                1285,
                9638
              ],
              [
                1335,
                9638
              ],
              [
                1335,
                9661
              ],
              [
                1392,
                9678
              ],
              [
                1367,
                9654
              ],
              [
                1427,
                9652
              ]
            ]
          ],
          [
            [
              [
                1772,
                9673
              ],
              [
                1809,
                9638
              ],
              [
                1919,
                9647
              ],
              [
                2001,
                9637
              ],
              [
                1992,
                9619
              ],
              [
                1925,
                9606
              ],
              [
                1889,
                9610
              ],
              [
                1740,
                9608
              ],
              [
                1699,
                9616
              ],
              [
                1731,
                9649
              ],
              [
                1724,
                9663
              ],
              [
                1669,
                9660
              ],
              [
                1662,
                9681
              ],
              [
                1772,
                9673
              ]
            ]
          ],
          [
            [
              [
                1996,
                9745
              ],
              [
                1873,
                9715
              ],
              [
                1800,
                9720
              ],
              [
                1786,
                9737
              ],
              [
                1838,
                9750
              ],
              [
                1776,
                9746
              ],
              [
                1770,
                9767
              ],
              [
                1803,
                9782
              ],
              [
                1910,
                9794
              ],
              [
                1960,
                9755
              ],
              [
                1996,
                9745
              ]
            ]
          ],
          [
            [
              [
                2015,
                9646
              ],
              [
                2002,
                9665
              ],
              [
                1899,
                9661
              ],
              [
                1795,
                9667
              ],
              [
                1816,
                9672
              ],
              [
                1808,
                9700
              ],
              [
                1843,
                9682
              ],
              [
                1891,
                9689
              ],
              [
                1882,
                9705
              ],
              [
                1946,
                9705
              ],
              [
                1905,
                9714
              ],
              [
                1946,
                9733
              ],
              [
                2000,
                9737
              ],
              [
                1994,
                9773
              ],
              [
                2049,
                9771
              ],
              [
                2180,
                9780
              ],
              [
                2153,
                9786
              ],
              [
                2088,
                9779
              ],
              [
                1998,
                9780
              ],
              [
                1946,
                9791
              ],
              [
                1948,
                9811
              ],
              [
                2125,
                9821
              ],
              [
                2199,
                9836
              ],
              [
                2325,
                9834
              ],
              [
                2355,
                9840
              ],
              [
                2510,
                9835
              ],
              [
                2563,
                9819
              ],
              [
                2388,
                9784
              ],
              [
                2304,
                9759
              ],
              [
                2210,
                9748
              ],
              [
                2203,
                9732
              ],
              [
                2085,
                9693
              ],
              [
                2028,
                9691
              ],
              [
                2081,
                9681
              ],
              [
                2015,
                9646
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CL",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.64,
        "hc-middle-y": 0.92,
        "hc-key": "cl",
        "hc-a2": "CL",
        "name": "Chile",
        "labelrank": "2",
        "country-abbrev": "Chile",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "CHL",
        "iso-a2": "CL",
        "woe-id": "23424782",
        "continent": "South America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                1534,
                5222
              ],
              [
                1544,
                5185
              ],
              [
                1521,
                5190
              ],
              [
                1515,
                5239
              ],
              [
                1534,
                5222
              ]
            ]
          ],
          [
            [
              [
                1539,
                5150
              ],
              [
                1551,
                5163
              ],
              [
                1564,
                5139
              ],
              [
                1568,
                5095
              ],
              [
                1539,
                5150
              ]
            ]
          ],
          [
            [
              [
                1560,
                5014
              ],
              [
                1571,
                5016
              ],
              [
                1614,
                4936
              ],
              [
                1597,
                4905
              ],
              [
                1597,
                4938
              ],
              [
                1575,
                4947
              ],
              [
                1557,
                4987
              ],
              [
                1560,
                5014
              ]
            ]
          ],
          [
            [
              [
                1826,
                4836
              ],
              [
                1860,
                4758
              ],
              [
                1857,
                4758
              ],
              [
                1860,
                4757
              ],
              [
                1861,
                4754
              ],
              [
                1852,
                4753
              ],
              [
                1913,
                4749
              ],
              [
                1909,
                4729
              ],
              [
                1837,
                4735
              ],
              [
                1828,
                4749
              ],
              [
                1828,
                4751
              ],
              [
                1811,
                4749
              ],
              [
                1748,
                4783
              ],
              [
                1787,
                4782
              ],
              [
                1780,
                4822
              ],
              [
                1800,
                4843
              ],
              [
                1826,
                4836
              ]
            ]
          ],
          [
            [
              [
                1455,
                6145
              ],
              [
                1469,
                6148
              ],
              [
                1481,
                6177
              ],
              [
                1504,
                6121
              ],
              [
                1524,
                6102
              ],
              [
                1517,
                6064
              ],
              [
                1539,
                6031
              ],
              [
                1556,
                5972
              ],
              [
                1579,
                5972
              ],
              [
                1580,
                5927
              ],
              [
                1542,
                5897
              ],
              [
                1563,
                5815
              ],
              [
                1547,
                5807
              ],
              [
                1521,
                5720
              ],
              [
                1520,
                5636
              ],
              [
                1550,
                5586
              ],
              [
                1567,
                5533
              ],
              [
                1558,
                5497
              ],
              [
                1566,
                5462
              ],
              [
                1549,
                5445
              ],
              [
                1557,
                5398
              ],
              [
                1577,
                5359
              ],
              [
                1562,
                5350
              ],
              [
                1566,
                5284
              ],
              [
                1589,
                5233
              ],
              [
                1588,
                5199
              ],
              [
                1615,
                5165
              ],
              [
                1613,
                5134
              ],
              [
                1643,
                5110
              ],
              [
                1634,
                5095
              ],
              [
                1650,
                5058
              ],
              [
                1641,
                5012
              ],
              [
                1654,
                4996
              ],
              [
                1634,
                4951
              ],
              [
                1664,
                4906
              ],
              [
                1688,
                4910
              ],
              [
                1698,
                4876
              ],
              [
                1720,
                4860
              ],
              [
                1778,
                4859
              ],
              [
                1827,
                4847
              ],
              [
                1805,
                4852
              ],
              [
                1767,
                4833
              ],
              [
                1775,
                4793
              ],
              [
                1702,
                4819
              ],
              [
                1612,
                4926
              ],
              [
                1619,
                4931
              ],
              [
                1600,
                4991
              ],
              [
                1573,
                5020
              ],
              [
                1587,
                5046
              ],
              [
                1547,
                5065
              ],
              [
                1563,
                5092
              ],
              [
                1585,
                5072
              ],
              [
                1576,
                5126
              ],
              [
                1590,
                5144
              ],
              [
                1568,
                5155
              ],
              [
                1565,
                5234
              ],
              [
                1544,
                5256
              ],
              [
                1522,
                5246
              ],
              [
                1507,
                5275
              ],
              [
                1511,
                5328
              ],
              [
                1478,
                5397
              ],
              [
                1489,
                5481
              ],
              [
                1498,
                5499
              ],
              [
                1500,
                5605
              ],
              [
                1476,
                5687
              ],
              [
                1470,
                5737
              ],
              [
                1481,
                5787
              ],
              [
                1483,
                5874
              ],
              [
                1468,
                5961
              ],
              [
                1478,
                6026
              ],
              [
                1455,
                6145
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CV",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.57,
        "hc-middle-y": 0.50,
        "hc-key": "cv",
        "hc-a2": "CV",
        "name": "Cape Verde",
        "labelrank": "4",
        "country-abbrev": "C.Vd.",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "CPV",
        "iso-a2": "CV",
        "woe-id": "23424794",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3013,
              7439
            ],
            [
              3020,
              7432
            ],
            [
              3021,
              7424
            ],
            [
              3011,
              7429
            ],
            [
              3013,
              7439
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "DM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.54,
        "hc-middle-y": 0.48,
        "hc-key": "dm",
        "hc-a2": "DM",
        "name": "Dominica",
        "labelrank": "6",
        "country-abbrev": "D'inca",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "DMA",
        "iso-a2": "DM",
        "woe-id": "23424798",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1747,
              7450
            ],
            [
              1751,
              7443
            ],
            [
              1747,
              7435
            ],
            [
              1744,
              7446
            ],
            [
              1747,
              7450
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SC",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.59,
        "hc-middle-y": 0.79,
        "hc-key": "sc",
        "hc-a2": "SC",
        "name": "Seychelles",
        "labelrank": "6",
        "country-abbrev": "Syc.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "SYC",
        "iso-a2": "SC",
        "woe-id": "23424941",
        "continent": "Seven seas (open ocean)"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5383,
              6491
            ],
            [
              5383,
              6487
            ],
            [
              5376,
              6486
            ],
            [
              5383,
              6489
            ],
            [
              5383,
              6491
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "JM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.47,
        "hc-key": "jm",
        "hc-a2": "JM",
        "name": "Jamaica",
        "labelrank": "4",
        "country-abbrev": "Jam.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "JAM",
        "iso-a2": "JM",
        "woe-id": "23424858",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1220,
              7561
            ],
            [
              1259,
              7539
            ],
            [
              1207,
              7537
            ],
            [
              1194,
              7560
            ],
            [
              1220,
              7561
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "OM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.82,
        "hc-middle-y": 0.44,
        "hc-key": "om",
        "hc-a2": "OM",
        "name": "Oman",
        "labelrank": "4",
        "country-abbrev": "Oman",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "OMN",
        "iso-a2": "OM",
        "woe-id": "23424898",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                5671,
                7821
              ],
              [
                5670,
                7820
              ],
              [
                5669,
                7824
              ],
              [
                5673,
                7823
              ],
              [
                5671,
                7821
              ]
            ]
          ],
          [
            [
              [
                5661,
                7853
              ],
              [
                5669,
                7865
              ],
              [
                5669,
                7836
              ],
              [
                5665,
                7838
              ],
              [
                5661,
                7853
              ]
            ]
          ],
          [
            [
              [
                5549,
                7581
              ],
              [
                5646,
                7619
              ],
              [
                5662,
                7696
              ],
              [
                5644,
                7724
              ],
              [
                5657,
                7808
              ],
              [
                5676,
                7811
              ],
              [
                5705,
                7772
              ],
              [
                5760,
                7756
              ],
              [
                5800,
                7706
              ],
              [
                5738,
                7609
              ],
              [
                5745,
                7582
              ],
              [
                5707,
                7566
              ],
              [
                5699,
                7540
              ],
              [
                5669,
                7536
              ],
              [
                5657,
                7505
              ],
              [
                5593,
                7490
              ],
              [
                5579,
                7516
              ],
              [
                5549,
                7581
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "VC",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.48,
        "hc-middle-y": 0.50,
        "hc-key": "vc",
        "hc-a2": "VC",
        "name": "Saint Vincent and the Grenadines",
        "labelrank": "6",
        "country-abbrev": "St.V.G.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "VCT",
        "iso-a2": "VC",
        "woe-id": "23424981",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1747,
              7352
            ],
            [
              1745,
              7359
            ],
            [
              1750,
              7365
            ],
            [
              1749,
              7357
            ],
            [
              1747,
              7352
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BD",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.41,
        "hc-middle-y": 0.74,
        "hc-key": "bd",
        "hc-a2": "BD",
        "name": "Bangladesh",
        "labelrank": "3",
        "country-abbrev": "Bang.",
        "subregion": "Southern Asia",
        "region-wb": "South Asia",
        "iso-a3": "BGD",
        "iso-a2": "BD",
        "woe-id": "23424759",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6885,
              7660
            ],
            [
              6849,
              7727
            ],
            [
              6816,
              7698
            ],
            [
              6774,
              7694
            ],
            [
              6774,
              7694
            ],
            [
              6775,
              7696
            ],
            [
              6773,
              7701
            ],
            [
              6747,
              7760
            ],
            [
              6750,
              7784
            ],
            [
              6724,
              7798
            ],
            [
              6750,
              7818
            ],
            [
              6717,
              7847
            ],
            [
              6726,
              7868
            ],
            [
              6775,
              7848
            ],
            [
              6798,
              7818
            ],
            [
              6853,
              7819
            ],
            [
              6870,
              7809
            ],
            [
              6834,
              7758
            ],
            [
              6852,
              7733
            ],
            [
              6866,
              7763
            ],
            [
              6891,
              7696
            ],
            [
              6897,
              7669
            ],
            [
              6885,
              7660
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SB",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.03,
        "hc-middle-y": 0.12,
        "hc-key": "sb",
        "hc-a2": "SB",
        "name": "Solomon Islands",
        "labelrank": "3",
        "country-abbrev": "S. Is.",
        "subregion": "Melanesia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "SLB",
        "iso-a2": "SB",
        "woe-id": "23424766",
        "continent": "Oceania"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                9197,
                6499
              ],
              [
                9214,
                6492
              ],
              [
                9263,
                6520
              ],
              [
                9278,
                6480
              ],
              [
                9240,
                6497
              ],
              [
                9246,
                6468
              ],
              [
                9219,
                6473
              ],
              [
                9197,
                6499
              ]
            ]
          ],
          [
            [
              [
                9094,
                6577
              ],
              [
                9117,
                6596
              ],
              [
                9159,
                6563
              ],
              [
                9125,
                6553
              ],
              [
                9147,
                6544
              ],
              [
                9169,
                6511
              ],
              [
                9114,
                6539
              ],
              [
                9094,
                6577
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LC",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.48,
        "hc-key": "lc",
        "hc-a2": "LC",
        "name": "Saint Lucia",
        "labelrank": "6",
        "country-abbrev": "S.L.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "LCA",
        "iso-a2": "LC",
        "woe-id": "23424951",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1757,
              7378
            ],
            [
              1753,
              7384
            ],
            [
              1759,
              7393
            ],
            [
              1760,
              7387
            ],
            [
              1757,
              7378
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "NO",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.11,
        "hc-middle-y": 0.83,
        "hc-key": "no",
        "hc-a2": "NO",
        "name": "Norway",
        "labelrank": "3",
        "country-abbrev": "Nor.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "NOR",
        "iso-a2": "NO",
        "woe-id": "-90",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4269,
                9716
              ],
              [
                4298,
                9716
              ],
              [
                4346,
                9705
              ],
              [
                4271,
                9695
              ],
              [
                4269,
                9716
              ]
            ]
          ],
          [
            [
              [
                4566,
                9461
              ],
              [
                4548,
                9447
              ],
              [
                4526,
                9436
              ],
              [
                4526,
                9456
              ],
              [
                4493,
                9469
              ],
              [
                4449,
                9457
              ],
              [
                4429,
                9420
              ],
              [
                4367,
                9426
              ],
              [
                4344,
                9444
              ],
              [
                4320,
                9436
              ],
              [
                4308,
                9414
              ],
              [
                4262,
                9420
              ],
              [
                4217,
                9383
              ],
              [
                4225,
                9370
              ],
              [
                4182,
                9340
              ],
              [
                4185,
                9313
              ],
              [
                4165,
                9288
              ],
              [
                4175,
                9268
              ],
              [
                4142,
                9267
              ],
              [
                4126,
                9244
              ],
              [
                4150,
                9133
              ],
              [
                4124,
                9094
              ],
              [
                4100,
                9109
              ],
              [
                4046,
                9068
              ],
              [
                3991,
                9063
              ],
              [
                3961,
                9085
              ],
              [
                3945,
                9140
              ],
              [
                3956,
                9185
              ],
              [
                3939,
                9194
              ],
              [
                3998,
                9233
              ],
              [
                4051,
                9251
              ],
              [
                4085,
                9283
              ],
              [
                4117,
                9295
              ],
              [
                4125,
                9336
              ],
              [
                4197,
                9406
              ],
              [
                4215,
                9416
              ],
              [
                4137,
                9406
              ],
              [
                4194,
                9431
              ],
              [
                4221,
                9434
              ],
              [
                4219,
                9418
              ],
              [
                4243,
                9431
              ],
              [
                4267,
                9471
              ],
              [
                4357,
                9477
              ],
              [
                4353,
                9490
              ],
              [
                4396,
                9484
              ],
              [
                4433,
                9504
              ],
              [
                4425,
                9470
              ],
              [
                4455,
                9498
              ],
              [
                4500,
                9498
              ],
              [
                4567,
                9476
              ],
              [
                4566,
                9461
              ]
            ]
          ],
          [
            [
              [
                4038,
                9736
              ],
              [
                4038,
                9758
              ],
              [
                4106,
                9753
              ],
              [
                4119,
                9760
              ],
              [
                4165,
                9736
              ],
              [
                4155,
                9766
              ],
              [
                4241,
                9739
              ],
              [
                4274,
                9734
              ],
              [
                4223,
                9723
              ],
              [
                4187,
                9669
              ],
              [
                4131,
                9687
              ],
              [
                4107,
                9712
              ],
              [
                4038,
                9736
              ]
            ]
          ],
          [
            [
              [
                4364,
                9752
              ],
              [
                4232,
                9747
              ],
              [
                4209,
                9758
              ],
              [
                4239,
                9782
              ],
              [
                4283,
                9765
              ],
              [
                4375,
                9769
              ],
              [
                4384,
                9733
              ],
              [
                4364,
                9752
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.59,
        "hc-middle-y": 0.50,
        "hc-key": "kn",
        "hc-a2": "KN",
        "name": "Saint Kitts and Nevis",
        "labelrank": "6",
        "country-abbrev": "St.K.N.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "KNA",
        "iso-a2": "KN",
        "woe-id": "23424940",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1712,
              7512
            ],
            [
              1704,
              7518
            ],
            [
              1705,
              7520
            ],
            [
              1709,
              7517
            ],
            [
              1712,
              7512
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BH",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.56,
        "hc-middle-y": 0.50,
        "hc-key": "bh",
        "hc-a2": "BH",
        "name": "Bahrain",
        "labelrank": "4",
        "country-abbrev": "Bahr.",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "BHR",
        "iso-a2": "BH",
        "woe-id": "23424753",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5476,
              7860
            ],
            [
              5480,
              7858
            ],
            [
              5480,
              7842
            ],
            [
              5476,
              7850
            ],
            [
              5476,
              7860
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "ID",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.38,
        "hc-middle-y": 0.40,
        "hc-key": "id",
        "hc-a2": "ID",
        "name": "Indonesia",
        "labelrank": "2",
        "country-abbrev": "Indo.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "IDN",
        "iso-a2": "ID",
        "woe-id": "23424846",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                7873,
                6490
              ],
              [
                7898,
                6462
              ],
              [
                7885,
                6453
              ],
              [
                7848,
                6490
              ],
              [
                7873,
                6490
              ]
            ]
          ],
          [
            [
              [
                8513,
                6536
              ],
              [
                8473,
                6526
              ],
              [
                8488,
                6556
              ],
              [
                8516,
                6566
              ],
              [
                8513,
                6536
              ]
            ]
          ],
          [
            [
              [
                7969,
                6641
              ],
              [
                7965,
                6668
              ],
              [
                7987,
                6681
              ],
              [
                7978,
                6631
              ],
              [
                7969,
                6641
              ]
            ]
          ],
          [
            [
              [
                8009,
                6792
              ],
              [
                8104,
                6780
              ],
              [
                8087,
                6770
              ],
              [
                8019,
                6771
              ],
              [
                8009,
                6792
              ]
            ]
          ],
          [
            [
              [
                7462,
                6742
              ],
              [
                7429,
                6731
              ],
              [
                7411,
                6742
              ],
              [
                7391,
                6787
              ],
              [
                7414,
                6789
              ],
              [
                7432,
                6738
              ],
              [
                7462,
                6742
              ]
            ]
          ],
          [
            [
              [
                8327,
                6635
              ],
              [
                8369,
                6630
              ],
              [
                8382,
                6616
              ],
              [
                8360,
                6584
              ],
              [
                8362,
                6619
              ],
              [
                8327,
                6635
              ]
            ]
          ],
          [
            [
              [
                7793,
                6528
              ],
              [
                7842,
                6530
              ],
              [
                7822,
                6509
              ],
              [
                7772,
                6500
              ],
              [
                7733,
                6511
              ],
              [
                7754,
                6535
              ],
              [
                7793,
                6528
              ]
            ]
          ],
          [
            [
              [
                8024,
                6497
              ],
              [
                8028,
                6497
              ],
              [
                8040,
                6505
              ],
              [
                8041,
                6496
              ],
              [
                8044,
                6485
              ],
              [
                8021,
                6460
              ],
              [
                7985,
                6453
              ],
              [
                8009,
                6491
              ],
              [
                8016,
                6485
              ],
              [
                8024,
                6497
              ]
            ]
          ],
          [
            [
              [
                7814,
                7010
              ],
              [
                7804,
                7006
              ],
              [
                7807,
                7010
              ],
              [
                7814,
                7010
              ]
            ]
          ],
          [
            [
              [
                8600,
                6750
              ],
              [
                8592,
                6606
              ],
              [
                8584,
                6500
              ],
              [
                8552,
                6538
              ],
              [
                8517,
                6531
              ],
              [
                8525,
                6559
              ],
              [
                8487,
                6648
              ],
              [
                8426,
                6677
              ],
              [
                8402,
                6678
              ],
              [
                8350,
                6716
              ],
              [
                8324,
                6693
              ],
              [
                8320,
                6742
              ],
              [
                8335,
                6757
              ],
              [
                8298,
                6769
              ],
              [
                8290,
                6788
              ],
              [
                8244,
                6816
              ],
              [
                8321,
                6836
              ],
              [
                8364,
                6822
              ],
              [
                8368,
                6768
              ],
              [
                8395,
                6722
              ],
              [
                8427,
                6735
              ],
              [
                8445,
                6764
              ],
              [
                8472,
                6769
              ],
              [
                8495,
                6793
              ],
              [
                8563,
                6759
              ],
              [
                8600,
                6750
              ]
            ]
          ],
          [
            [
              [
                7414,
                6725
              ],
              [
                7402,
                6633
              ],
              [
                7363,
                6622
              ],
              [
                7262,
                6726
              ],
              [
                7237,
                6767
              ],
              [
                7220,
                6819
              ],
              [
                7187,
                6859
              ],
              [
                7155,
                6850
              ],
              [
                7184,
                6782
              ],
              [
                7171,
                6785
              ],
              [
                7152,
                6850
              ],
              [
                7180,
                6860
              ],
              [
                7159,
                6925
              ],
              [
                7118,
                6928
              ],
              [
                7139,
                6888
              ],
              [
                7132,
                6872
              ],
              [
                7109,
                6905
              ],
              [
                7126,
                6960
              ],
              [
                7050,
                7036
              ],
              [
                7049,
                7068
              ],
              [
                7083,
                7051
              ],
              [
                7119,
                7052
              ],
              [
                7147,
                7011
              ],
              [
                7199,
                6972
              ],
              [
                7241,
                6923
              ],
              [
                7286,
                6896
              ],
              [
                7348,
                6888
              ],
              [
                7324,
                6871
              ],
              [
                7339,
                6850
              ],
              [
                7324,
                6822
              ],
              [
                7358,
                6810
              ],
              [
                7374,
                6762
              ],
              [
                7400,
                6757
              ],
              [
                7414,
                6725
              ]
            ]
          ],
          [
            [
              [
                8013,
                6521
              ],
              [
                7871,
                6509
              ],
              [
                7883,
                6531
              ],
              [
                7952,
                6518
              ],
              [
                7976,
                6534
              ],
              [
                8049,
                6536
              ],
              [
                8080,
                6555
              ],
              [
                8132,
                6560
              ],
              [
                8168,
                6576
              ],
              [
                8152,
                6536
              ],
              [
                8128,
                6556
              ],
              [
                8082,
                6547
              ],
              [
                8013,
                6521
              ]
            ]
          ],
          [
            [
              [
                7650,
                6530
              ],
              [
                7594,
                6528
              ],
              [
                7517,
                6553
              ],
              [
                7482,
                6549
              ],
              [
                7421,
                6565
              ],
              [
                7388,
                6588
              ],
              [
                7409,
                6624
              ],
              [
                7486,
                6610
              ],
              [
                7493,
                6590
              ],
              [
                7557,
                6583
              ],
              [
                7566,
                6602
              ],
              [
                7623,
                6586
              ],
              [
                7631,
                6625
              ],
              [
                7635,
                6575
              ],
              [
                7651,
                6551
              ],
              [
                7675,
                6557
              ],
              [
                7688,
                6539
              ],
              [
                7730,
                6529
              ],
              [
                7725,
                6511
              ],
              [
                7691,
                6512
              ],
              [
                7650,
                6530
              ]
            ]
          ],
          [
            [
              [
                8188,
                6727
              ],
              [
                8155,
                6705
              ],
              [
                8132,
                6711
              ],
              [
                8115,
                6702
              ],
              [
                8091,
                6728
              ],
              [
                8141,
                6722
              ],
              [
                8158,
                6738
              ],
              [
                8211,
                6743
              ],
              [
                8246,
                6730
              ],
              [
                8254,
                6708
              ],
              [
                8188,
                6727
              ]
            ]
          ],
          [
            [
              [
                7935,
                6671
              ],
              [
                7941,
                6693
              ],
              [
                7917,
                6714
              ],
              [
                7924,
                6744
              ],
              [
                7901,
                6725
              ],
              [
                7896,
                6644
              ],
              [
                7861,
                6642
              ],
              [
                7872,
                6684
              ],
              [
                7847,
                6749
              ],
              [
                7866,
                6775
              ],
              [
                7891,
                6878
              ],
              [
                7920,
                6902
              ],
              [
                7944,
                6891
              ],
              [
                8023,
                6882
              ],
              [
                8063,
                6919
              ],
              [
                8068,
                6904
              ],
              [
                8036,
                6865
              ],
              [
                7902,
                6868
              ],
              [
                7889,
                6841
              ],
              [
                7912,
                6796
              ],
              [
                7926,
                6796
              ],
              [
                7946,
                6832
              ],
              [
                7964,
                6821
              ],
              [
                8005,
                6825
              ],
              [
                7941,
                6776
              ],
              [
                7971,
                6729
              ],
              [
                7981,
                6679
              ],
              [
                7935,
                6671
              ]
            ]
          ],
          [
            [
              [
                8172,
                6876
              ],
              [
                8208,
                6847
              ],
              [
                8160,
                6868
              ],
              [
                8145,
                6805
              ],
              [
                8150,
                6841
              ],
              [
                8140,
                6897
              ],
              [
                8179,
                6951
              ],
              [
                8155,
                6881
              ],
              [
                8175,
                6909
              ],
              [
                8172,
                6876
              ]
            ]
          ],
          [
            [
              [
                7803,
                7010
              ],
              [
                7797,
                6977
              ],
              [
                7823,
                6938
              ],
              [
                7816,
                6923
              ],
              [
                7855,
                6890
              ],
              [
                7812,
                6879
              ],
              [
                7802,
                6830
              ],
              [
                7771,
                6793
              ],
              [
                7765,
                6719
              ],
              [
                7703,
                6690
              ],
              [
                7691,
                6721
              ],
              [
                7650,
                6728
              ],
              [
                7608,
                6714
              ],
              [
                7606,
                6743
              ],
              [
                7556,
                6735
              ],
              [
                7547,
                6807
              ],
              [
                7513,
                6787
              ],
              [
                7535,
                6816
              ],
              [
                7520,
                6830
              ],
              [
                7510,
                6881
              ],
              [
                7536,
                6930
              ],
              [
                7537,
                6912
              ],
              [
                7568,
                6883
              ],
              [
                7620,
                6894
              ],
              [
                7650,
                6910
              ],
              [
                7672,
                6897
              ],
              [
                7702,
                6905
              ],
              [
                7733,
                6967
              ],
              [
                7744,
                7019
              ],
              [
                7803,
                7010
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MU",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.60,
        "hc-middle-y": 0.58,
        "hc-key": "mu",
        "hc-a2": "MU",
        "name": "Mauritius",
        "labelrank": "5",
        "country-abbrev": "Mus.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "MUS",
        "iso-a2": "MU",
        "woe-id": "23424894",
        "continent": "Seven seas (open ocean)"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5737,
              6077
            ],
            [
              5735,
              6062
            ],
            [
              5725,
              6061
            ],
            [
              5731,
              6080
            ],
            [
              5737,
              6077
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "RU",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.86,
        "hc-middle-y": 0.46,
        "hc-key": "ru",
        "hc-a2": "RU",
        "name": "Russia",
        "labelrank": "2",
        "country-abbrev": "Rus.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "RUS",
        "iso-a2": "RU",
        "woe-id": "23424936",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                8380,
                8648
              ],
              [
                8352,
                8601
              ],
              [
                8302,
                8582
              ],
              [
                8346,
                8610
              ],
              [
                8380,
                8648
              ]
            ]
          ],
          [
            [
              [
                5001,
                9807
              ],
              [
                4991,
                9794
              ],
              [
                5040,
                9785
              ],
              [
                4937,
                9769
              ],
              [
                4944,
                9793
              ],
              [
                5001,
                9807
              ]
            ]
          ],
          [
            [
              [
                7077,
                9590
              ],
              [
                7160,
                9578
              ],
              [
                7171,
                9567
              ],
              [
                7095,
                9577
              ],
              [
                7077,
                9590
              ]
            ]
          ],
          [
            [
              [
                5090,
                9804
              ],
              [
                5082,
                9786
              ],
              [
                5172,
                9788
              ],
              [
                5041,
                9769
              ],
              [
                5090,
                9804
              ]
            ]
          ],
          [
            [
              [
                6066,
                9734
              ],
              [
                6086,
                9720
              ],
              [
                5977,
                9712
              ],
              [
                5978,
                9745
              ],
              [
                6066,
                9734
              ]
            ]
          ],
          [
            [
              [
                4815,
                9782
              ],
              [
                4891,
                9783
              ],
              [
                4831,
                9767
              ],
              [
                4791,
                9772
              ],
              [
                4815,
                9782
              ]
            ]
          ],
          [
            [
              [
                7844,
                8484
              ],
              [
                7832,
                8540
              ],
              [
                7803,
                8569
              ],
              [
                7826,
                8587
              ],
              [
                7854,
                8558
              ],
              [
                7855,
                8581
              ],
              [
                7858,
                8626
              ],
              [
                7847,
                8681
              ],
              [
                7819,
                8706
              ],
              [
                7781,
                8680
              ],
              [
                7737,
                8679
              ],
              [
                7715,
                8702
              ],
              [
                7642,
                8745
              ],
              [
                7600,
                8749
              ],
              [
                7527,
                8806
              ],
              [
                7485,
                8846
              ],
              [
                7438,
                8877
              ],
              [
                7350,
                8898
              ],
              [
                7289,
                8887
              ],
              [
                7280,
                8869
              ],
              [
                7319,
                8845
              ],
              [
                7317,
                8780
              ],
              [
                7296,
                8748
              ],
              [
                7257,
                8760
              ],
              [
                7175,
                8777
              ],
              [
                7155,
                8751
              ],
              [
                7097,
                8734
              ],
              [
                7027,
                8741
              ],
              [
                6997,
                8764
              ],
              [
                6907,
                8784
              ],
              [
                6866,
                8771
              ],
              [
                6814,
                8789
              ],
              [
                6797,
                8815
              ],
              [
                6683,
                8845
              ],
              [
                6675,
                8804
              ],
              [
                6700,
                8786
              ],
              [
                6688,
                8756
              ],
              [
                6601,
                8767
              ],
              [
                6580,
                8787
              ],
              [
                6518,
                8799
              ],
              [
                6416,
                8735
              ],
              [
                6408,
                8733
              ],
              [
                6403,
                8732
              ],
              [
                6372,
                8751
              ],
              [
                6333,
                8751
              ],
              [
                6255,
                8803
              ],
              [
                6201,
                8793
              ],
              [
                6169,
                8815
              ],
              [
                6156,
                8796
              ],
              [
                6052,
                8887
              ],
              [
                6001,
                8912
              ],
              [
                5997,
                8930
              ],
              [
                5942,
                8899
              ],
              [
                5915,
                8912
              ],
              [
                5846,
                8918
              ],
              [
                5816,
                8961
              ],
              [
                5745,
                8957
              ],
              [
                5746,
                8949
              ],
              [
                5672,
                8926
              ],
              [
                5557,
                8910
              ],
              [
                5599,
                8882
              ],
              [
                5566,
                8865
              ],
              [
                5561,
                8836
              ],
              [
                5606,
                8819
              ],
              [
                5611,
                8795
              ],
              [
                5568,
                8786
              ],
              [
                5527,
                8804
              ],
              [
                5465,
                8806
              ],
              [
                5447,
                8786
              ],
              [
                5368,
                8822
              ],
              [
                5285,
                8827
              ],
              [
                5241,
                8788
              ],
              [
                5241,
                8759
              ],
              [
                5209,
                8783
              ],
              [
                5196,
                8760
              ],
              [
                5197,
                8707
              ],
              [
                5222,
                8684
              ],
              [
                5250,
                8683
              ],
              [
                5298,
                8628
              ],
              [
                5255,
                8605
              ],
              [
                5237,
                8563
              ],
              [
                5272,
                8530
              ],
              [
                5274,
                8502
              ],
              [
                5318,
                8458
              ],
              [
                5297,
                8434
              ],
              [
                5251,
                8460
              ],
              [
                5195,
                8491
              ],
              [
                5169,
                8484
              ],
              [
                5130,
                8507
              ],
              [
                5041,
                8516
              ],
              [
                5004,
                8544
              ],
              [
                4924,
                8586
              ],
              [
                4951,
                8592
              ],
              [
                4953,
                8634
              ],
              [
                4993,
                8654
              ],
              [
                4960,
                8657
              ],
              [
                4973,
                8686
              ],
              [
                5001,
                8685
              ],
              [
                4996,
                8747
              ],
              [
                4912,
                8782
              ],
              [
                4861,
                8779
              ],
              [
                4837,
                8811
              ],
              [
                4810,
                8813
              ],
              [
                4791,
                8854
              ],
              [
                4734,
                8844
              ],
              [
                4712,
                8878
              ],
              [
                4752,
                8893
              ],
              [
                4721,
                8906
              ],
              [
                4683,
                8972
              ],
              [
                4602,
                8992
              ],
              [
                4583,
                9017
              ],
              [
                4571,
                9041
              ],
              [
                4573,
                9051
              ],
              [
                4575,
                9058
              ],
              [
                4590,
                9053
              ],
              [
                4570,
                9094
              ],
              [
                4573,
                9100
              ],
              [
                4575,
                9104
              ],
              [
                4578,
                9105
              ],
              [
                4578,
                9105
              ],
              [
                4576,
                9106
              ],
              [
                4576,
                9106
              ],
              [
                4578,
                9105
              ],
              [
                4581,
                9107
              ],
              [
                4578,
                9109
              ],
              [
                4575,
                9111
              ],
              [
                4620,
                9135
              ],
              [
                4562,
                9149
              ],
              [
                4639,
                9217
              ],
              [
                4644,
                9231
              ],
              [
                4595,
                9259
              ],
              [
                4608,
                9269
              ],
              [
                4575,
                9302
              ],
              [
                4574,
                9339
              ],
              [
                4547,
                9364
              ],
              [
                4564,
                9392
              ],
              [
                4526,
                9409
              ],
              [
                4526,
                9436
              ],
              [
                4548,
                9447
              ],
              [
                4566,
                9461
              ],
              [
                4698,
                9441
              ],
              [
                4840,
                9392
              ],
              [
                4854,
                9363
              ],
              [
                4795,
                9338
              ],
              [
                4631,
                9365
              ],
              [
                4693,
                9339
              ],
              [
                4717,
                9293
              ],
              [
                4765,
                9308
              ],
              [
                4838,
                9287
              ],
              [
                4857,
                9296
              ],
              [
                4833,
                9323
              ],
              [
                4882,
                9353
              ],
              [
                4941,
                9331
              ],
              [
                4939,
                9358
              ],
              [
                4916,
                9375
              ],
              [
                4914,
                9411
              ],
              [
                4886,
                9422
              ],
              [
                4954,
                9417
              ],
              [
                4981,
                9397
              ],
              [
                4943,
                9380
              ],
              [
                4970,
                9366
              ],
              [
                5017,
                9369
              ],
              [
                5034,
                9393
              ],
              [
                5001,
                9443
              ],
              [
                5047,
                9443
              ],
              [
                5063,
                9408
              ],
              [
                5154,
                9435
              ],
              [
                5137,
                9411
              ],
              [
                5175,
                9408
              ],
              [
                5200,
                9424
              ],
              [
                5235,
                9421
              ],
              [
                5266,
                9435
              ],
              [
                5297,
                9413
              ],
              [
                5314,
                9439
              ],
              [
                5240,
                9470
              ],
              [
                5244,
                9483
              ],
              [
                5288,
                9466
              ],
              [
                5386,
                9453
              ],
              [
                5469,
                9431
              ],
              [
                5514,
                9408
              ],
              [
                5522,
                9434
              ],
              [
                5458,
                9448
              ],
              [
                5441,
                9491
              ],
              [
                5420,
                9508
              ],
              [
                5446,
                9525
              ],
              [
                5448,
                9574
              ],
              [
                5476,
                9576
              ],
              [
                5531,
                9553
              ],
              [
                5533,
                9516
              ],
              [
                5561,
                9503
              ],
              [
                5606,
                9433
              ],
              [
                5641,
                9419
              ],
              [
                5627,
                9358
              ],
              [
                5565,
                9356
              ],
              [
                5648,
                9344
              ],
              [
                5685,
                9392
              ],
              [
                5657,
                9425
              ],
              [
                5698,
                9435
              ],
              [
                5758,
                9410
              ],
              [
                5732,
                9432
              ],
              [
                5671,
                9443
              ],
              [
                5637,
                9438
              ],
              [
                5612,
                9459
              ],
              [
                5615,
                9484
              ],
              [
                5564,
                9513
              ],
              [
                5594,
                9534
              ],
              [
                5571,
                9559
              ],
              [
                5605,
                9576
              ],
              [
                5668,
                9648
              ],
              [
                5718,
                9596
              ],
              [
                5760,
                9593
              ],
              [
                5761,
                9607
              ],
              [
                5837,
                9636
              ],
              [
                5924,
                9648
              ],
              [
                5949,
                9686
              ],
              [
                5975,
                9651
              ],
              [
                6065,
                9668
              ],
              [
                6053,
                9685
              ],
              [
                6109,
                9702
              ],
              [
                6216,
                9674
              ],
              [
                6345,
                9665
              ],
              [
                6399,
                9631
              ],
              [
                6307,
                9568
              ],
              [
                6396,
                9583
              ],
              [
                6391,
                9609
              ],
              [
                6423,
                9607
              ],
              [
                6456,
                9575
              ],
              [
                6500,
                9583
              ],
              [
                6576,
                9580
              ],
              [
                6604,
                9565
              ],
              [
                6712,
                9559
              ],
              [
                6700,
                9590
              ],
              [
                6733,
                9579
              ],
              [
                6804,
                9577
              ],
              [
                6855,
                9563
              ],
              [
                6881,
                9533
              ],
              [
                6953,
                9498
              ],
              [
                6987,
                9491
              ],
              [
                6974,
                9527
              ],
              [
                7019,
                9513
              ],
              [
                7067,
                9519
              ],
              [
                7170,
                9514
              ],
              [
                7115,
                9546
              ],
              [
                7151,
                9555
              ],
              [
                7252,
                9548
              ],
              [
                7302,
                9525
              ],
              [
                7304,
                9541
              ],
              [
                7510,
                9494
              ],
              [
                7569,
                9502
              ],
              [
                7700,
                9493
              ],
              [
                7715,
                9464
              ],
              [
                7770,
                9450
              ],
              [
                7825,
                9457
              ],
              [
                7912,
                9451
              ],
              [
                7919,
                9468
              ],
              [
                7958,
                9443
              ],
              [
                8013,
                9428
              ],
              [
                8033,
                9437
              ],
              [
                7975,
                9458
              ],
              [
                7972,
                9471
              ],
              [
                8056,
                9461
              ],
              [
                8118,
                9464
              ],
              [
                8126,
                9516
              ],
              [
                8134,
                9459
              ],
              [
                8260,
                9434
              ],
              [
                8455,
                9304
              ],
              [
                8429,
                9291
              ],
              [
                8372,
                9297
              ],
              [
                8445,
                9275
              ],
              [
                8559,
                9224
              ],
              [
                8557,
                9212
              ],
              [
                8504,
                9219
              ],
              [
                8450,
                9184
              ],
              [
                8422,
                9145
              ],
              [
                8352,
                9150
              ],
              [
                8327,
                9123
              ],
              [
                8306,
                9146
              ],
              [
                8294,
                9122
              ],
              [
                8250,
                9131
              ],
              [
                8280,
                9097
              ],
              [
                8309,
                9102
              ],
              [
                8311,
                9057
              ],
              [
                8338,
                9048
              ],
              [
                8361,
                9014
              ],
              [
                8401,
                8993
              ],
              [
                8368,
                8991
              ],
              [
                8418,
                8945
              ],
              [
                8384,
                8920
              ],
              [
                8406,
                8887
              ],
              [
                8391,
                8874
              ],
              [
                8413,
                8839
              ],
              [
                8400,
                8773
              ],
              [
                8380,
                8777
              ],
              [
                8402,
                8803
              ],
              [
                8231,
                8946
              ],
              [
                8173,
                9014
              ],
              [
                8172,
                9051
              ],
              [
                8191,
                9073
              ],
              [
                8189,
                9144
              ],
              [
                8206,
                9177
              ],
              [
                8164,
                9223
              ],
              [
                8135,
                9217
              ],
              [
                8158,
                9192
              ],
              [
                8134,
                9150
              ],
              [
                8082,
                9197
              ],
              [
                8012,
                9192
              ],
              [
                8002,
                9142
              ],
              [
                8012,
                9112
              ],
              [
                7963,
                9089
              ],
              [
                7929,
                9110
              ],
              [
                7881,
                9121
              ],
              [
                7849,
                9108
              ],
              [
                7738,
                9109
              ],
              [
                7704,
                9098
              ],
              [
                7701,
                9053
              ],
              [
                7680,
                9022
              ],
              [
                7682,
                8991
              ],
              [
                7652,
                8946
              ],
              [
                7709,
                8935
              ],
              [
                7770,
                8899
              ],
              [
                7771,
                8925
              ],
              [
                7802,
                8924
              ],
              [
                7880,
                8888
              ],
              [
                7938,
                8786
              ],
              [
                7958,
                8768
              ],
              [
                7989,
                8709
              ],
              [
                7980,
                8683
              ],
              [
                7986,
                8625
              ],
              [
                7966,
                8529
              ],
              [
                7922,
                8489
              ],
              [
                7865,
                8514
              ],
              [
                7855,
                8475
              ],
              [
                7851,
                8479
              ],
              [
                7844,
                8484
              ]
            ]
          ],
          [
            [
              [
                4374,
                8930
              ],
              [
                4392,
                8939
              ],
              [
                4370,
                8930
              ],
              [
                4370,
                8931
              ],
              [
                4377,
                8946
              ],
              [
                4403,
                8961
              ],
              [
                4405,
                8960
              ],
              [
                4410,
                8947
              ],
              [
                4413,
                8959
              ],
              [
                4459,
                8946
              ],
              [
                4461,
                8927
              ],
              [
                4459,
                8926
              ],
              [
                4374,
                8930
              ]
            ]
          ],
          [
            [
              [
                5811,
                9765
              ],
              [
                5792,
                9763
              ],
              [
                5739,
                9761
              ],
              [
                5708,
                9794
              ],
              [
                5739,
                9787
              ],
              [
                5790,
                9797
              ],
              [
                5855,
                9783
              ],
              [
                5855,
                9771
              ],
              [
                5825,
                9767
              ],
              [
                5920,
                9763
              ],
              [
                5938,
                9745
              ],
              [
                5917,
                9733
              ],
              [
                5851,
                9739
              ],
              [
                5805,
                9753
              ],
              [
                5811,
                9765
              ]
            ]
          ],
          [
            [
              [
                5146,
                9652
              ],
              [
                5249,
                9662
              ],
              [
                5298,
                9680
              ],
              [
                5351,
                9669
              ],
              [
                5322,
                9656
              ],
              [
                5199,
                9627
              ],
              [
                5126,
                9540
              ],
              [
                5161,
                9507
              ],
              [
                5206,
                9490
              ],
              [
                5149,
                9485
              ],
              [
                5099,
                9495
              ],
              [
                5082,
                9511
              ],
              [
                5040,
                9523
              ],
              [
                5048,
                9553
              ],
              [
                5081,
                9570
              ],
              [
                5060,
                9585
              ],
              [
                5108,
                9607
              ],
              [
                5088,
                9612
              ],
              [
                5146,
                9652
              ]
            ]
          ],
          [
            [
              [
                8031,
                8720
              ],
              [
                7972,
                8809
              ],
              [
                7937,
                8831
              ],
              [
                7888,
                8891
              ],
              [
                7907,
                8903
              ],
              [
                7939,
                8883
              ],
              [
                7976,
                8836
              ],
              [
                8089,
                8738
              ],
              [
                8055,
                8743
              ],
              [
                8084,
                8678
              ],
              [
                8138,
                8636
              ],
              [
                8089,
                8639
              ],
              [
                8063,
                8690
              ],
              [
                8031,
                8720
              ]
            ]
          ],
          [
            [
              [
                -833,
                9304
              ],
              [
                -637,
                9434
              ],
              [
                -590,
                9383
              ],
              [
                -632,
                9345
              ],
              [
                -589,
                9368
              ],
              [
                -531,
                9368
              ],
              [
                -524,
                9336
              ],
              [
                -609,
                9318
              ],
              [
                -646,
                9296
              ],
              [
                -699,
                9278
              ],
              [
                -730,
                9302
              ],
              [
                -712,
                9317
              ],
              [
                -773,
                9320
              ],
              [
                -759,
                9337
              ],
              [
                -833,
                9304
              ]
            ]
          ],
          [
            [
              [
                7141,
                9630
              ],
              [
                7124,
                9671
              ],
              [
                7142,
                9671
              ],
              [
                7144,
                9636
              ],
              [
                7256,
                9627
              ],
              [
                7211,
                9617
              ],
              [
                7141,
                9630
              ]
            ]
          ],
          [
            [
              [
                7102,
                9621
              ],
              [
                7014,
                9613
              ],
              [
                6903,
                9636
              ],
              [
                6931,
                9659
              ],
              [
                6999,
                9645
              ],
              [
                6987,
                9658
              ],
              [
                7112,
                9638
              ],
              [
                7102,
                9621
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TT",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.43,
        "hc-key": "tt",
        "hc-a2": "TT",
        "name": "Trinidad and Tobago",
        "labelrank": "5",
        "country-abbrev": "Tr.T.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "TTO",
        "iso-a2": "TT",
        "woe-id": "23424958",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1752,
              7267
            ],
            [
              1748,
              7240
            ],
            [
              1732,
              7246
            ],
            [
              1726,
              7262
            ],
            [
              1752,
              7267
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.57,
        "hc-middle-y": 0.36,
        "hc-key": "br",
        "hc-a2": "BR",
        "name": "Brazil",
        "labelrank": "2",
        "country-abbrev": "Brazil",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "BRA",
        "iso-a2": "BR",
        "woe-id": "23424768",
        "continent": "South America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                2080,
                6822
              ],
              [
                2100,
                6846
              ],
              [
                2167,
                6839
              ],
              [
                2152,
                6795
              ],
              [
                2093,
                6781
              ],
              [
                2080,
                6822
              ]
            ]
          ],
          [
            [
              [
                2086,
                5559
              ],
              [
                2094,
                5589
              ],
              [
                2092,
                5594
              ],
              [
                2002,
                5663
              ],
              [
                1990,
                5654
              ],
              [
                1958,
                5692
              ],
              [
                1933,
                5689
              ],
              [
                1982,
                5764
              ],
              [
                2040,
                5805
              ],
              [
                2031,
                5864
              ],
              [
                2008,
                5866
              ],
              [
                2008,
                5868
              ],
              [
                2007,
                5872
              ],
              [
                2016,
                5901
              ],
              [
                2013,
                5924
              ],
              [
                1974,
                5929
              ],
              [
                1963,
                5979
              ],
              [
                1935,
                6001
              ],
              [
                1882,
                6001
              ],
              [
                1884,
                6044
              ],
              [
                1870,
                6074
              ],
              [
                1884,
                6151
              ],
              [
                1853,
                6186
              ],
              [
                1848,
                6222
              ],
              [
                1791,
                6224
              ],
              [
                1773,
                6319
              ],
              [
                1727,
                6329
              ],
              [
                1683,
                6363
              ],
              [
                1638,
                6371
              ],
              [
                1601,
                6421
              ],
              [
                1596,
                6478
              ],
              [
                1556,
                6469
              ],
              [
                1503,
                6428
              ],
              [
                1459,
                6429
              ],
              [
                1423,
                6426
              ],
              [
                1424,
                6487
              ],
              [
                1402,
                6468
              ],
              [
                1369,
                6465
              ],
              [
                1303,
                6560
              ],
              [
                1331,
                6604
              ],
              [
                1337,
                6653
              ],
              [
                1408,
                6690
              ],
              [
                1436,
                6687
              ],
              [
                1453,
                6805
              ],
              [
                1430,
                6844
              ],
              [
                1430,
                6873
              ],
              [
                1462,
                6875
              ],
              [
                1437,
                6891
              ],
              [
                1437,
                6916
              ],
              [
                1495,
                6916
              ],
              [
                1523,
                6931
              ],
              [
                1539,
                6897
              ],
              [
                1583,
                6875
              ],
              [
                1632,
                6911
              ],
              [
                1658,
                6943
              ],
              [
                1635,
                6945
              ],
              [
                1631,
                6988
              ],
              [
                1616,
                7003
              ],
              [
                1721,
                7014
              ],
              [
                1750,
                7050
              ],
              [
                1775,
                7046
              ],
              [
                1770,
                7023
              ],
              [
                1790,
                7002
              ],
              [
                1773,
                6954
              ],
              [
                1781,
                6921
              ],
              [
                1812,
                6896
              ],
              [
                1871,
                6928
              ],
              [
                1892,
                6925
              ],
              [
                1910,
                6947
              ],
              [
                1956,
                6940
              ],
              [
                2011,
                6934
              ],
              [
                2056,
                7005
              ],
              [
                2077,
                6999
              ],
              [
                2090,
                6932
              ],
              [
                2115,
                6914
              ],
              [
                2118,
                6851
              ],
              [
                2074,
                6845
              ],
              [
                2068,
                6803
              ],
              [
                2090,
                6781
              ],
              [
                2138,
                6775
              ],
              [
                2186,
                6828
              ],
              [
                2242,
                6815
              ],
              [
                2271,
                6783
              ],
              [
                2282,
                6798
              ],
              [
                2314,
                6743
              ],
              [
                2327,
                6763
              ],
              [
                2397,
                6739
              ],
              [
                2453,
                6741
              ],
              [
                2504,
                6708
              ],
              [
                2549,
                6661
              ],
              [
                2604,
                6653
              ],
              [
                2632,
                6574
              ],
              [
                2616,
                6496
              ],
              [
                2564,
                6436
              ],
              [
                2518,
                6352
              ],
              [
                2498,
                6340
              ],
              [
                2496,
                6286
              ],
              [
                2505,
                6240
              ],
              [
                2500,
                6170
              ],
              [
                2484,
                6150
              ],
              [
                2484,
                6105
              ],
              [
                2444,
                6022
              ],
              [
                2448,
                6006
              ],
              [
                2415,
                5967
              ],
              [
                2339,
                5968
              ],
              [
                2257,
                5916
              ],
              [
                2226,
                5887
              ],
              [
                2207,
                5848
              ],
              [
                2220,
                5789
              ],
              [
                2213,
                5753
              ],
              [
                2183,
                5717
              ],
              [
                2172,
                5678
              ],
              [
                2141,
                5689
              ],
              [
                2139,
                5654
              ],
              [
                2117,
                5629
              ],
              [
                2113,
                5577
              ],
              [
                2092,
                5552
              ],
              [
                2087,
                5556
              ],
              [
                2086,
                5559
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BS",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.16,
        "hc-middle-y": 0.29,
        "hc-key": "bs",
        "hc-a2": "BS",
        "name": "The Bahamas",
        "labelrank": "4",
        "country-abbrev": "Bhs.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "BHS",
        "iso-a2": "BS",
        "woe-id": "23424758",
        "continent": "North America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                1283,
                7827
              ],
              [
                1239,
                7800
              ],
              [
                1232,
                7768
              ],
              [
                1220,
                7799
              ],
              [
                1255,
                7815
              ],
              [
                1264,
                7847
              ],
              [
                1283,
                7827
              ]
            ]
          ],
          [
            [
              [
                1317,
                7778
              ],
              [
                1319,
                7751
              ],
              [
                1319,
                7751
              ],
              [
                1310,
                7778
              ],
              [
                1317,
                7778
              ],
              [
                1317,
                7778
              ],
              [
                1317,
                7778
              ]
            ]
          ],
          [
            [
              [
                1323,
                7739
              ],
              [
                1320,
                7740
              ],
              [
                1319,
                7751
              ],
              [
                1319,
                7751
              ],
              [
                1323,
                7739
              ],
              [
                1323,
                7739
              ],
              [
                1323,
                7739
              ]
            ]
          ],
          [
            [
              [
                1323,
                7739
              ],
              [
                1392,
                7710
              ],
              [
                1326,
                7730
              ],
              [
                1323,
                7739
              ],
              [
                1323,
                7739
              ],
              [
                1323,
                7739
              ]
            ]
          ],
          [
            [
              [
                1317,
                7778
              ],
              [
                1317,
                7779
              ],
              [
                1342,
                7777
              ],
              [
                1317,
                7778
              ],
              [
                1317,
                7778
              ],
              [
                1317,
                7778
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PW",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.54,
        "hc-key": "pw",
        "hc-a2": "PW",
        "name": "Palau",
        "labelrank": "6",
        "country-abbrev": "Palau",
        "subregion": "Micronesia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "PLW",
        "iso-a2": "PW",
        "woe-id": "23424927",
        "continent": "Oceania"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              8266,
              6966
            ],
            [
              8265,
              6967
            ],
            [
              8266,
              6968
            ],
            [
              8267,
              6967
            ],
            [
              8266,
              6966
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "NG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.38,
        "hc-middle-y": 0.37,
        "hc-key": "ng",
        "hc-a2": "NG",
        "name": "Nigeria",
        "labelrank": "2",
        "country-abbrev": "Nigeria",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "NGA",
        "iso-a2": "NG",
        "woe-id": "23424908",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4103,
              7035
            ],
            [
              4021,
              7015
            ],
            [
              4001,
              7028
            ],
            [
              3977,
              7081
            ],
            [
              3960,
              7095
            ],
            [
              3903,
              7095
            ],
            [
              3905,
              7199
            ],
            [
              3941,
              7258
            ],
            [
              3933,
              7300
            ],
            [
              3950,
              7368
            ],
            [
              3997,
              7384
            ],
            [
              4045,
              7350
            ],
            [
              4075,
              7364
            ],
            [
              4136,
              7343
            ],
            [
              4152,
              7360
            ],
            [
              4197,
              7364
            ],
            [
              4232,
              7353
            ],
            [
              4270,
              7377
            ],
            [
              4285,
              7353
            ],
            [
              4306,
              7319
            ],
            [
              4304,
              7292
            ],
            [
              4284,
              7284
            ],
            [
              4225,
              7171
            ],
            [
              4213,
              7124
            ],
            [
              4195,
              7098
            ],
            [
              4170,
              7124
            ],
            [
              4111,
              7074
            ],
            [
              4103,
              7035
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GD",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.50,
        "hc-key": "gd",
        "hc-a2": "GD",
        "name": "Grenada",
        "labelrank": "6",
        "country-abbrev": "Gren.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "GRD",
        "iso-a2": "GD",
        "woe-id": "23424826",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1730,
              7313
            ],
            [
              1726,
              7313
            ],
            [
              1727,
              7318
            ],
            [
              1731,
              7320
            ],
            [
              1730,
              7313
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.51,
        "hc-key": "ag",
        "hc-a2": "AG",
        "name": "Antigua and Barbuda",
        "labelrank": "6",
        "country-abbrev": "Ant.B.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "ATG",
        "iso-a2": "AG",
        "woe-id": "23424737",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1739,
              7509
            ],
            [
              1742,
              7505
            ],
            [
              1737,
              7504
            ],
            [
              1735,
              7508
            ],
            [
              1739,
              7509
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TW",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.50,
        "hc-key": "tw",
        "hc-a2": "TW",
        "name": "Taiwan",
        "labelrank": "3",
        "country-abbrev": "Taiwan",
        "subregion": "Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "TWN",
        "iso-a2": "TW",
        "woe-id": "23424971",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7779,
              7758
            ],
            [
              7796,
              7765
            ],
            [
              7814,
              7814
            ],
            [
              7841,
              7816
            ],
            [
              7841,
              7741
            ],
            [
              7831,
              7694
            ],
            [
              7779,
              7758
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "FJ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.36,
        "hc-middle-y": 0.78,
        "hc-key": "fj",
        "hc-a2": "FJ",
        "name": "Fiji",
        "labelrank": "6",
        "country-abbrev": "Fiji",
        "subregion": "Melanesia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "FJI",
        "iso-a2": "FJ",
        "woe-id": "23424813",
        "continent": "Oceania"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              9794,
              6202
            ],
            [
              9851,
              6223
            ],
            [
              9786,
              6179
            ],
            [
              9795,
              6155
            ],
            [
              9749,
              6154
            ],
            [
              9794,
              6202
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BB",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.25,
        "hc-middle-y": 0.55,
        "hc-key": "bb",
        "hc-a2": "BB",
        "name": "Barbados",
        "labelrank": "5",
        "country-abbrev": "Barb.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "BRB",
        "iso-a2": "BB",
        "woe-id": "23424754",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1804,
              7352
            ],
            [
              1800,
              7355
            ],
            [
              1801,
              7363
            ],
            [
              1806,
              7355
            ],
            [
              1804,
              7352
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "IT",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.74,
        "hc-middle-y": 0.61,
        "hc-key": "it",
        "hc-a2": "IT",
        "name": "Italy",
        "labelrank": "2",
        "country-abbrev": "Italy",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "ITA",
        "iso-a2": "IT",
        "woe-id": "23424853",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4099,
                8360
              ],
              [
                4070,
                8360
              ],
              [
                4079,
                8387
              ],
              [
                4067,
                8422
              ],
              [
                4104,
                8436
              ],
              [
                4118,
                8408
              ],
              [
                4112,
                8358
              ],
              [
                4099,
                8360
              ]
            ]
          ],
          [
            [
              [
                4291,
                8267
              ],
              [
                4272,
                8267
              ],
              [
                4204,
                8306
              ],
              [
                4214,
                8321
              ],
              [
                4247,
                8313
              ],
              [
                4305,
                8325
              ],
              [
                4291,
                8267
              ]
            ]
          ],
          [
            [
              [
                4041,
                8531
              ],
              [
                4012,
                8582
              ],
              [
                4024,
                8613
              ],
              [
                4055,
                8626
              ],
              [
                4112,
                8629
              ],
              [
                4126,
                8648
              ],
              [
                4175,
                8656
              ],
              [
                4225,
                8636
              ],
              [
                4215,
                8627
              ],
              [
                4227,
                8601
              ],
              [
                4182,
                8590
              ],
              [
                4190,
                8547
              ],
              [
                4229,
                8521
              ],
              [
                4246,
                8486
              ],
              [
                4306,
                8444
              ],
              [
                4373,
                8413
              ],
              [
                4391,
                8392
              ],
              [
                4344,
                8408
              ],
              [
                4328,
                8384
              ],
              [
                4350,
                8369
              ],
              [
                4320,
                8312
              ],
              [
                4322,
                8344
              ],
              [
                4303,
                8391
              ],
              [
                4238,
                8436
              ],
              [
                4217,
                8435
              ],
              [
                4136,
                8507
              ],
              [
                4125,
                8533
              ],
              [
                4079,
                8554
              ],
              [
                4041,
                8531
              ]
            ],
            [
              [
                4197,
                8460
              ],
              [
                4197,
                8460
              ],
              [
                4197,
                8460
              ],
              [
                4197,
                8460
              ],
              [
                4197,
                8460
              ]
            ],
            [
              [
                4193,
                8534
              ],
              [
                4194,
                8538
              ],
              [
                4192,
                8537
              ],
              [
                4191,
                8535
              ],
              [
                4193,
                8534
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MT",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.53,
        "hc-key": "mt",
        "hc-a2": "MT",
        "name": "Malta",
        "labelrank": "5",
        "country-abbrev": "Malta",
        "subregion": "Southern Europe",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "MLT",
        "iso-a2": "MT",
        "woe-id": "23424897",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4267,
              8236
            ],
            [
              4274,
              8233
            ],
            [
              4275,
              8228
            ],
            [
              4270,
              8230
            ],
            [
              4267,
              8236
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.16,
        "hc-middle-y": 0.52,
        "hc-key": "pg",
        "hc-a2": "PG",
        "name": "Papua New Guinea",
        "labelrank": "2",
        "country-abbrev": "P.N.G.",
        "subregion": "Melanesia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "PNG",
        "iso-a2": "PG",
        "woe-id": "23424926",
        "continent": "Oceania"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                9060,
                6640
              ],
              [
                9098,
                6599
              ],
              [
                9079,
                6591
              ],
              [
                9060,
                6622
              ],
              [
                9060,
                6640
              ]
            ]
          ],
          [
            [
              [
                8584,
                6500
              ],
              [
                8592,
                6606
              ],
              [
                8600,
                6750
              ],
              [
                8718,
                6703
              ],
              [
                8760,
                6663
              ],
              [
                8756,
                6641
              ],
              [
                8796,
                6625
              ],
              [
                8804,
                6650
              ],
              [
                8824,
                6593
              ],
              [
                8794,
                6591
              ],
              [
                8800,
                6563
              ],
              [
                8830,
                6541
              ],
              [
                8842,
                6501
              ],
              [
                8887,
                6479
              ],
              [
                8914,
                6488
              ],
              [
                8926,
                6458
              ],
              [
                8910,
                6444
              ],
              [
                8816,
                6459
              ],
              [
                8788,
                6486
              ],
              [
                8760,
                6539
              ],
              [
                8683,
                6558
              ],
              [
                8666,
                6505
              ],
              [
                8639,
                6491
              ],
              [
                8584,
                6500
              ]
            ]
          ],
          [
            [
              [
                8984,
                6708
              ],
              [
                8964,
                6726
              ],
              [
                8964,
                6726
              ],
              [
                8983,
                6713
              ],
              [
                8984,
                6708
              ],
              [
                8984,
                6708
              ],
              [
                8984,
                6708
              ]
            ]
          ],
          [
            [
              [
                8984,
                6708
              ],
              [
                9010,
                6686
              ],
              [
                9000,
                6664
              ],
              [
                8984,
                6708
              ],
              [
                8984,
                6708
              ],
              [
                8984,
                6708
              ]
            ]
          ],
          [
            [
              [
                8914,
                6609
              ],
              [
                8886,
                6607
              ],
              [
                8834,
                6629
              ],
              [
                8935,
                6642
              ],
              [
                8959,
                6662
              ],
              [
                8956,
                6689
              ],
              [
                8985,
                6684
              ],
              [
                8972,
                6640
              ],
              [
                8914,
                6609
              ]
            ]
          ],
          [
            [
              [
                8964,
                6726
              ],
              [
                8942,
                6741
              ],
              [
                8913,
                6747
              ],
              [
                8897,
                6789
              ],
              [
                8909,
                6757
              ],
              [
                8934,
                6752
              ],
              [
                8964,
                6726
              ],
              [
                8964,
                6726
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.55,
        "hc-key": "sg",
        "hc-a2": "SG",
        "name": "Singapore",
        "labelrank": "6",
        "country-abbrev": "Sing.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "SGP",
        "iso-a2": "SG",
        "woe-id": "23424948",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7340,
              6905
            ],
            [
              7345,
              6903
            ],
            [
              7339,
              6899
            ],
            [
              7333,
              6900
            ],
            [
              7340,
              6905
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CY",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.39,
        "hc-middle-y": 0.50,
        "hc-key": "cy",
        "hc-a2": "CY",
        "name": "Cyprus",
        "labelrank": "5",
        "country-abbrev": "Cyp.",
        "subregion": "Western Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "CYP",
        "iso-a2": "CY",
        "woe-id": "-90",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4892,
                8197
              ],
              [
                4892,
                8197
              ],
              [
                4892,
                8197
              ],
              [
                4892,
                8197
              ],
              [
                4892,
                8197
              ]
            ]
          ],
          [
            [
              [
                4901,
                8199
              ],
              [
                4904,
                8195
              ],
              [
                4897,
                8195
              ],
              [
                4894,
                8198
              ],
              [
                4897,
                8199
              ],
              [
                4900,
                8198
              ],
              [
                4901,
                8199
              ]
            ]
          ],
          [
            [
              [
                4893,
                8196
              ],
              [
                4893,
                8196
              ],
              [
                4894,
                8196
              ],
              [
                4893,
                8196
              ],
              [
                4893,
                8196
              ]
            ]
          ],
          [
            [
              [
                4891,
                8196
              ],
              [
                4889,
                8190
              ],
              [
                4870,
                8182
              ],
              [
                4864,
                8185
              ],
              [
                4862,
                8183
              ],
              [
                4845,
                8198
              ],
              [
                4854,
                8203
              ],
              [
                4856,
                8203
              ],
              [
                4857,
                8204
              ],
              [
                4858,
                8204
              ],
              [
                4858,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4881,
                8203
              ],
              [
                4891,
                8196
              ],
              [
                4891,
                8196
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.39,
        "hc-middle-y": 0.52,
        "hc-key": "km",
        "hc-a2": "KM",
        "name": "Comoros",
        "labelrank": "6",
        "country-abbrev": "Com.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "COM",
        "iso-a2": "KM",
        "woe-id": "23424786",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5279,
              6391
            ],
            [
              5271,
              6398
            ],
            [
              5272,
              6410
            ],
            [
              5276,
              6413
            ],
            [
              5279,
              6391
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "VA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.61,
        "hc-middle-y": 0.45,
        "hc-key": "va",
        "hc-a2": "VA",
        "name": "Vatican",
        "labelrank": "6",
        "country-abbrev": "Vat.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "VAT",
        "iso-a2": "VA",
        "woe-id": "23424986",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4197,
              8460
            ],
            [
              4197,
              8460
            ],
            [
              4197,
              8460
            ],
            [
              4197,
              8460
            ],
            [
              4197,
              8460
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.65,
        "hc-middle-y": 0.39,
        "hc-key": "sm",
        "hc-a2": "SM",
        "name": "San Marino",
        "labelrank": "6",
        "country-abbrev": "S.M.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "SMR",
        "iso-a2": "SM",
        "woe-id": "23424947",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4193,
              8534
            ],
            [
              4191,
              8535
            ],
            [
              4192,
              8537
            ],
            [
              4194,
              8538
            ],
            [
              4193,
              8534
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.21,
        "hc-middle-y": 0.14,
        "hc-key": "am",
        "hc-a2": "AM",
        "name": "Armenia",
        "labelrank": "6",
        "country-abbrev": "Arm.",
        "subregion": "Western Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "ARM",
        "iso-a2": "AM",
        "woe-id": "23424743",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                5231,
                8412
              ],
              [
                5231,
                8413
              ],
              [
                5233,
                8413
              ],
              [
                5232,
                8411
              ],
              [
                5231,
                8412
              ]
            ]
          ],
          [
            [
              [
                5220,
                8426
              ],
              [
                5219,
                8425
              ],
              [
                5219,
                8426
              ],
              [
                5219,
                8426
              ],
              [
                5220,
                8426
              ]
            ]
          ],
          [
            [
              [
                5216,
                8380
              ],
              [
                5178,
                8393
              ],
              [
                5164,
                8430
              ],
              [
                5186,
                8435
              ],
              [
                5211,
                8437
              ],
              [
                5228,
                8412
              ],
              [
                5245,
                8389
              ],
              [
                5243,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5239,
                8391
              ],
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5240,
                8389
              ],
              [
                5241,
                8389
              ],
              [
                5245,
                8389
              ],
              [
                5245,
                8389
              ],
              [
                5245,
                8389
              ],
              [
                5268,
                8368
              ],
              [
                5276,
                8348
              ],
              [
                5271,
                8350
              ],
              [
                5264,
                8348
              ],
              [
                5248,
                8374
              ],
              [
                5216,
                8380
              ]
            ],
            [
              [
                5214,
                8428
              ],
              [
                5213,
                8429
              ],
              [
                5212,
                8429
              ],
              [
                5212,
                8428
              ],
              [
                5214,
                8428
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.87,
        "hc-middle-y": 0.24,
        "hc-key": "az",
        "hc-a2": "AZ",
        "name": "Azerbaijan",
        "labelrank": "5",
        "country-abbrev": "Aze.",
        "subregion": "Western Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "AZE",
        "iso-a2": "AZ",
        "woe-id": "23424741",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                5214,
                8428
              ],
              [
                5212,
                8428
              ],
              [
                5212,
                8429
              ],
              [
                5213,
                8429
              ],
              [
                5214,
                8428
              ]
            ]
          ],
          [
            [
              [
                5245,
                8389
              ],
              [
                5245,
                8389
              ],
              [
                5248,
                8389
              ],
              [
                5228,
                8412
              ],
              [
                5211,
                8437
              ],
              [
                5260,
                8428
              ],
              [
                5251,
                8460
              ],
              [
                5297,
                8434
              ],
              [
                5318,
                8458
              ],
              [
                5359,
                8412
              ],
              [
                5354,
                8331
              ],
              [
                5324,
                8346
              ],
              [
                5315,
                8380
              ],
              [
                5276,
                8348
              ],
              [
                5268,
                8368
              ],
              [
                5245,
                8389
              ]
            ],
            [
              [
                5231,
                8412
              ],
              [
                5232,
                8411
              ],
              [
                5233,
                8413
              ],
              [
                5231,
                8413
              ],
              [
                5231,
                8412
              ]
            ],
            [
              [
                5220,
                8426
              ],
              [
                5219,
                8426
              ],
              [
                5219,
                8426
              ],
              [
                5219,
                8425
              ],
              [
                5220,
                8426
              ]
            ]
          ],
          [
            [
              [
                5217,
                8378
              ],
              [
                5216,
                8380
              ],
              [
                5248,
                8374
              ],
              [
                5264,
                8348
              ],
              [
                5241,
                8353
              ],
              [
                5217,
                8378
              ]
            ]
          ],
          [
            [
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5239,
                8391
              ],
              [
                5240,
                8390
              ]
            ]
          ],
          [
            [
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5240,
                8390
              ],
              [
                5245,
                8389
              ],
              [
                5240,
                8390
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TJ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.58,
        "hc-middle-y": 0.39,
        "hc-key": "tj",
        "hc-a2": "TJ",
        "name": "Tajikistan",
        "labelrank": "4",
        "country-abbrev": "Tjk.",
        "subregion": "Central Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "TJK",
        "iso-a2": "TJ",
        "woe-id": "23424961",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                6013,
                8425
              ],
              [
                6012,
                8424
              ],
              [
                6009,
                8427
              ],
              [
                6011,
                8427
              ],
              [
                6013,
                8425
              ]
            ]
          ],
          [
            [
              [
                6006,
                8427
              ],
              [
                6031,
                8397
              ],
              [
                6027,
                8395
              ],
              [
                6023,
                8390
              ],
              [
                6023,
                8390
              ],
              [
                6022,
                8389
              ],
              [
                6020,
                8389
              ],
              [
                6020,
                8389
              ],
              [
                6019,
                8390
              ],
              [
                6019,
                8390
              ],
              [
                6013,
                8391
              ],
              [
                5982,
                8391
              ],
              [
                5987,
                8373
              ],
              [
                6054,
                8377
              ],
              [
                6083,
                8360
              ],
              [
                6124,
                8370
              ],
              [
                6139,
                8337
              ],
              [
                6170,
                8334
              ],
              [
                6188,
                8284
              ],
              [
                6135,
                8293
              ],
              [
                6096,
                8263
              ],
              [
                6076,
                8310
              ],
              [
                6040,
                8328
              ],
              [
                6034,
                8296
              ],
              [
                6010,
                8279
              ],
              [
                5963,
                8282
              ],
              [
                5971,
                8322
              ],
              [
                5955,
                8352
              ],
              [
                5929,
                8361
              ],
              [
                5965,
                8391
              ],
              [
                5965,
                8391
              ],
              [
                5968,
                8387
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5967,
                8390
              ],
              [
                5967,
                8390
              ],
              [
                5971,
                8391
              ],
              [
                5975,
                8418
              ],
              [
                6006,
                8427
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.04,
        "hc-middle-y": 0.55,
        "hc-key": "ga",
        "hc-a2": "GA",
        "name": "Gabon",
        "labelrank": "4",
        "country-abbrev": "Gabon",
        "subregion": "Middle Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "GAB",
        "iso-a2": "GA",
        "woe-id": "23424822",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4188,
              6699
            ],
            [
              4126,
              6779
            ],
            [
              4107,
              6828
            ],
            [
              4126,
              6834
            ],
            [
              4128,
              6874
            ],
            [
              4144,
              6888
            ],
            [
              4196,
              6889
            ],
            [
              4196,
              6933
            ],
            [
              4197,
              6939
            ],
            [
              4263,
              6933
            ],
            [
              4261,
              6897
            ],
            [
              4295,
              6901
            ],
            [
              4303,
              6885
            ],
            [
              4281,
              6842
            ],
            [
              4304,
              6827
            ],
            [
              4290,
              6754
            ],
            [
              4233,
              6778
            ],
            [
              4234,
              6760
            ],
            [
              4204,
              6760
            ],
            [
              4213,
              6707
            ],
            [
              4188,
              6699
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "UZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.56,
        "hc-middle-y": 0.57,
        "hc-key": "uz",
        "hc-a2": "UZ",
        "name": "Uzbekistan",
        "labelrank": "3",
        "country-abbrev": "Uzb.",
        "subregion": "Central Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "UZB",
        "iso-a2": "UZ",
        "woe-id": "23424980",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                6060,
                8388
              ],
              [
                6058,
                8388
              ],
              [
                6056,
                8389
              ],
              [
                6060,
                8391
              ],
              [
                6060,
                8388
              ]
            ]
          ],
          [
            [
              [
                6041,
                8390
              ],
              [
                6043,
                8387
              ],
              [
                6037,
                8387
              ],
              [
                6033,
                8394
              ],
              [
                6041,
                8390
              ]
            ]
          ],
          [
            [
              [
                5596,
                8470
              ],
              [
                5587,
                8477
              ],
              [
                5580,
                8461
              ],
              [
                5585,
                8436
              ],
              [
                5552,
                8438
              ],
              [
                5516,
                8575
              ],
              [
                5590,
                8599
              ],
              [
                5586,
                8573
              ],
              [
                5595,
                8596
              ],
              [
                5620,
                8584
              ],
              [
                5617,
                8566
              ],
              [
                5644,
                8547
              ],
              [
                5642,
                8570
              ],
              [
                5717,
                8519
              ],
              [
                5803,
                8528
              ],
              [
                5840,
                8497
              ],
              [
                5887,
                8434
              ],
              [
                5926,
                8434
              ],
              [
                5953,
                8411
              ],
              [
                5958,
                8440
              ],
              [
                6007,
                8473
              ],
              [
                5991,
                8448
              ],
              [
                6035,
                8431
              ],
              [
                6041,
                8443
              ],
              [
                6092,
                8418
              ],
              [
                6054,
                8394
              ],
              [
                6031,
                8397
              ],
              [
                6006,
                8427
              ],
              [
                5960,
                8373
              ],
              [
                5929,
                8361
              ],
              [
                5955,
                8352
              ],
              [
                5971,
                8322
              ],
              [
                5963,
                8282
              ],
              [
                5945,
                8282
              ],
              [
                5921,
                8289
              ],
              [
                5916,
                8315
              ],
              [
                5884,
                8323
              ],
              [
                5767,
                8389
              ],
              [
                5742,
                8426
              ],
              [
                5680,
                8441
              ],
              [
                5663,
                8475
              ],
              [
                5619,
                8493
              ],
              [
                5596,
                8470
              ]
            ],
            [
              [
                6013,
                8425
              ],
              [
                6011,
                8427
              ],
              [
                6009,
                8427
              ],
              [
                6012,
                8424
              ],
              [
                6013,
                8425
              ]
            ],
            [
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ],
              [
                5969,
                8386
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LS",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.53,
        "hc-middle-y": 0.48,
        "hc-key": "ls",
        "hc-a2": "LS",
        "name": "Lesotho",
        "labelrank": "6",
        "country-abbrev": "Les.",
        "subregion": "Southern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "LSO",
        "iso-a2": "LS",
        "woe-id": "23424880",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4694,
              5711
            ],
            [
              4749,
              5751
            ],
            [
              4773,
              5721
            ],
            [
              4725,
              5671
            ],
            [
              4694,
              5711
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "IN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.38,
        "hc-middle-y": 0.47,
        "hc-key": "in",
        "hc-a2": "IN",
        "name": "India",
        "labelrank": "2",
        "country-abbrev": "India",
        "subregion": "Southern Asia",
        "region-wb": "South Asia",
        "iso-a3": "IND",
        "iso-a2": "IN",
        "woe-id": "23424848",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6747,
              7760
            ],
            [
              6774,
              7694
            ],
            [
              6774,
              7694
            ],
            [
              6774,
              7694
            ],
            [
              6714,
              7679
            ],
            [
              6712,
              7645
            ],
            [
              6695,
              7619
            ],
            [
              6664,
              7616
            ],
            [
              6626,
              7553
            ],
            [
              6577,
              7512
            ],
            [
              6574,
              7488
            ],
            [
              6509,
              7454
            ],
            [
              6504,
              7428
            ],
            [
              6520,
              7364
            ],
            [
              6508,
              7313
            ],
            [
              6512,
              7246
            ],
            [
              6496,
              7247
            ],
            [
              6485,
              7207
            ],
            [
              6460,
              7195
            ],
            [
              6437,
              7161
            ],
            [
              6403,
              7193
            ],
            [
              6362,
              7300
            ],
            [
              6335,
              7344
            ],
            [
              6314,
              7410
            ],
            [
              6278,
              7468
            ],
            [
              6237,
              7614
            ],
            [
              6242,
              7640
            ],
            [
              6217,
              7710
            ],
            [
              6213,
              7666
            ],
            [
              6178,
              7647
            ],
            [
              6145,
              7664
            ],
            [
              6103,
              7708
            ],
            [
              6143,
              7718
            ],
            [
              6090,
              7741
            ],
            [
              6071,
              7767
            ],
            [
              6091,
              7783
            ],
            [
              6129,
              7780
            ],
            [
              6163,
              7800
            ],
            [
              6123,
              7871
            ],
            [
              6098,
              7882
            ],
            [
              6123,
              7929
            ],
            [
              6138,
              7916
            ],
            [
              6170,
              7926
            ],
            [
              6197,
              7967
            ],
            [
              6205,
              8001
            ],
            [
              6234,
              8047
            ],
            [
              6227,
              8070
            ],
            [
              6250,
              8087
            ],
            [
              6199,
              8126
            ],
            [
              6181,
              8172
            ],
            [
              6195,
              8188
            ],
            [
              6244,
              8177
            ],
            [
              6278,
              8201
            ],
            [
              6299,
              8216
            ],
            [
              6323,
              8182
            ],
            [
              6346,
              8172
            ],
            [
              6351,
              8138
            ],
            [
              6380,
              8110
            ],
            [
              6346,
              8101
            ],
            [
              6369,
              8055
            ],
            [
              6452,
              8012
            ],
            [
              6435,
              7995
            ],
            [
              6432,
              7960
            ],
            [
              6531,
              7908
            ],
            [
              6592,
              7902
            ],
            [
              6639,
              7872
            ],
            [
              6690,
              7864
            ],
            [
              6715,
              7878
            ],
            [
              6704,
              7922
            ],
            [
              6726,
              7927
            ],
            [
              6734,
              7901
            ],
            [
              6769,
              7877
            ],
            [
              6842,
              7887
            ],
            [
              6821,
              7918
            ],
            [
              6852,
              7924
            ],
            [
              6905,
              7978
            ],
            [
              6929,
              7968
            ],
            [
              6954,
              7980
            ],
            [
              7003,
              7936
            ],
            [
              6991,
              7903
            ],
            [
              6943,
              7869
            ],
            [
              6948,
              7840
            ],
            [
              6930,
              7767
            ],
            [
              6903,
              7773
            ],
            [
              6908,
              7711
            ],
            [
              6891,
              7696
            ],
            [
              6866,
              7763
            ],
            [
              6852,
              7733
            ],
            [
              6834,
              7758
            ],
            [
              6870,
              7809
            ],
            [
              6853,
              7819
            ],
            [
              6798,
              7818
            ],
            [
              6775,
              7848
            ],
            [
              6726,
              7868
            ],
            [
              6717,
              7847
            ],
            [
              6750,
              7818
            ],
            [
              6724,
              7798
            ],
            [
              6750,
              7784
            ],
            [
              6747,
              7760
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KP",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.82,
        "hc-middle-y": 0.77,
        "hc-key": "kp",
        "hc-a2": "KP",
        "name": "North Korea",
        "labelrank": "3",
        "country-abbrev": "N.K.",
        "subregion": "Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "PRK",
        "iso-a2": "KP",
        "woe-id": "23424865",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7706,
              8391
            ],
            [
              7704,
              8392
            ],
            [
              7739,
              8423
            ],
            [
              7742,
              8451
            ],
            [
              7796,
              8440
            ],
            [
              7779,
              8464
            ],
            [
              7844,
              8484
            ],
            [
              7851,
              8479
            ],
            [
              7855,
              8475
            ],
            [
              7839,
              8447
            ],
            [
              7856,
              8420
            ],
            [
              7810,
              8381
            ],
            [
              7820,
              8359
            ],
            [
              7859,
              8338
            ],
            [
              7827,
              8326
            ],
            [
              7820,
              8307
            ],
            [
              7751,
              8335
            ],
            [
              7754,
              8365
            ],
            [
              7706,
              8390
            ],
            [
              7706,
              8391
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.53,
        "hc-key": "kg",
        "hc-a2": "KG",
        "name": "Kyrgyzstan",
        "labelrank": "4",
        "country-abbrev": "Kgz.",
        "subregion": "Central Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "KGZ",
        "iso-a2": "KG",
        "woe-id": "23424864",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6127,
              8391
            ],
            [
              6127,
              8390
            ],
            [
              6127,
              8390
            ],
            [
              6131,
              8375
            ],
            [
              6124,
              8370
            ],
            [
              6083,
              8360
            ],
            [
              6054,
              8377
            ],
            [
              5987,
              8373
            ],
            [
              5982,
              8391
            ],
            [
              6031,
              8397
            ],
            [
              6054,
              8394
            ],
            [
              6092,
              8418
            ],
            [
              6041,
              8443
            ],
            [
              6035,
              8431
            ],
            [
              5991,
              8448
            ],
            [
              6007,
              8473
            ],
            [
              6027,
              8495
            ],
            [
              6084,
              8479
            ],
            [
              6094,
              8511
            ],
            [
              6130,
              8495
            ],
            [
              6230,
              8497
            ],
            [
              6294,
              8471
            ],
            [
              6243,
              8428
            ],
            [
              6204,
              8424
            ],
            [
              6178,
              8400
            ],
            [
              6169,
              8412
            ],
            [
              6127,
              8390
            ],
            [
              6127,
              8390
            ],
            [
              6127,
              8391
            ]
          ],
          [
            [
              6060,
              8388
            ],
            [
              6060,
              8391
            ],
            [
              6056,
              8389
            ],
            [
              6058,
              8388
            ],
            [
              6060,
              8388
            ]
          ],
          [
            [
              6041,
              8390
            ],
            [
              6033,
              8394
            ],
            [
              6037,
              8387
            ],
            [
              6043,
              8387
            ],
            [
              6041,
              8390
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "ES",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.77,
        "hc-middle-y": 0.26,
        "hc-key": "es",
        "hc-a2": "ES",
        "name": "Spain",
        "labelrank": "2",
        "country-abbrev": "Sp.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "ESP",
        "iso-a2": "ES",
        "woe-id": "23424950",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8427
              ],
              [
                3618,
                8448
              ],
              [
                3607,
                8462
              ],
              [
                3540,
                8463
              ],
              [
                3527,
                8507
              ],
              [
                3568,
                8530
              ],
              [
                3588,
                8522
              ],
              [
                3756,
                8515
              ],
              [
                3810,
                8489
              ],
              [
                3855,
                8486
              ],
              [
                3858,
                8480
              ],
              [
                3864,
                8483
              ],
              [
                3872,
                8481
              ],
              [
                3871,
                8481
              ],
              [
                3872,
                8482
              ],
              [
                3873,
                8480
              ],
              [
                3872,
                8480
              ],
              [
                3889,
                8476
              ],
              [
                3909,
                8480
              ],
              [
                3911,
                8463
              ],
              [
                3875,
                8437
              ],
              [
                3842,
                8428
              ],
              [
                3801,
                8373
              ],
              [
                3818,
                8344
              ],
              [
                3795,
                8327
              ],
              [
                3789,
                8299
              ],
              [
                3758,
                8289
              ],
              [
                3745,
                8266
              ],
              [
                3670,
                8264
              ],
              [
                3641,
                8241
              ],
              [
                3640,
                8241
              ],
              [
                3615,
                8248
              ],
              [
                3605,
                8273
              ],
              [
                3576,
                8282
              ],
              [
                3592,
                8354
              ],
              [
                3574,
                8379
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3596,
                8389
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ],
              [
                3595,
                8390
              ]
            ]
          ],
          [
            [
              [
                3639,
                8233
              ],
              [
                3642,
                8232
              ],
              [
                3641,
                8230
              ],
              [
                3639,
                8231
              ],
              [
                3639,
                8233
              ]
            ]
          ],
          [
            [
              [
                3717,
                8207
              ],
              [
                3716,
                8209
              ],
              [
                3717,
                8209
              ],
              [
                3717,
                8209
              ],
              [
                3717,
                8209
              ],
              [
                3718,
                8207
              ],
              [
                3717,
                8207
              ]
            ]
          ],
          [
            [
              [
                3335,
                7931
              ],
              [
                3360,
                7968
              ],
              [
                3353,
                7936
              ],
              [
                3335,
                7931
              ],
              [
                3335,
                7931
              ],
              [
                3335,
                7931
              ]
            ]
          ],
          [
            [
              [
                3333,
                7930
              ],
              [
                3335,
                7931
              ],
              [
                3335,
                7931
              ],
              [
                3335,
                7931
              ],
              [
                3335,
                7930
              ],
              [
                3333,
                7930
              ],
              [
                3333,
                7930
              ]
            ]
          ],
          [
            [
              [
                3333,
                7930
              ],
              [
                3306,
                7922
              ],
              [
                3242,
                7931
              ],
              [
                3283,
                7949
              ],
              [
                3307,
                7928
              ],
              [
                3333,
                7930
              ],
              [
                3333,
                7930
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MX",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.58,
        "hc-key": "mx",
        "hc-a2": "MX",
        "name": "Mexico",
        "labelrank": "2",
        "country-abbrev": "Mex.",
        "subregion": "Central America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "MEX",
        "iso-a2": "MX",
        "woe-id": "23424900",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              502,
              7990
            ],
            [
              502,
              7985
            ],
            [
              509,
              7984
            ],
            [
              523,
              7938
            ],
            [
              538,
              7891
            ],
            [
              543,
              7881
            ],
            [
              544,
              7872
            ],
            [
              571,
              7853
            ],
            [
              606,
              7849
            ],
            [
              579,
              7793
            ],
            [
              560,
              7725
            ],
            [
              572,
              7644
            ],
            [
              606,
              7572
            ],
            [
              648,
              7548
            ],
            [
              738,
              7567
            ],
            [
              771,
              7587
            ],
            [
              801,
              7659
            ],
            [
              878,
              7682
            ],
            [
              923,
              7666
            ],
            [
              902,
              7638
            ],
            [
              870,
              7552
            ],
            [
              856,
              7561
            ],
            [
              834,
              7538
            ],
            [
              824,
              7535
            ],
            [
              764,
              7536
            ],
            [
              745,
              7514
            ],
            [
              776,
              7480
            ],
            [
              730,
              7468
            ],
            [
              706,
              7410
            ],
            [
              657,
              7469
            ],
            [
              626,
              7482
            ],
            [
              565,
              7453
            ],
            [
              495,
              7487
            ],
            [
              423,
              7515
            ],
            [
              401,
              7538
            ],
            [
              347,
              7555
            ],
            [
              302,
              7594
            ],
            [
              285,
              7635
            ],
            [
              302,
              7644
            ],
            [
              270,
              7676
            ],
            [
              301,
              7682
            ],
            [
              296,
              7721
            ],
            [
              231,
              7822
            ],
            [
              199,
              7842
            ],
            [
              207,
              7878
            ],
            [
              177,
              7903
            ],
            [
              140,
              7967
            ],
            [
              130,
              8035
            ],
            [
              137,
              8049
            ],
            [
              95,
              8072
            ],
            [
              72,
              8012
            ],
            [
              112,
              7944
            ],
            [
              137,
              7842
            ],
            [
              154,
              7813
            ],
            [
              146,
              7795
            ],
            [
              174,
              7779
            ],
            [
              179,
              7744
            ],
            [
              161,
              7730
            ],
            [
              152,
              7756
            ],
            [
              103,
              7803
            ],
            [
              109,
              7852
            ],
            [
              46,
              7898
            ],
            [
              26,
              7932
            ],
            [
              62,
              7912
            ],
            [
              73,
              7945
            ],
            [
              33,
              7995
            ],
            [
              34,
              8035
            ],
            [
              23,
              8101
            ],
            [
              103,
              8108
            ],
            [
              97,
              8100
            ],
            [
              203,
              8055
            ],
            [
              296,
              8055
            ],
            [
              301,
              8072
            ],
            [
              356,
              8072
            ],
            [
              395,
              8025
            ],
            [
              397,
              7992
            ],
            [
              435,
              7965
            ],
            [
              472,
              8000
            ],
            [
              502,
              7990
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.71,
        "hc-middle-y": 0.13,
        "hc-key": "ma",
        "hc-a2": "MA",
        "name": "Morocco",
        "labelrank": "3",
        "country-abbrev": "Mor.",
        "subregion": "Northern Africa",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "MAR",
        "iso-a2": "MA",
        "woe-id": "23424893",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3717,
              8207
            ],
            [
              3718,
              8207
            ],
            [
              3720,
              8202
            ],
            [
              3740,
              8200
            ],
            [
              3754,
              8187
            ],
            [
              3757,
              8128
            ],
            [
              3777,
              8101
            ],
            [
              3771,
              8084
            ],
            [
              3730,
              8086
            ],
            [
              3692,
              8067
            ],
            [
              3692,
              8032
            ],
            [
              3623,
              7989
            ],
            [
              3562,
              7981
            ],
            [
              3527,
              7953
            ],
            [
              3526,
              7914
            ],
            [
              3522,
              7894
            ],
            [
              3491,
              7884
            ],
            [
              3436,
              7884
            ],
            [
              3414,
              7852
            ],
            [
              3400,
              7805
            ],
            [
              3346,
              7751
            ],
            [
              3338,
              7708
            ],
            [
              3317,
              7675
            ],
            [
              3245,
              7674
            ],
            [
              3293,
              7774
            ],
            [
              3318,
              7801
            ],
            [
              3333,
              7856
            ],
            [
              3363,
              7877
            ],
            [
              3386,
              7925
            ],
            [
              3434,
              7940
            ],
            [
              3465,
              7966
            ],
            [
              3498,
              8020
            ],
            [
              3491,
              8058
            ],
            [
              3512,
              8103
            ],
            [
              3536,
              8130
            ],
            [
              3592,
              8159
            ],
            [
              3622,
              8227
            ],
            [
              3639,
              8233
            ],
            [
              3639,
              8231
            ],
            [
              3641,
              8230
            ],
            [
              3671,
              8203
            ],
            [
              3717,
              8210
            ],
            [
              3717,
              8209
            ],
            [
              3717,
              8209
            ],
            [
              3717,
              8207
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CO",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.48,
        "hc-key": "co",
        "hc-a2": "CO",
        "name": "Colombia",
        "labelrank": "2",
        "country-abbrev": "Col.",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "COL",
        "iso-a2": "CO",
        "woe-id": "23424787",
        "continent": "South America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1132,
              6905
            ],
            [
              1137,
              6934
            ],
            [
              1164,
              6951
            ],
            [
              1190,
              6995
            ],
            [
              1182,
              7065
            ],
            [
              1188,
              7103
            ],
            [
              1171,
              7128
            ],
            [
              1197,
              7156
            ],
            [
              1191,
              7183
            ],
            [
              1205,
              7179
            ],
            [
              1252,
              7214
            ],
            [
              1258,
              7257
            ],
            [
              1307,
              7287
            ],
            [
              1335,
              7285
            ],
            [
              1398,
              7329
            ],
            [
              1402,
              7306
            ],
            [
              1380,
              7299
            ],
            [
              1345,
              7251
            ],
            [
              1340,
              7208
            ],
            [
              1359,
              7170
            ],
            [
              1367,
              7123
            ],
            [
              1434,
              7118
            ],
            [
              1456,
              7086
            ],
            [
              1522,
              7089
            ],
            [
              1507,
              7024
            ],
            [
              1525,
              6982
            ],
            [
              1507,
              6961
            ],
            [
              1528,
              6942
            ],
            [
              1539,
              6897
            ],
            [
              1523,
              6931
            ],
            [
              1495,
              6916
            ],
            [
              1437,
              6916
            ],
            [
              1437,
              6891
            ],
            [
              1462,
              6875
            ],
            [
              1430,
              6873
            ],
            [
              1430,
              6844
            ],
            [
              1453,
              6805
            ],
            [
              1436,
              6687
            ],
            [
              1409,
              6705
            ],
            [
              1432,
              6746
            ],
            [
              1402,
              6765
            ],
            [
              1352,
              6756
            ],
            [
              1324,
              6765
            ],
            [
              1309,
              6802
            ],
            [
              1253,
              6846
            ],
            [
              1218,
              6868
            ],
            [
              1178,
              6875
            ],
            [
              1132,
              6905
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.50,
        "hc-key": "tz",
        "hc-a2": "TZ",
        "name": "United Republic of Tanzania",
        "labelrank": "3",
        "country-abbrev": "Tanz.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "TZA",
        "iso-a2": "TZ",
        "woe-id": "23424973",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4992,
              6405
            ],
            [
              4992,
              6408
            ],
            [
              4991,
              6411
            ],
            [
              4990,
              6412
            ],
            [
              4986,
              6414
            ],
            [
              4985,
              6417
            ],
            [
              4985,
              6417
            ],
            [
              4984,
              6418
            ],
            [
              4978,
              6467
            ],
            [
              4971,
              6477
            ],
            [
              4968,
              6480
            ],
            [
              4968,
              6481
            ],
            [
              4967,
              6481
            ],
            [
              4965,
              6484
            ],
            [
              4964,
              6484
            ],
            [
              4964,
              6484
            ],
            [
              4960,
              6483
            ],
            [
              4959,
              6476
            ],
            [
              4941,
              6481
            ],
            [
              4925,
              6488
            ],
            [
              4894,
              6501
            ],
            [
              4867,
              6520
            ],
            [
              4827,
              6622
            ],
            [
              4818,
              6679
            ],
            [
              4858,
              6725
            ],
            [
              4849,
              6758
            ],
            [
              4859,
              6789
            ],
            [
              4847,
              6809
            ],
            [
              4859,
              6812
            ],
            [
              4891,
              6812
            ],
            [
              4891,
              6809
            ],
            [
              4893,
              6812
            ],
            [
              4893,
              6812
            ],
            [
              4886,
              6759
            ],
            [
              4939,
              6753
            ],
            [
              4961,
              6765
            ],
            [
              4951,
              6786
            ],
            [
              4969,
              6810
            ],
            [
              5090,
              6733
            ],
            [
              5094,
              6709
            ],
            [
              5141,
              6670
            ],
            [
              5164,
              6648
            ],
            [
              5145,
              6630
            ],
            [
              5153,
              6603
            ],
            [
              5144,
              6515
            ],
            [
              5158,
              6472
            ],
            [
              5178,
              6447
            ],
            [
              5077,
              6399
            ],
            [
              4992,
              6405
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.46,
        "hc-middle-y": 0.33,
        "hc-key": "ar",
        "hc-a2": "AR",
        "name": "Argentina",
        "labelrank": "2",
        "country-abbrev": "Arg.",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "ARG",
        "iso-a2": "AR",
        "woe-id": "23424747",
        "continent": "South America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                1860,
                4757
              ],
              [
                1863,
                4754
              ],
              [
                1861,
                4754
              ],
              [
                1860,
                4757
              ]
            ]
          ],
          [
            [
              [
                1860,
                4758
              ],
              [
                1826,
                4836
              ],
              [
                1876,
                4790
              ],
              [
                1974,
                4754
              ],
              [
                1924,
                4748
              ],
              [
                1860,
                4758
              ]
            ]
          ],
          [
            [
              [
                1933,
                5689
              ],
              [
                1924,
                5623
              ],
              [
                1928,
                5602
              ],
              [
                1929,
                5531
              ],
              [
                1984,
                5486
              ],
              [
                1979,
                5470
              ],
              [
                2010,
                5431
              ],
              [
                1991,
                5380
              ],
              [
                1949,
                5359
              ],
              [
                1851,
                5340
              ],
              [
                1861,
                5334
              ],
              [
                1867,
                5279
              ],
              [
                1824,
                5268
              ],
              [
                1786,
                5285
              ],
              [
                1794,
                5238
              ],
              [
                1814,
                5221
              ],
              [
                1834,
                5234
              ],
              [
                1848,
                5208
              ],
              [
                1806,
                5174
              ],
              [
                1811,
                5119
              ],
              [
                1795,
                5125
              ],
              [
                1766,
                5078
              ],
              [
                1802,
                5046
              ],
              [
                1827,
                5044
              ],
              [
                1839,
                5007
              ],
              [
                1805,
                4971
              ],
              [
                1808,
                4934
              ],
              [
                1784,
                4922
              ],
              [
                1785,
                4897
              ],
              [
                1827,
                4847
              ],
              [
                1778,
                4859
              ],
              [
                1720,
                4860
              ],
              [
                1698,
                4876
              ],
              [
                1688,
                4910
              ],
              [
                1664,
                4906
              ],
              [
                1634,
                4951
              ],
              [
                1654,
                4996
              ],
              [
                1641,
                5012
              ],
              [
                1650,
                5058
              ],
              [
                1634,
                5095
              ],
              [
                1643,
                5110
              ],
              [
                1613,
                5134
              ],
              [
                1615,
                5165
              ],
              [
                1588,
                5199
              ],
              [
                1589,
                5233
              ],
              [
                1566,
                5284
              ],
              [
                1562,
                5350
              ],
              [
                1577,
                5359
              ],
              [
                1557,
                5398
              ],
              [
                1549,
                5445
              ],
              [
                1566,
                5462
              ],
              [
                1558,
                5497
              ],
              [
                1567,
                5533
              ],
              [
                1550,
                5586
              ],
              [
                1520,
                5636
              ],
              [
                1521,
                5720
              ],
              [
                1547,
                5807
              ],
              [
                1563,
                5815
              ],
              [
                1542,
                5897
              ],
              [
                1580,
                5927
              ],
              [
                1579,
                5972
              ],
              [
                1607,
                6012
              ],
              [
                1663,
                5996
              ],
              [
                1675,
                5970
              ],
              [
                1684,
                6004
              ],
              [
                1728,
                5995
              ],
              [
                1789,
                5934
              ],
              [
                1822,
                5926
              ],
              [
                1910,
                5871
              ],
              [
                1884,
                5799
              ],
              [
                1978,
                5794
              ],
              [
                2006,
                5825
              ],
              [
                2008,
                5866
              ],
              [
                2031,
                5864
              ],
              [
                2040,
                5805
              ],
              [
                1982,
                5764
              ],
              [
                1933,
                5689
              ]
            ],
            [
              [
                1566,
                5310
              ],
              [
                1566,
                5310
              ],
              [
                1566,
                5311
              ],
              [
                1566,
                5310
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.43,
        "hc-middle-y": 0.50,
        "hc-key": "sa",
        "hc-a2": "SA",
        "name": "Saudi Arabia",
        "labelrank": "2",
        "country-abbrev": "Saud.",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "SAU",
        "iso-a2": "SA",
        "woe-id": "23424938",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5398,
              7948
            ],
            [
              5418,
              7912
            ],
            [
              5463,
              7876
            ],
            [
              5466,
              7840
            ],
            [
              5492,
              7802
            ],
            [
              5498,
              7795
            ],
            [
              5506,
              7798
            ],
            [
              5509,
              7793
            ],
            [
              5511,
              7797
            ],
            [
              5512,
              7798
            ],
            [
              5512,
              7798
            ],
            [
              5509,
              7785
            ],
            [
              5519,
              7783
            ],
            [
              5556,
              7733
            ],
            [
              5644,
              7724
            ],
            [
              5662,
              7696
            ],
            [
              5646,
              7619
            ],
            [
              5549,
              7581
            ],
            [
              5455,
              7566
            ],
            [
              5424,
              7548
            ],
            [
              5402,
              7508
            ],
            [
              5325,
              7521
            ],
            [
              5258,
              7517
            ],
            [
              5248,
              7480
            ],
            [
              5229,
              7522
            ],
            [
              5190,
              7569
            ],
            [
              5179,
              7601
            ],
            [
              5133,
              7637
            ],
            [
              5113,
              7670
            ],
            [
              5110,
              7718
            ],
            [
              5086,
              7765
            ],
            [
              5054,
              7784
            ],
            [
              5042,
              7819
            ],
            [
              4961,
              7932
            ],
            [
              4945,
              7932
            ],
            [
              4954,
              7979
            ],
            [
              4990,
              7973
            ],
            [
              5048,
              8023
            ],
            [
              5011,
              8061
            ],
            [
              5079,
              8085
            ],
            [
              5121,
              8078
            ],
            [
              5179,
              8046
            ],
            [
              5273,
              7974
            ],
            [
              5333,
              7970
            ],
            [
              5363,
              7966
            ],
            [
              5398,
              7948
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "QA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.50,
        "hc-key": "qa",
        "hc-a2": "QA",
        "name": "Qatar",
        "labelrank": "5",
        "country-abbrev": "Qatar",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "QAT",
        "iso-a2": "QA",
        "woe-id": "23424930",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5511,
              7797
            ],
            [
              5510,
              7798
            ],
            [
              5506,
              7798
            ],
            [
              5498,
              7795
            ],
            [
              5492,
              7802
            ],
            [
              5487,
              7831
            ],
            [
              5513,
              7846
            ],
            [
              5512,
              7798
            ],
            [
              5511,
              7797
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "NL",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.98,
        "hc-middle-y": 0.03,
        "hc-key": "nl",
        "hc-a2": "NL",
        "name": "Netherlands",
        "labelrank": "5",
        "country-abbrev": "Neth.",
        "subregion": "Western Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "NLD",
        "iso-a2": "NL",
        "woe-id": "-90",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                1701,
                7544
              ],
              [
                1698,
                7544
              ],
              [
                1698,
                7545
              ],
              [
                1701,
                7544
              ]
            ]
          ],
          [
            [
              [
                3909,
                8817
              ],
              [
                3921,
                8816
              ],
              [
                3934,
                8817
              ],
              [
                3922,
                8811
              ],
              [
                3909,
                8817
              ]
            ]
          ],
          [
            [
              [
                3936,
                8817
              ],
              [
                3923,
                8826
              ],
              [
                3952,
                8885
              ],
              [
                3974,
                8895
              ],
              [
                4018,
                8886
              ],
              [
                4015,
                8849
              ],
              [
                3997,
                8834
              ],
              [
                3987,
                8794
              ],
              [
                3957,
                8821
              ],
              [
                3936,
                8817
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "YE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.35,
        "hc-middle-y": 0.50,
        "hc-key": "ye",
        "hc-a2": "YE",
        "name": "Yemen",
        "labelrank": "3",
        "country-abbrev": "Yem.",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "YEM",
        "iso-a2": "YE",
        "woe-id": "23425002",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5549,
              7581
            ],
            [
              5579,
              7516
            ],
            [
              5593,
              7490
            ],
            [
              5575,
              7483
            ],
            [
              5567,
              7451
            ],
            [
              5480,
              7417
            ],
            [
              5452,
              7390
            ],
            [
              5429,
              7391
            ],
            [
              5385,
              7367
            ],
            [
              5356,
              7365
            ],
            [
              5294,
              7335
            ],
            [
              5269,
              7358
            ],
            [
              5247,
              7449
            ],
            [
              5248,
              7480
            ],
            [
              5258,
              7517
            ],
            [
              5325,
              7521
            ],
            [
              5402,
              7508
            ],
            [
              5424,
              7548
            ],
            [
              5455,
              7566
            ],
            [
              5549,
              7581
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.61,
        "hc-middle-y": 0.64,
        "hc-key": "ae",
        "hc-a2": "AE",
        "name": "United Arab Emirates",
        "labelrank": "4",
        "country-abbrev": "U.A.E.",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "ARE",
        "iso-a2": "AE",
        "woe-id": "23424738",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5669,
              7836
            ],
            [
              5673,
              7832
            ],
            [
              5676,
              7811
            ],
            [
              5657,
              7808
            ],
            [
              5644,
              7724
            ],
            [
              5556,
              7733
            ],
            [
              5519,
              7783
            ],
            [
              5604,
              7779
            ],
            [
              5661,
              7853
            ],
            [
              5665,
              7838
            ],
            [
              5669,
              7836
            ]
          ],
          [
            [
              5671,
              7821
            ],
            [
              5673,
              7823
            ],
            [
              5669,
              7824
            ],
            [
              5670,
              7820
            ],
            [
              5671,
              7821
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.48,
        "hc-middle-y": 0.37,
        "hc-key": "ke",
        "hc-a2": "KE",
        "name": "Kenya",
        "labelrank": "2",
        "country-abbrev": "Ken.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "KEN",
        "iso-a2": "KE",
        "woe-id": "23424863",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5141,
              6670
            ],
            [
              5094,
              6709
            ],
            [
              5090,
              6733
            ],
            [
              4969,
              6810
            ],
            [
              4975,
              6840
            ],
            [
              4966,
              6860
            ],
            [
              4999,
              6914
            ],
            [
              4998,
              6945
            ],
            [
              4965,
              7012
            ],
            [
              5013,
              7044
            ],
            [
              5030,
              7028
            ],
            [
              5062,
              7021
            ],
            [
              5105,
              6989
            ],
            [
              5154,
              6981
            ],
            [
              5195,
              7015
            ],
            [
              5233,
              7003
            ],
            [
              5203,
              6958
            ],
            [
              5204,
              6817
            ],
            [
              5222,
              6785
            ],
            [
              5176,
              6744
            ],
            [
              5141,
              6670
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.42,
        "hc-middle-y": 0.50,
        "hc-key": "tr",
        "hc-a2": "TR",
        "name": "Turkey",
        "labelrank": "2",
        "country-abbrev": "Tur.",
        "subregion": "Western Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "TUR",
        "iso-a2": "TR",
        "woe-id": "23424969",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4624,
              8416
            ],
            [
              4639,
              8441
            ],
            [
              4628,
              8453
            ],
            [
              4649,
              8467
            ],
            [
              4679,
              8463
            ],
            [
              4717,
              8435
            ],
            [
              4669,
              8426
            ],
            [
              4645,
              8406
            ],
            [
              4722,
              8405
            ],
            [
              4721,
              8435
            ],
            [
              4784,
              8430
            ],
            [
              4844,
              8465
            ],
            [
              4927,
              8454
            ],
            [
              4980,
              8428
            ],
            [
              5062,
              8423
            ],
            [
              5101,
              8446
            ],
            [
              5141,
              8448
            ],
            [
              5164,
              8430
            ],
            [
              5178,
              8393
            ],
            [
              5216,
              8380
            ],
            [
              5217,
              8378
            ],
            [
              5194,
              8367
            ],
            [
              5210,
              8313
            ],
            [
              5232,
              8280
            ],
            [
              5166,
              8289
            ],
            [
              5156,
              8279
            ],
            [
              5150,
              8288
            ],
            [
              5076,
              8265
            ],
            [
              4976,
              8268
            ],
            [
              4957,
              8232
            ],
            [
              4955,
              8272
            ],
            [
              4910,
              8266
            ],
            [
              4858,
              8237
            ],
            [
              4830,
              8257
            ],
            [
              4786,
              8271
            ],
            [
              4780,
              8245
            ],
            [
              4757,
              8241
            ],
            [
              4710,
              8277
            ],
            [
              4674,
              8289
            ],
            [
              4673,
              8314
            ],
            [
              4640,
              8325
            ],
            [
              4663,
              8349
            ],
            [
              4617,
              8396
            ],
            [
              4649,
              8411
            ],
            [
              4624,
              8416
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MY",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.92,
        "hc-middle-y": 0.22,
        "hc-key": "my",
        "hc-a2": "MY",
        "name": "Malaysia",
        "labelrank": "3",
        "country-abbrev": "Malay.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "MYS",
        "iso-a2": "MY",
        "woe-id": "23424901",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                7814,
                7010
              ],
              [
                7807,
                7010
              ],
              [
                7808,
                7011
              ],
              [
                7803,
                7010
              ],
              [
                7744,
                7019
              ],
              [
                7733,
                6967
              ],
              [
                7702,
                6905
              ],
              [
                7672,
                6897
              ],
              [
                7650,
                6910
              ],
              [
                7620,
                6894
              ],
              [
                7568,
                6883
              ],
              [
                7537,
                6912
              ],
              [
                7536,
                6930
              ],
              [
                7583,
                6910
              ],
              [
                7592,
                6957
              ],
              [
                7649,
                6972
              ],
              [
                7681,
                7027
              ],
              [
                7702,
                7005
              ],
              [
                7713,
                7038
              ],
              [
                7715,
                7039
              ],
              [
                7715,
                7036
              ],
              [
                7727,
                7016
              ],
              [
                7719,
                7039
              ],
              [
                7782,
                7126
              ],
              [
                7788,
                7105
              ],
              [
                7858,
                7050
              ],
              [
                7821,
                7038
              ],
              [
                7836,
                7018
              ],
              [
                7811,
                7012
              ],
              [
                7814,
                7010
              ]
            ]
          ],
          [
            [
              [
                7207,
                7098
              ],
              [
                7239,
                7090
              ],
              [
                7242,
                7067
              ],
              [
                7273,
                7091
              ],
              [
                7322,
                7035
              ],
              [
                7324,
                6964
              ],
              [
                7355,
                6903
              ],
              [
                7323,
                6909
              ],
              [
                7272,
                6942
              ],
              [
                7231,
                6999
              ],
              [
                7207,
                7098
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "VN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.64,
        "hc-middle-y": 0.95,
        "hc-key": "vn",
        "hc-a2": "VN",
        "name": "Vietnam",
        "labelrank": "2",
        "country-abbrev": "Viet.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "VNM",
        "iso-a2": "VN",
        "woe-id": "23424984",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7206,
              7712
            ],
            [
              7215,
              7726
            ],
            [
              7266,
              7716
            ],
            [
              7305,
              7749
            ],
            [
              7347,
              7732
            ],
            [
              7361,
              7697
            ],
            [
              7407,
              7677
            ],
            [
              7350,
              7620
            ],
            [
              7343,
              7581
            ],
            [
              7386,
              7522
            ],
            [
              7469,
              7442
            ],
            [
              7504,
              7347
            ],
            [
              7495,
              7287
            ],
            [
              7439,
              7249
            ],
            [
              7424,
              7258
            ],
            [
              7415,
              7217
            ],
            [
              7360,
              7194
            ],
            [
              7356,
              7243
            ],
            [
              7343,
              7251
            ],
            [
              7385,
              7274
            ],
            [
              7440,
              7325
            ],
            [
              7430,
              7416
            ],
            [
              7432,
              7438
            ],
            [
              7385,
              7504
            ],
            [
              7313,
              7573
            ],
            [
              7282,
              7593
            ],
            [
              7314,
              7622
            ],
            [
              7279,
              7656
            ],
            [
              7249,
              7652
            ],
            [
              7239,
              7680
            ],
            [
              7206,
              7712
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.26,
        "hc-middle-y": 0.50,
        "hc-key": "pa",
        "hc-a2": "PA",
        "name": "Panama",
        "labelrank": "4",
        "country-abbrev": "Pan.",
        "subregion": "Central America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "PAN",
        "iso-a2": "PA",
        "woe-id": "23424924",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1017,
              7219
            ],
            [
              1031,
              7194
            ],
            [
              1066,
              7189
            ],
            [
              1116,
              7220
            ],
            [
              1170,
              7205
            ],
            [
              1191,
              7183
            ],
            [
              1197,
              7156
            ],
            [
              1171,
              7128
            ],
            [
              1152,
              7180
            ],
            [
              1134,
              7196
            ],
            [
              1084,
              7161
            ],
            [
              1099,
              7137
            ],
            [
              1070,
              7128
            ],
            [
              1041,
              7163
            ],
            [
              1003,
              7159
            ],
            [
              998,
              7170
            ],
            [
              998,
              7171
            ],
            [
              998,
              7171
            ],
            [
              998,
              7171
            ],
            [
              998,
              7171
            ],
            [
              1017,
              7219
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "IR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.47,
        "hc-key": "ir",
        "hc-a2": "IR",
        "name": "Iran",
        "labelrank": "2",
        "country-abbrev": "Iran",
        "subregion": "Southern Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "IRN",
        "iso-a2": "IR",
        "woe-id": "23424851",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5354,
              8331
            ],
            [
              5363,
              8304
            ],
            [
              5463,
              8259
            ],
            [
              5528,
              8268
            ],
            [
              5521,
              8288
            ],
            [
              5564,
              8317
            ],
            [
              5618,
              8324
            ],
            [
              5673,
              8302
            ],
            [
              5731,
              8261
            ],
            [
              5759,
              8258
            ],
            [
              5769,
              8221
            ],
            [
              5766,
              8122
            ],
            [
              5786,
              8062
            ],
            [
              5815,
              8057
            ],
            [
              5822,
              8037
            ],
            [
              5797,
              7999
            ],
            [
              5839,
              7948
            ],
            [
              5870,
              7937
            ],
            [
              5890,
              7875
            ],
            [
              5851,
              7860
            ],
            [
              5847,
              7820
            ],
            [
              5790,
              7825
            ],
            [
              5703,
              7842
            ],
            [
              5680,
              7894
            ],
            [
              5617,
              7870
            ],
            [
              5580,
              7878
            ],
            [
              5535,
              7913
            ],
            [
              5498,
              7925
            ],
            [
              5444,
              8012
            ],
            [
              5406,
              8020
            ],
            [
              5395,
              8003
            ],
            [
              5361,
              8042
            ],
            [
              5362,
              8072
            ],
            [
              5345,
              8096
            ],
            [
              5305,
              8118
            ],
            [
              5271,
              8157
            ],
            [
              5290,
              8228
            ],
            [
              5257,
              8235
            ],
            [
              5232,
              8280
            ],
            [
              5210,
              8313
            ],
            [
              5194,
              8367
            ],
            [
              5217,
              8378
            ],
            [
              5241,
              8353
            ],
            [
              5264,
              8348
            ],
            [
              5271,
              8350
            ],
            [
              5276,
              8348
            ],
            [
              5315,
              8380
            ],
            [
              5324,
              8346
            ],
            [
              5354,
              8331
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "HT",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.19,
        "hc-middle-y": 0.82,
        "hc-key": "ht",
        "hc-a2": "HT",
        "name": "Haiti",
        "labelrank": "5",
        "country-abbrev": "Haiti",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "HTI",
        "iso-a2": "HT",
        "woe-id": "23424839",
        "continent": "North America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                1405,
                7562
              ],
              [
                1404,
                7562
              ],
              [
                1403,
                7563
              ],
              [
                1403,
                7563
              ],
              [
                1405,
                7562
              ]
            ]
          ],
          [
            [
              [
                1402,
                7566
              ],
              [
                1403,
                7561
              ],
              [
                1405,
                7561
              ],
              [
                1411,
                7555
              ],
              [
                1407,
                7544
              ],
              [
                1398,
                7552
              ],
              [
                1334,
                7549
              ],
              [
                1330,
                7568
              ],
              [
                1377,
                7559
              ],
              [
                1381,
                7597
              ],
              [
                1359,
                7611
              ],
              [
                1415,
                7608
              ],
              [
                1412,
                7572
              ],
              [
                1402,
                7566
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "DO",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.08,
        "hc-middle-y": 0.57,
        "hc-key": "do",
        "hc-a2": "DO",
        "name": "Dominican Republic",
        "labelrank": "5",
        "country-abbrev": "Dom. Rep.",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "DOM",
        "iso-a2": "DO",
        "woe-id": "23424800",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1403,
              7563
            ],
            [
              1402,
              7566
            ],
            [
              1412,
              7572
            ],
            [
              1415,
              7608
            ],
            [
              1441,
              7617
            ],
            [
              1475,
              7607
            ],
            [
              1484,
              7585
            ],
            [
              1524,
              7568
            ],
            [
              1504,
              7558
            ],
            [
              1445,
              7559
            ],
            [
              1418,
              7527
            ],
            [
              1407,
              7544
            ],
            [
              1411,
              7555
            ],
            [
              1405,
              7561
            ],
            [
              1405,
              7562
            ],
            [
              1403,
              7563
            ],
            [
              1403,
              7563
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GW",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.56,
        "hc-middle-y": 0.49,
        "hc-key": "gw",
        "hc-a2": "GW",
        "name": "Guinea Bissau",
        "labelrank": "6",
        "country-abbrev": "GnB.",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "GNB",
        "iso-a2": "GW",
        "woe-id": "23424929",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3303,
              7272
            ],
            [
              3272,
              7297
            ],
            [
              3246,
              7325
            ],
            [
              3298,
              7338
            ],
            [
              3348,
              7338
            ],
            [
              3347,
              7301
            ],
            [
              3314,
              7292
            ],
            [
              3303,
              7272
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "HR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.37,
        "hc-middle-y": 0.60,
        "hc-key": "hr",
        "hc-a2": "HR",
        "name": "Croatia",
        "labelrank": "6",
        "country-abbrev": "Cro.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "HRV",
        "iso-a2": "HR",
        "woe-id": "23424843",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4383,
                8479
              ],
              [
                4360,
                8494
              ],
              [
                4355,
                8497
              ],
              [
                4362,
                8494
              ],
              [
                4381,
                8485
              ],
              [
                4381,
                8482
              ],
              [
                4383,
                8479
              ]
            ]
          ],
          [
            [
              [
                4224,
                8597
              ],
              [
                4277,
                8595
              ],
              [
                4284,
                8624
              ],
              [
                4310,
                8635
              ],
              [
                4336,
                8614
              ],
              [
                4384,
                8613
              ],
              [
                4391,
                8584
              ],
              [
                4391,
                8570
              ],
              [
                4380,
                8582
              ],
              [
                4292,
                8586
              ],
              [
                4290,
                8568
              ],
              [
                4353,
                8499
              ],
              [
                4324,
                8506
              ],
              [
                4275,
                8546
              ],
              [
                4247,
                8592
              ],
              [
                4253,
                8561
              ],
              [
                4224,
                8597
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TH",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.91,
        "hc-key": "th",
        "hc-a2": "TH",
        "name": "Thailand",
        "labelrank": "3",
        "country-abbrev": "Thai.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "THA",
        "iso-a2": "TH",
        "woe-id": "23424960",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7273,
              7091
            ],
            [
              7242,
              7067
            ],
            [
              7239,
              7090
            ],
            [
              7207,
              7098
            ],
            [
              7162,
              7160
            ],
            [
              7137,
              7179
            ],
            [
              7151,
              7248
            ],
            [
              7176,
              7305
            ],
            [
              7153,
              7352
            ],
            [
              7153,
              7378
            ],
            [
              7117,
              7420
            ],
            [
              7131,
              7471
            ],
            [
              7072,
              7561
            ],
            [
              7084,
              7612
            ],
            [
              7102,
              7607
            ],
            [
              7151,
              7632
            ],
            [
              7168,
              7601
            ],
            [
              7194,
              7602
            ],
            [
              7201,
              7522
            ],
            [
              7229,
              7551
            ],
            [
              7259,
              7543
            ],
            [
              7292,
              7555
            ],
            [
              7325,
              7518
            ],
            [
              7328,
              7486
            ],
            [
              7361,
              7455
            ],
            [
              7353,
              7402
            ],
            [
              7283,
              7400
            ],
            [
              7260,
              7372
            ],
            [
              7287,
              7298
            ],
            [
              7247,
              7338
            ],
            [
              7218,
              7335
            ],
            [
              7215,
              7368
            ],
            [
              7182,
              7360
            ],
            [
              7188,
              7319
            ],
            [
              7166,
              7226
            ],
            [
              7192,
              7205
            ],
            [
              7215,
              7138
            ],
            [
              7273,
              7091
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "EE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.20,
        "hc-middle-y": 0.34,
        "hc-key": "ee",
        "hc-a2": "EE",
        "name": "Estonia",
        "labelrank": "6",
        "country-abbrev": "Est.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "EST",
        "iso-a2": "EE",
        "woe-id": "23424805",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4575,
              9111
            ],
            [
              4578,
              9109
            ],
            [
              4581,
              9107
            ],
            [
              4579,
              9106
            ],
            [
              4576,
              9106
            ],
            [
              4578,
              9105
            ],
            [
              4578,
              9105
            ],
            [
              4579,
              9105
            ],
            [
              4578,
              9105
            ],
            [
              4575,
              9105
            ],
            [
              4573,
              9100
            ],
            [
              4570,
              9094
            ],
            [
              4551,
              9088
            ],
            [
              4575,
              9058
            ],
            [
              4573,
              9051
            ],
            [
              4571,
              9041
            ],
            [
              4510,
              9061
            ],
            [
              4484,
              9054
            ],
            [
              4415,
              9092
            ],
            [
              4510,
              9117
            ],
            [
              4575,
              9111
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CD",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.58,
        "hc-middle-y": 0.43,
        "hc-key": "cd",
        "hc-a2": "CD",
        "name": "Democratic Republic of the Congo",
        "labelrank": "2",
        "country-abbrev": "D.R.C.",
        "subregion": "Middle Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "COD",
        "iso-a2": "CD",
        "woe-id": "23424780",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4803,
              6722
            ],
            [
              4799,
              6655
            ],
            [
              4811,
              6592
            ],
            [
              4847,
              6534
            ],
            [
              4790,
              6524
            ],
            [
              4770,
              6500
            ],
            [
              4776,
              6489
            ],
            [
              4782,
              6473
            ],
            [
              4769,
              6410
            ],
            [
              4791,
              6374
            ],
            [
              4817,
              6382
            ],
            [
              4816,
              6334
            ],
            [
              4795,
              6333
            ],
            [
              4767,
              6371
            ],
            [
              4744,
              6377
            ],
            [
              4729,
              6405
            ],
            [
              4713,
              6388
            ],
            [
              4667,
              6402
            ],
            [
              4666,
              6419
            ],
            [
              4632,
              6412
            ],
            [
              4621,
              6432
            ],
            [
              4563,
              6417
            ],
            [
              4561,
              6468
            ],
            [
              4549,
              6488
            ],
            [
              4549,
              6570
            ],
            [
              4473,
              6581
            ],
            [
              4467,
              6542
            ],
            [
              4407,
              6539
            ],
            [
              4387,
              6569
            ],
            [
              4374,
              6622
            ],
            [
              4258,
              6625
            ],
            [
              4233,
              6617
            ],
            [
              4225,
              6628
            ],
            [
              4233,
              6656
            ],
            [
              4255,
              6672
            ],
            [
              4266,
              6662
            ],
            [
              4300,
              6686
            ],
            [
              4314,
              6665
            ],
            [
              4362,
              6723
            ],
            [
              4363,
              6768
            ],
            [
              4414,
              6830
            ],
            [
              4425,
              6933
            ],
            [
              4444,
              6984
            ],
            [
              4441,
              7017
            ],
            [
              4480,
              7048
            ],
            [
              4510,
              7020
            ],
            [
              4575,
              7011
            ],
            [
              4588,
              7036
            ],
            [
              4607,
              7029
            ],
            [
              4679,
              7057
            ],
            [
              4742,
              7045
            ],
            [
              4774,
              7015
            ],
            [
              4823,
              7025
            ],
            [
              4858,
              6984
            ],
            [
              4854,
              6944
            ],
            [
              4873,
              6934
            ],
            [
              4847,
              6908
            ],
            [
              4847,
              6898
            ],
            [
              4829,
              6882
            ],
            [
              4820,
              6846
            ],
            [
              4807,
              6827
            ],
            [
              4818,
              6832
            ],
            [
              4815,
              6815
            ],
            [
              4816,
              6797
            ],
            [
              4808,
              6792
            ],
            [
              4804,
              6785
            ],
            [
              4794,
              6774
            ],
            [
              4792,
              6755
            ],
            [
              4793,
              6748
            ],
            [
              4797,
              6745
            ],
            [
              4804,
              6733
            ],
            [
              4803,
              6722
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KW",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.61,
        "hc-middle-y": 0.42,
        "hc-key": "kw",
        "hc-a2": "KW",
        "name": "Kuwait",
        "labelrank": "6",
        "country-abbrev": "Kwt.",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "KWT",
        "iso-a2": "KW",
        "woe-id": "23424870",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5398,
              7948
            ],
            [
              5363,
              7966
            ],
            [
              5333,
              7970
            ],
            [
              5348,
              8003
            ],
            [
              5375,
              8004
            ],
            [
              5384,
              7979
            ],
            [
              5398,
              7948
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "DE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.33,
        "hc-key": "de",
        "hc-a2": "DE",
        "name": "Germany",
        "labelrank": "2",
        "country-abbrev": "Ger.",
        "subregion": "Western Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "DEU",
        "iso-a2": "DE",
        "woe-id": "23424829",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4057,
                8947
              ],
              [
                4062,
                8947
              ],
              [
                4079,
                8943
              ],
              [
                4139,
                8910
              ],
              [
                4188,
                8938
              ],
              [
                4218,
                8912
              ],
              [
                4217,
                8910
              ],
              [
                4218,
                8909
              ],
              [
                4207,
                8909
              ],
              [
                4220,
                8903
              ],
              [
                4235,
                8862
              ],
              [
                4245,
                8798
              ],
              [
                4179,
                8781
              ],
              [
                4177,
                8757
              ],
              [
                4222,
                8720
              ],
              [
                4192,
                8696
              ],
              [
                4193,
                8679
              ],
              [
                4141,
                8668
              ],
              [
                4102,
                8674
              ],
              [
                4083,
                8684
              ],
              [
                4086,
                8679
              ],
              [
                4064,
                8676
              ],
              [
                4038,
                8676
              ],
              [
                4055,
                8727
              ],
              [
                3999,
                8746
              ],
              [
                4003,
                8759
              ],
              [
                3991,
                8771
              ],
              [
                3998,
                8778
              ],
              [
                3987,
                8794
              ],
              [
                3997,
                8834
              ],
              [
                4015,
                8849
              ],
              [
                4018,
                8886
              ],
              [
                4022,
                8904
              ],
              [
                4068,
                8910
              ],
              [
                4057,
                8947
              ]
            ]
          ],
          [
            [
              [
                4086,
                8679
              ],
              [
                4087,
                8678
              ],
              [
                4087,
                8678
              ],
              [
                4086,
                8679
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.50,
        "hc-key": "cz",
        "hc-a2": "CZ",
        "name": "Czech Republic",
        "labelrank": "5",
        "country-abbrev": "Cz. Rep.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "CZE",
        "iso-a2": "CZ",
        "woe-id": "23424810",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4222,
              8720
            ],
            [
              4177,
              8757
            ],
            [
              4179,
              8781
            ],
            [
              4245,
              8798
            ],
            [
              4293,
              8788
            ],
            [
              4359,
              8763
            ],
            [
              4368,
              8748
            ],
            [
              4348,
              8732
            ],
            [
              4316,
              8714
            ],
            [
              4256,
              8728
            ],
            [
              4222,
              8720
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "IE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.44,
        "hc-middle-y": 0.47,
        "hc-key": "ie",
        "hc-a2": "IE",
        "name": "Ireland",
        "labelrank": "3",
        "country-abbrev": "Ire.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "IRL",
        "iso-a2": "IE",
        "woe-id": "23424803",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3606,
              8953
            ],
            [
              3578,
              8931
            ],
            [
              3632,
              8917
            ],
            [
              3638,
              8876
            ],
            [
              3626,
              8847
            ],
            [
              3595,
              8845
            ],
            [
              3524,
              8820
            ],
            [
              3508,
              8836
            ],
            [
              3551,
              8887
            ],
            [
              3532,
              8886
            ],
            [
              3526,
              8925
            ],
            [
              3565,
              8923
            ],
            [
              3576,
              8956
            ],
            [
              3606,
              8953
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.21,
        "hc-middle-y": 0.48,
        "hc-key": "mm",
        "hc-a2": "MM",
        "name": "Myanmar",
        "labelrank": "3",
        "country-abbrev": "Myan.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "MMR",
        "iso-a2": "MM",
        "woe-id": "23424763",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6885,
              7660
            ],
            [
              6897,
              7669
            ],
            [
              6891,
              7696
            ],
            [
              6908,
              7711
            ],
            [
              6903,
              7773
            ],
            [
              6930,
              7767
            ],
            [
              6948,
              7840
            ],
            [
              6943,
              7869
            ],
            [
              6991,
              7903
            ],
            [
              7003,
              7936
            ],
            [
              7008,
              7948
            ],
            [
              7054,
              7910
            ],
            [
              7068,
              7846
            ],
            [
              7041,
              7815
            ],
            [
              7047,
              7768
            ],
            [
              7077,
              7776
            ],
            [
              7092,
              7742
            ],
            [
              7114,
              7737
            ],
            [
              7108,
              7702
            ],
            [
              7135,
              7698
            ],
            [
              7147,
              7674
            ],
            [
              7179,
              7679
            ],
            [
              7166,
              7670
            ],
            [
              7151,
              7632
            ],
            [
              7102,
              7607
            ],
            [
              7084,
              7612
            ],
            [
              7072,
              7561
            ],
            [
              7131,
              7471
            ],
            [
              7117,
              7420
            ],
            [
              7153,
              7378
            ],
            [
              7153,
              7352
            ],
            [
              7176,
              7305
            ],
            [
              7151,
              7248
            ],
            [
              7135,
              7357
            ],
            [
              7111,
              7383
            ],
            [
              7091,
              7476
            ],
            [
              7072,
              7505
            ],
            [
              7018,
              7455
            ],
            [
              6976,
              7467
            ],
            [
              6982,
              7525
            ],
            [
              6960,
              7574
            ],
            [
              6935,
              7595
            ],
            [
              6885,
              7660
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GQ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.54,
        "hc-middle-y": 0.55,
        "hc-key": "gq",
        "hc-a2": "GQ",
        "name": "Equatorial Guinea",
        "labelrank": "4",
        "country-abbrev": "Eq. G.",
        "subregion": "Middle Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "GNQ",
        "iso-a2": "GQ",
        "woe-id": "23424804",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4144,
              6888
            ],
            [
              4129,
              6896
            ],
            [
              4144,
              6940
            ],
            [
              4151,
              6933
            ],
            [
              4196,
              6933
            ],
            [
              4196,
              6889
            ],
            [
              4144,
              6888
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "UG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.70,
        "hc-key": "ug",
        "hc-a2": "UG",
        "name": "Uganda",
        "labelrank": "3",
        "country-abbrev": "Uga.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "UGA",
        "iso-a2": "UG",
        "woe-id": "23424974",
        "continent": "Africa"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4893,
                6812
              ],
              [
                4893,
                6812
              ],
              [
                4893,
                6812
              ],
              [
                4893,
                6812
              ]
            ]
          ],
          [
            [
              [
                4891,
                6812
              ],
              [
                4859,
                6812
              ],
              [
                4847,
                6809
              ],
              [
                4828,
                6793
              ],
              [
                4816,
                6797
              ],
              [
                4815,
                6815
              ],
              [
                4818,
                6832
              ],
              [
                4827,
                6844
              ],
              [
                4820,
                6846
              ],
              [
                4829,
                6882
              ],
              [
                4847,
                6898
              ],
              [
                4878,
                6924
              ],
              [
                4873,
                6934
              ],
              [
                4854,
                6944
              ],
              [
                4858,
                6984
              ],
              [
                4890,
                6997
              ],
              [
                4904,
                6986
              ],
              [
                4948,
                6994
              ],
              [
                4965,
                7012
              ],
              [
                4998,
                6945
              ],
              [
                4999,
                6914
              ],
              [
                4966,
                6860
              ],
              [
                4941,
                6862
              ],
              [
                4896,
                6845
              ],
              [
                4891,
                6812
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.61,
        "hc-middle-y": 0.49,
        "hc-key": "kz",
        "hc-a2": "KZ",
        "name": "Kazakhstan",
        "labelrank": "3",
        "country-abbrev": "Kaz.",
        "subregion": "Central Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "KAZ",
        "iso-a2": "KZ",
        "woe-id": "-90",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5590,
              8599
            ],
            [
              5516,
              8575
            ],
            [
              5552,
              8438
            ],
            [
              5538,
              8436
            ],
            [
              5488,
              8476
            ],
            [
              5438,
              8454
            ],
            [
              5438,
              8491
            ],
            [
              5413,
              8495
            ],
            [
              5347,
              8563
            ],
            [
              5373,
              8591
            ],
            [
              5407,
              8594
            ],
            [
              5418,
              8616
            ],
            [
              5409,
              8650
            ],
            [
              5351,
              8658
            ],
            [
              5298,
              8628
            ],
            [
              5250,
              8683
            ],
            [
              5222,
              8684
            ],
            [
              5197,
              8707
            ],
            [
              5196,
              8760
            ],
            [
              5209,
              8783
            ],
            [
              5241,
              8759
            ],
            [
              5241,
              8788
            ],
            [
              5285,
              8827
            ],
            [
              5368,
              8822
            ],
            [
              5447,
              8786
            ],
            [
              5465,
              8806
            ],
            [
              5527,
              8804
            ],
            [
              5568,
              8786
            ],
            [
              5611,
              8795
            ],
            [
              5606,
              8819
            ],
            [
              5561,
              8836
            ],
            [
              5566,
              8865
            ],
            [
              5599,
              8882
            ],
            [
              5557,
              8910
            ],
            [
              5672,
              8926
            ],
            [
              5746,
              8949
            ],
            [
              5745,
              8957
            ],
            [
              5816,
              8961
            ],
            [
              5846,
              8918
            ],
            [
              5915,
              8912
            ],
            [
              5942,
              8899
            ],
            [
              5997,
              8930
            ],
            [
              6001,
              8912
            ],
            [
              6052,
              8887
            ],
            [
              6156,
              8796
            ],
            [
              6169,
              8815
            ],
            [
              6201,
              8793
            ],
            [
              6255,
              8803
            ],
            [
              6333,
              8751
            ],
            [
              6372,
              8751
            ],
            [
              6403,
              8732
            ],
            [
              6369,
              8707
            ],
            [
              6383,
              8656
            ],
            [
              6364,
              8647
            ],
            [
              6306,
              8661
            ],
            [
              6309,
              8599
            ],
            [
              6249,
              8579
            ],
            [
              6299,
              8507
            ],
            [
              6294,
              8471
            ],
            [
              6230,
              8497
            ],
            [
              6130,
              8495
            ],
            [
              6094,
              8511
            ],
            [
              6084,
              8479
            ],
            [
              6027,
              8495
            ],
            [
              6007,
              8473
            ],
            [
              5958,
              8440
            ],
            [
              5953,
              8411
            ],
            [
              5926,
              8434
            ],
            [
              5887,
              8434
            ],
            [
              5840,
              8497
            ],
            [
              5803,
              8528
            ],
            [
              5717,
              8519
            ],
            [
              5642,
              8570
            ],
            [
              5624,
              8613
            ],
            [
              5605,
              8605
            ],
            [
              5602,
              8609
            ],
            [
              5599,
              8603
            ],
            [
              5590,
              8599
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.60,
        "hc-middle-y": 0.76,
        "hc-key": "kr",
        "hc-a2": "KR",
        "name": "South Korea",
        "labelrank": "2",
        "country-abbrev": "S.K.",
        "subregion": "Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "KOR",
        "iso-a2": "KR",
        "woe-id": "23424868",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7820,
              8307
            ],
            [
              7827,
              8326
            ],
            [
              7859,
              8338
            ],
            [
              7915,
              8286
            ],
            [
              7950,
              8217
            ],
            [
              7936,
              8186
            ],
            [
              7909,
              8195
            ],
            [
              7860,
              8170
            ],
            [
              7860,
              8228
            ],
            [
              7822,
              8266
            ],
            [
              7837,
              8277
            ],
            [
              7820,
              8307
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TL",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.60,
        "hc-middle-y": 0.21,
        "hc-key": "tl",
        "hc-a2": "TL",
        "name": "East Timor",
        "labelrank": "5",
        "country-abbrev": "T.L.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "TLS",
        "iso-a2": "TL",
        "woe-id": "23424968",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                8009,
                6491
              ],
              [
                8016,
                6495
              ],
              [
                8024,
                6497
              ],
              [
                8016,
                6485
              ],
              [
                8009,
                6491
              ]
            ]
          ],
          [
            [
              [
                8040,
                6505
              ],
              [
                8048,
                6517
              ],
              [
                8123,
                6526
              ],
              [
                8044,
                6485
              ],
              [
                8041,
                6496
              ],
              [
                8040,
                6505
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.59,
        "hc-middle-y": 0.70,
        "hc-key": "mr",
        "hc-a2": "MR",
        "name": "Mauritania",
        "labelrank": "3",
        "country-abbrev": "Mrt.",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "MRT",
        "iso-a2": "MR",
        "woe-id": "23424896",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3526,
              7900
            ],
            [
              3629,
              7828
            ],
            [
              3652,
              7812
            ],
            [
              3593,
              7812
            ],
            [
              3626,
              7446
            ],
            [
              3450,
              7444
            ],
            [
              3417,
              7448
            ],
            [
              3398,
              7419
            ],
            [
              3330,
              7490
            ],
            [
              3263,
              7483
            ],
            [
              3255,
              7458
            ],
            [
              3274,
              7541
            ],
            [
              3259,
              7596
            ],
            [
              3271,
              7628
            ],
            [
              3247,
              7664
            ],
            [
              3242,
              7649
            ],
            [
              3246,
              7671
            ],
            [
              3378,
              7671
            ],
            [
              3379,
              7736
            ],
            [
              3412,
              7753
            ],
            [
              3415,
              7850
            ],
            [
              3524,
              7850
            ],
            [
              3526,
              7900
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "DZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.50,
        "hc-key": "dz",
        "hc-a2": "DZ",
        "name": "Algeria",
        "labelrank": "3",
        "country-abbrev": "Alg.",
        "subregion": "Northern Africa",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "DZA",
        "iso-a2": "DZ",
        "woe-id": "23424740",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3652,
              7812
            ],
            [
              3629,
              7828
            ],
            [
              3526,
              7900
            ],
            [
              3526,
              7914
            ],
            [
              3527,
              7953
            ],
            [
              3562,
              7981
            ],
            [
              3623,
              7989
            ],
            [
              3692,
              8032
            ],
            [
              3692,
              8067
            ],
            [
              3730,
              8086
            ],
            [
              3771,
              8084
            ],
            [
              3777,
              8101
            ],
            [
              3757,
              8128
            ],
            [
              3754,
              8187
            ],
            [
              3740,
              8200
            ],
            [
              3844,
              8255
            ],
            [
              3904,
              8267
            ],
            [
              3963,
              8271
            ],
            [
              3978,
              8261
            ],
            [
              4046,
              8278
            ],
            [
              4084,
              8273
            ],
            [
              4075,
              8183
            ],
            [
              4052,
              8154
            ],
            [
              4081,
              8101
            ],
            [
              4104,
              8084
            ],
            [
              4121,
              8013
            ],
            [
              4133,
              7971
            ],
            [
              4135,
              7870
            ],
            [
              4121,
              7855
            ],
            [
              4143,
              7806
            ],
            [
              4193,
              7785
            ],
            [
              4208,
              7755
            ],
            [
              4060,
              7653
            ],
            [
              4005,
              7598
            ],
            [
              3952,
              7587
            ],
            [
              3915,
              7586
            ],
            [
              3918,
              7612
            ],
            [
              3874,
              7628
            ],
            [
              3849,
              7662
            ],
            [
              3652,
              7812
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.70,
        "hc-middle-y": 0.71,
        "hc-key": "pe",
        "hc-a2": "PE",
        "name": "Peru",
        "labelrank": "2",
        "country-abbrev": "Peru",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "PER",
        "iso-a2": "PE",
        "woe-id": "23424919",
        "continent": "South America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1479,
              6253
            ],
            [
              1458,
              6240
            ],
            [
              1490,
              6226
            ],
            [
              1492,
              6227
            ],
            [
              1495,
              6226
            ],
            [
              1491,
              6215
            ],
            [
              1494,
              6213
            ],
            [
              1475,
              6185
            ],
            [
              1481,
              6177
            ],
            [
              1469,
              6148
            ],
            [
              1455,
              6145
            ],
            [
              1414,
              6185
            ],
            [
              1283,
              6259
            ],
            [
              1241,
              6308
            ],
            [
              1241,
              6336
            ],
            [
              1187,
              6416
            ],
            [
              1135,
              6534
            ],
            [
              1100,
              6589
            ],
            [
              1060,
              6616
            ],
            [
              1053,
              6687
            ],
            [
              1083,
              6720
            ],
            [
              1077,
              6693
            ],
            [
              1128,
              6657
            ],
            [
              1150,
              6719
            ],
            [
              1206,
              6751
            ],
            [
              1243,
              6791
            ],
            [
              1253,
              6846
            ],
            [
              1309,
              6802
            ],
            [
              1324,
              6765
            ],
            [
              1352,
              6756
            ],
            [
              1402,
              6765
            ],
            [
              1432,
              6746
            ],
            [
              1409,
              6705
            ],
            [
              1436,
              6687
            ],
            [
              1408,
              6690
            ],
            [
              1337,
              6653
            ],
            [
              1331,
              6604
            ],
            [
              1303,
              6560
            ],
            [
              1369,
              6465
            ],
            [
              1402,
              6468
            ],
            [
              1424,
              6487
            ],
            [
              1423,
              6426
            ],
            [
              1459,
              6429
            ],
            [
              1493,
              6369
            ],
            [
              1482,
              6324
            ],
            [
              1492,
              6304
            ],
            [
              1479,
              6253
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AO",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.64,
        "hc-key": "ao",
        "hc-a2": "AO",
        "name": "Angola",
        "labelrank": "3",
        "country-abbrev": "Ang.",
        "subregion": "Middle Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "AGO",
        "iso-a2": "AO",
        "woe-id": "23424745",
        "continent": "Africa"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4225,
                6628
              ],
              [
                4226,
                6640
              ],
              [
                4219,
                6657
              ],
              [
                4244,
                6681
              ],
              [
                4255,
                6672
              ],
              [
                4233,
                6656
              ],
              [
                4225,
                6628
              ]
            ]
          ],
          [
            [
              [
                4206,
                6186
              ],
              [
                4206,
                6242
              ],
              [
                4224,
                6283
              ],
              [
                4233,
                6334
              ],
              [
                4272,
                6379
              ],
              [
                4277,
                6439
              ],
              [
                4251,
                6500
              ],
              [
                4264,
                6529
              ],
              [
                4227,
                6615
              ],
              [
                4258,
                6625
              ],
              [
                4374,
                6622
              ],
              [
                4387,
                6569
              ],
              [
                4407,
                6539
              ],
              [
                4467,
                6542
              ],
              [
                4473,
                6581
              ],
              [
                4549,
                6570
              ],
              [
                4549,
                6488
              ],
              [
                4561,
                6468
              ],
              [
                4563,
                6417
              ],
              [
                4621,
                6432
              ],
              [
                4621,
                6350
              ],
              [
                4552,
                6350
              ],
              [
                4550,
                6228
              ],
              [
                4595,
                6171
              ],
              [
                4508,
                6156
              ],
              [
                4440,
                6167
              ],
              [
                4430,
                6181
              ],
              [
                4279,
                6180
              ],
              [
                4253,
                6198
              ],
              [
                4206,
                6186
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.86,
        "hc-middle-y": 0.24,
        "hc-key": "mz",
        "hc-a2": "MZ",
        "name": "Mozambique",
        "labelrank": "3",
        "country-abbrev": "Moz.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "MOZ",
        "iso-a2": "MZ",
        "woe-id": "23424902",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4986,
              6330
            ],
            [
              4982,
              6381
            ],
            [
              4992,
              6405
            ],
            [
              5077,
              6399
            ],
            [
              5178,
              6447
            ],
            [
              5186,
              6281
            ],
            [
              5151,
              6219
            ],
            [
              5053,
              6163
            ],
            [
              4976,
              6086
            ],
            [
              4967,
              6064
            ],
            [
              4992,
              6000
            ],
            [
              4973,
              5904
            ],
            [
              4897,
              5867
            ],
            [
              4884,
              5852
            ],
            [
              4894,
              5817
            ],
            [
              4876,
              5817
            ],
            [
              4868,
              5817
            ],
            [
              4867,
              5839
            ],
            [
              4865,
              5851
            ],
            [
              4870,
              5910
            ],
            [
              4851,
              5988
            ],
            [
              4890,
              6031
            ],
            [
              4913,
              6079
            ],
            [
              4906,
              6101
            ],
            [
              4917,
              6144
            ],
            [
              4918,
              6208
            ],
            [
              4833,
              6249
            ],
            [
              4828,
              6274
            ],
            [
              4930,
              6311
            ],
            [
              4944,
              6288
            ],
            [
              4968,
              6297
            ],
            [
              4974,
              6262
            ],
            [
              4961,
              6239
            ],
            [
              4995,
              6191
            ],
            [
              4990,
              6214
            ],
            [
              5013,
              6233
            ],
            [
              5018,
              6286
            ],
            [
              4986,
              6330
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.18,
        "hc-middle-y": 0.10,
        "hc-key": "cr",
        "hc-a2": "CR",
        "name": "Costa Rica",
        "labelrank": "5",
        "country-abbrev": "C.R.",
        "subregion": "Central America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "CRI",
        "iso-a2": "CR",
        "woe-id": "23424791",
        "continent": "North America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                984,
                7270
              ],
              [
                989,
                7254
              ],
              [
                1017,
                7219
              ],
              [
                998,
                7171
              ],
              [
                998,
                7171
              ],
              [
                995,
                7182
              ],
              [
                946,
                7221
              ],
              [
                931,
                7218
              ],
              [
                907,
                7248
              ],
              [
                915,
                7276
              ],
              [
                960,
                7273
              ],
              [
                984,
                7270
              ]
            ]
          ],
          [
            [
              [
                1003,
                7159
              ],
              [
                998,
                7170
              ],
              [
                998,
                7171
              ],
              [
                998,
                7171
              ],
              [
                1003,
                7159
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SV",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.55,
        "hc-key": "sv",
        "hc-a2": "SV",
        "name": "El Salvador",
        "labelrank": "6",
        "country-abbrev": "El. S.",
        "subregion": "Central America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "SLV",
        "iso-a2": "SV",
        "woe-id": "23424807",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              850,
              7366
            ],
            [
              817,
              7360
            ],
            [
              775,
              7378
            ],
            [
              775,
              7382
            ],
            [
              802,
              7405
            ],
            [
              856,
              7382
            ],
            [
              850,
              7366
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GT",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.77,
        "hc-key": "gt",
        "hc-a2": "GT",
        "name": "Guatemala",
        "labelrank": "3",
        "country-abbrev": "Guat.",
        "subregion": "Central America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "GTM",
        "iso-a2": "GT",
        "woe-id": "23424834",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              823,
              7462
            ],
            [
              833,
              7455
            ],
            [
              846,
              7455
            ],
            [
              811,
              7429
            ],
            [
              802,
              7405
            ],
            [
              775,
              7382
            ],
            [
              775,
              7378
            ],
            [
              735,
              7387
            ],
            [
              706,
              7410
            ],
            [
              730,
              7468
            ],
            [
              776,
              7480
            ],
            [
              745,
              7514
            ],
            [
              764,
              7536
            ],
            [
              824,
              7535
            ],
            [
              812,
              7462
            ],
            [
              823,
              7462
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.55,
        "hc-middle-y": 0.50,
        "hc-key": "bz",
        "hc-a2": "BZ",
        "name": "Belize",
        "labelrank": "6",
        "country-abbrev": "Belize",
        "subregion": "Central America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "BLZ",
        "iso-a2": "BZ",
        "woe-id": "23424760",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              824,
              7535
            ],
            [
              834,
              7538
            ],
            [
              856,
              7561
            ],
            [
              852,
              7503
            ],
            [
              823,
              7462
            ],
            [
              812,
              7462
            ],
            [
              824,
              7535
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "VE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.61,
        "hc-middle-y": 0.47,
        "hc-key": "ve",
        "hc-a2": "VE",
        "name": "Venezuela",
        "labelrank": "3",
        "country-abbrev": "Ven.",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "VEN",
        "iso-a2": "VE",
        "woe-id": "23424982",
        "continent": "South America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1778,
              7179
            ],
            [
              1729,
              7077
            ],
            [
              1750,
              7050
            ],
            [
              1721,
              7014
            ],
            [
              1616,
              7003
            ],
            [
              1631,
              6988
            ],
            [
              1635,
              6945
            ],
            [
              1658,
              6943
            ],
            [
              1632,
              6911
            ],
            [
              1583,
              6875
            ],
            [
              1539,
              6897
            ],
            [
              1528,
              6942
            ],
            [
              1507,
              6961
            ],
            [
              1525,
              6982
            ],
            [
              1507,
              7024
            ],
            [
              1522,
              7089
            ],
            [
              1456,
              7086
            ],
            [
              1434,
              7118
            ],
            [
              1367,
              7123
            ],
            [
              1359,
              7170
            ],
            [
              1340,
              7208
            ],
            [
              1345,
              7251
            ],
            [
              1380,
              7299
            ],
            [
              1402,
              7306
            ],
            [
              1382,
              7297
            ],
            [
              1391,
              7263
            ],
            [
              1371,
              7228
            ],
            [
              1390,
              7198
            ],
            [
              1408,
              7225
            ],
            [
              1391,
              7266
            ],
            [
              1448,
              7293
            ],
            [
              1485,
              7291
            ],
            [
              1514,
              7253
            ],
            [
              1578,
              7257
            ],
            [
              1603,
              7272
            ],
            [
              1622,
              7244
            ],
            [
              1646,
              7260
            ],
            [
              1691,
              7264
            ],
            [
              1702,
              7224
            ],
            [
              1726,
              7231
            ],
            [
              1754,
              7208
            ],
            [
              1742,
              7188
            ],
            [
              1778,
              7179
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GY",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.70,
        "hc-middle-y": 0.27,
        "hc-key": "gy",
        "hc-a2": "GY",
        "name": "Guyana",
        "labelrank": "4",
        "country-abbrev": "Guy.",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "GUY",
        "iso-a2": "GY",
        "woe-id": "23424836",
        "continent": "South America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1750,
              7050
            ],
            [
              1729,
              7077
            ],
            [
              1778,
              7179
            ],
            [
              1809,
              7158
            ],
            [
              1872,
              7084
            ],
            [
              1869,
              7061
            ],
            [
              1840,
              7011
            ],
            [
              1892,
              6925
            ],
            [
              1871,
              6928
            ],
            [
              1812,
              6896
            ],
            [
              1781,
              6921
            ],
            [
              1773,
              6954
            ],
            [
              1790,
              7002
            ],
            [
              1770,
              7023
            ],
            [
              1775,
              7046
            ],
            [
              1750,
              7050
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "HN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.98,
        "hc-middle-y": 0.32,
        "hc-key": "hn",
        "hc-a2": "HN",
        "name": "Honduras",
        "labelrank": "5",
        "country-abbrev": "Hond.",
        "subregion": "Central America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "HND",
        "iso-a2": "HN",
        "woe-id": "23424841",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              802,
              7405
            ],
            [
              811,
              7429
            ],
            [
              846,
              7455
            ],
            [
              924,
              7466
            ],
            [
              978,
              7458
            ],
            [
              1014,
              7427
            ],
            [
              950,
              7417
            ],
            [
              923,
              7387
            ],
            [
              888,
              7380
            ],
            [
              866,
              7350
            ],
            [
              860,
              7361
            ],
            [
              850,
              7366
            ],
            [
              856,
              7382
            ],
            [
              802,
              7405
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "NI",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.41,
        "hc-middle-y": 0.74,
        "hc-key": "ni",
        "hc-a2": "NI",
        "name": "Nicaragua",
        "labelrank": "5",
        "country-abbrev": "Nic.",
        "subregion": "Central America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "NIC",
        "iso-a2": "NI",
        "woe-id": "23424915",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              915,
              7276
            ],
            [
              854,
              7345
            ],
            [
              866,
              7350
            ],
            [
              888,
              7380
            ],
            [
              923,
              7387
            ],
            [
              950,
              7417
            ],
            [
              1014,
              7427
            ],
            [
              994,
              7366
            ],
            [
              984,
              7270
            ],
            [
              960,
              7273
            ],
            [
              915,
              7276
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MW",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.26,
        "hc-middle-y": 0.35,
        "hc-key": "mw",
        "hc-a2": "MW",
        "name": "Malawi",
        "labelrank": "6",
        "country-abbrev": "Mal.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "MWI",
        "iso-a2": "MW",
        "woe-id": "23424889",
        "continent": "Africa"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4991,
                6411
              ],
              [
                4990,
                6411
              ],
              [
                4990,
                6412
              ],
              [
                4991,
                6411
              ]
            ]
          ],
          [
            [
              [
                4985,
                6417
              ],
              [
                4985,
                6417
              ],
              [
                4984,
                6418
              ],
              [
                4985,
                6417
              ],
              [
                4985,
                6417
              ]
            ]
          ],
          [
            [
              [
                4971,
                6477
              ],
              [
                4968,
                6481
              ],
              [
                4968,
                6480
              ],
              [
                4971,
                6477
              ]
            ]
          ],
          [
            [
              [
                4965,
                6484
              ],
              [
                4964,
                6484
              ],
              [
                4964,
                6484
              ],
              [
                4965,
                6484
              ]
            ]
          ],
          [
            [
              [
                4925,
                6488
              ],
              [
                4941,
                6481
              ],
              [
                4959,
                6476
              ],
              [
                4970,
                6401
              ],
              [
                4961,
                6375
              ],
              [
                4968,
                6336
              ],
              [
                4998,
                6296
              ],
              [
                4986,
                6330
              ],
              [
                5018,
                6286
              ],
              [
                5013,
                6233
              ],
              [
                4990,
                6214
              ],
              [
                4995,
                6191
              ],
              [
                4961,
                6239
              ],
              [
                4974,
                6262
              ],
              [
                4968,
                6297
              ],
              [
                4944,
                6288
              ],
              [
                4930,
                6311
              ],
              [
                4917,
                6323
              ],
              [
                4937,
                6368
              ],
              [
                4935,
                6432
              ],
              [
                4950,
                6443
              ],
              [
                4925,
                6488
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.40,
        "hc-middle-y": 0.41,
        "hc-key": "tm",
        "hc-a2": "TM",
        "name": "Turkmenistan",
        "labelrank": "4",
        "country-abbrev": "Turkm.",
        "subregion": "Central Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "TKM",
        "iso-a2": "TM",
        "woe-id": "23424972",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5580,
              8461
            ],
            [
              5607,
              8452
            ],
            [
              5596,
              8470
            ],
            [
              5619,
              8493
            ],
            [
              5663,
              8475
            ],
            [
              5680,
              8441
            ],
            [
              5742,
              8426
            ],
            [
              5767,
              8389
            ],
            [
              5884,
              8323
            ],
            [
              5916,
              8315
            ],
            [
              5921,
              8289
            ],
            [
              5876,
              8284
            ],
            [
              5866,
              8246
            ],
            [
              5805,
              8202
            ],
            [
              5769,
              8221
            ],
            [
              5759,
              8258
            ],
            [
              5731,
              8261
            ],
            [
              5673,
              8302
            ],
            [
              5618,
              8324
            ],
            [
              5564,
              8317
            ],
            [
              5521,
              8288
            ],
            [
              5511,
              8350
            ],
            [
              5482,
              8373
            ],
            [
              5489,
              8390
            ],
            [
              5459,
              8399
            ],
            [
              5461,
              8425
            ],
            [
              5488,
              8412
            ],
            [
              5515,
              8431
            ],
            [
              5481,
              8466
            ],
            [
              5438,
              8454
            ],
            [
              5488,
              8476
            ],
            [
              5538,
              8436
            ],
            [
              5552,
              8438
            ],
            [
              5585,
              8436
            ],
            [
              5580,
              8461
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "ZM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.31,
        "hc-middle-y": 0.68,
        "hc-key": "zm",
        "hc-a2": "ZM",
        "name": "Zambia",
        "labelrank": "3",
        "country-abbrev": "Zambia",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "ZMB",
        "iso-a2": "ZM",
        "woe-id": "23425003",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4776,
              6489
            ],
            [
              4798,
              6516
            ],
            [
              4790,
              6524
            ],
            [
              4847,
              6534
            ],
            [
              4862,
              6512
            ],
            [
              4867,
              6520
            ],
            [
              4894,
              6501
            ],
            [
              4925,
              6488
            ],
            [
              4950,
              6443
            ],
            [
              4935,
              6432
            ],
            [
              4937,
              6368
            ],
            [
              4917,
              6323
            ],
            [
              4930,
              6311
            ],
            [
              4828,
              6274
            ],
            [
              4833,
              6249
            ],
            [
              4781,
              6233
            ],
            [
              4777,
              6214
            ],
            [
              4754,
              6202
            ],
            [
              4735,
              6191
            ],
            [
              4716,
              6159
            ],
            [
              4705,
              6155
            ],
            [
              4657,
              6165
            ],
            [
              4623,
              6178
            ],
            [
              4595,
              6171
            ],
            [
              4550,
              6228
            ],
            [
              4552,
              6350
            ],
            [
              4621,
              6350
            ],
            [
              4621,
              6432
            ],
            [
              4632,
              6412
            ],
            [
              4666,
              6419
            ],
            [
              4667,
              6402
            ],
            [
              4713,
              6388
            ],
            [
              4729,
              6405
            ],
            [
              4744,
              6377
            ],
            [
              4767,
              6371
            ],
            [
              4795,
              6333
            ],
            [
              4816,
              6334
            ],
            [
              4817,
              6382
            ],
            [
              4791,
              6374
            ],
            [
              4769,
              6410
            ],
            [
              4782,
              6473
            ],
            [
              4776,
              6489
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "NC",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.58,
        "hc-middle-y": 0.72,
        "hc-key": "nc",
        "hc-a2": "NC",
        "name": "Northern Cyprus",
        "labelrank": "6",
        "country-abbrev": "N. Cy.",
        "subregion": "Western Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "-99",
        "iso-a2": "NC",
        "woe-id": "-90",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4897,
                8199
              ],
              [
                4893,
                8198
              ],
              [
                4890,
                8198
              ],
              [
                4881,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4858,
                8204
              ],
              [
                4858,
                8204
              ],
              [
                4916,
                8224
              ],
              [
                4900,
                8199
              ],
              [
                4898,
                8199
              ],
              [
                4897,
                8199
              ]
            ]
          ],
          [
            [
              [
                4855,
                8204
              ],
              [
                4856,
                8204
              ],
              [
                4856,
                8203
              ],
              [
                4855,
                8204
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "ZA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.39,
        "hc-middle-y": 0.64,
        "hc-key": "za",
        "hc-a2": "ZA",
        "name": "South Africa",
        "labelrank": "2",
        "country-abbrev": "S.Af.",
        "subregion": "Southern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "ZAF",
        "iso-a2": "ZA",
        "woe-id": "23424942",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4868,
              5817
            ],
            [
              4876,
              5817
            ],
            [
              4894,
              5817
            ],
            [
              4872,
              5751
            ],
            [
              4830,
              5713
            ],
            [
              4800,
              5663
            ],
            [
              4746,
              5608
            ],
            [
              4684,
              5561
            ],
            [
              4610,
              5535
            ],
            [
              4538,
              5543
            ],
            [
              4514,
              5529
            ],
            [
              4441,
              5512
            ],
            [
              4406,
              5548
            ],
            [
              4388,
              5588
            ],
            [
              4402,
              5594
            ],
            [
              4401,
              5631
            ],
            [
              4374,
              5683
            ],
            [
              4351,
              5751
            ],
            [
              4365,
              5770
            ],
            [
              4381,
              5746
            ],
            [
              4437,
              5736
            ],
            [
              4466,
              5757
            ],
            [
              4472,
              5898
            ],
            [
              4498,
              5845
            ],
            [
              4492,
              5815
            ],
            [
              4524,
              5817
            ],
            [
              4561,
              5850
            ],
            [
              4572,
              5877
            ],
            [
              4631,
              5856
            ],
            [
              4656,
              5864
            ],
            [
              4667,
              5898
            ],
            [
              4700,
              5917
            ],
            [
              4707,
              5941
            ],
            [
              4748,
              5978
            ],
            [
              4787,
              5997
            ],
            [
              4818,
              5991
            ],
            [
              4851,
              5988
            ],
            [
              4870,
              5910
            ],
            [
              4865,
              5851
            ],
            [
              4849,
              5860
            ],
            [
              4826,
              5834
            ],
            [
              4835,
              5804
            ],
            [
              4862,
              5799
            ],
            [
              4868,
              5817
            ]
          ],
          [
            [
              4694,
              5711
            ],
            [
              4725,
              5671
            ],
            [
              4773,
              5721
            ],
            [
              4749,
              5751
            ],
            [
              4694,
              5711
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LT",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.18,
        "hc-middle-y": 0.47,
        "hc-key": "lt",
        "hc-a2": "LT",
        "name": "Lithuania",
        "labelrank": "5",
        "country-abbrev": "Lith.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "LTU",
        "iso-a2": "LT",
        "woe-id": "23424875",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4413,
                8959
              ],
              [
                4408,
                8975
              ],
              [
                4403,
                8989
              ],
              [
                4431,
                9002
              ],
              [
                4532,
                8992
              ],
              [
                4562,
                8974
              ],
              [
                4538,
                8925
              ],
              [
                4483,
                8912
              ],
              [
                4481,
                8920
              ],
              [
                4461,
                8927
              ],
              [
                4459,
                8946
              ],
              [
                4413,
                8959
              ]
            ]
          ],
          [
            [
              [
                4403,
                8961
              ],
              [
                4407,
                8968
              ],
              [
                4405,
                8960
              ],
              [
                4403,
                8961
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "ET",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.43,
        "hc-middle-y": 0.56,
        "hc-key": "et",
        "hc-a2": "ET",
        "name": "Ethiopia",
        "labelrank": "2",
        "country-abbrev": "Eth.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "ETH",
        "iso-a2": "ET",
        "woe-id": "23424808",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5223,
              7284
            ],
            [
              5220,
              7280
            ],
            [
              5223,
              7277
            ],
            [
              5229,
              7271
            ],
            [
              5262,
              7273
            ],
            [
              5253,
              7259
            ],
            [
              5281,
              7212
            ],
            [
              5302,
              7196
            ],
            [
              5403,
              7158
            ],
            [
              5437,
              7158
            ],
            [
              5336,
              7039
            ],
            [
              5303,
              7041
            ],
            [
              5233,
              7003
            ],
            [
              5195,
              7015
            ],
            [
              5154,
              6981
            ],
            [
              5105,
              6989
            ],
            [
              5062,
              7021
            ],
            [
              5030,
              7028
            ],
            [
              4989,
              7105
            ],
            [
              4954,
              7145
            ],
            [
              4931,
              7150
            ],
            [
              4935,
              7173
            ],
            [
              4961,
              7175
            ],
            [
              4964,
              7214
            ],
            [
              4980,
              7269
            ],
            [
              4989,
              7263
            ],
            [
              5013,
              7334
            ],
            [
              5030,
              7339
            ],
            [
              5041,
              7399
            ],
            [
              5086,
              7423
            ],
            [
              5187,
              7393
            ],
            [
              5241,
              7330
            ],
            [
              5221,
              7294
            ],
            [
              5223,
              7284
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GH",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.19,
        "hc-middle-y": 0.90,
        "hc-key": "gh",
        "hc-a2": "GH",
        "name": "Ghana",
        "labelrank": "3",
        "country-abbrev": "Ghana",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "GHA",
        "iso-a2": "GH",
        "woe-id": "23424824",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3851,
              7085
            ],
            [
              3740,
              7032
            ],
            [
              3705,
              7046
            ],
            [
              3705,
              7047
            ],
            [
              3710,
              7046
            ],
            [
              3715,
              7048
            ],
            [
              3702,
              7114
            ],
            [
              3726,
              7166
            ],
            [
              3720,
              7215
            ],
            [
              3718,
              7273
            ],
            [
              3805,
              7278
            ],
            [
              3823,
              7243
            ],
            [
              3829,
              7113
            ],
            [
              3851,
              7085
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SI",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.57,
        "hc-key": "si",
        "hc-a2": "SI",
        "name": "Slovenia",
        "labelrank": "6",
        "country-abbrev": "Slo.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "SVN",
        "iso-a2": "SI",
        "woe-id": "23424945",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4224,
              8597
            ],
            [
              4223,
              8599
            ],
            [
              4227,
              8601
            ],
            [
              4215,
              8627
            ],
            [
              4225,
              8636
            ],
            [
              4250,
              8630
            ],
            [
              4296,
              8648
            ],
            [
              4301,
              8648
            ],
            [
              4310,
              8635
            ],
            [
              4284,
              8624
            ],
            [
              4277,
              8595
            ],
            [
              4224,
              8597
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.50,
        "hc-key": "ba",
        "hc-a2": "BA",
        "name": "Bosnia and Herzegovina",
        "labelrank": "5",
        "country-abbrev": "B.H.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "BIH",
        "iso-a2": "BA",
        "woe-id": "23424761",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4355,
              8497
            ],
            [
              4352,
              8499
            ],
            [
              4353,
              8499
            ],
            [
              4290,
              8568
            ],
            [
              4292,
              8586
            ],
            [
              4380,
              8582
            ],
            [
              4391,
              8570
            ],
            [
              4402,
              8570
            ],
            [
              4401,
              8521
            ],
            [
              4380,
              8501
            ],
            [
              4381,
              8485
            ],
            [
              4362,
              8494
            ],
            [
              4355,
              8497
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "JO",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.13,
        "hc-middle-y": 0.48,
        "hc-key": "jo",
        "hc-a2": "JO",
        "name": "Jordan",
        "labelrank": "4",
        "country-abbrev": "Jord.",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "JOR",
        "iso-a2": "JO",
        "woe-id": "23424860",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4963,
              8046
            ],
            [
              4966,
              8050
            ],
            [
              4961,
              8051
            ],
            [
              4961,
              8052
            ],
            [
              4962,
              8055
            ],
            [
              4966,
              8055
            ],
            [
              4964,
              8072
            ],
            [
              4961,
              8105
            ],
            [
              4967,
              8109
            ],
            [
              5003,
              8093
            ],
            [
              5061,
              8134
            ],
            [
              5075,
              8100
            ],
            [
              5079,
              8085
            ],
            [
              5011,
              8061
            ],
            [
              5048,
              8023
            ],
            [
              4990,
              7973
            ],
            [
              4954,
              7979
            ],
            [
              4955,
              7986
            ],
            [
              4953,
              7987
            ],
            [
              4956,
              8021
            ],
            [
              4963,
              8046
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SY",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.29,
        "hc-middle-y": 0.53,
        "hc-key": "sy",
        "hc-a2": "SY",
        "name": "Syria",
        "labelrank": "3",
        "country-abbrev": "Syria",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "SYR",
        "iso-a2": "SY",
        "woe-id": "23424956",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5061,
              8134
            ],
            [
              5003,
              8093
            ],
            [
              4967,
              8109
            ],
            [
              4970,
              8117
            ],
            [
              4966,
              8135
            ],
            [
              4988,
              8166
            ],
            [
              4965,
              8183
            ],
            [
              4960,
              8213
            ],
            [
              4957,
              8232
            ],
            [
              4976,
              8268
            ],
            [
              5076,
              8265
            ],
            [
              5150,
              8288
            ],
            [
              5156,
              8279
            ],
            [
              5129,
              8256
            ],
            [
              5132,
              8189
            ],
            [
              5061,
              8134
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MC",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.67,
        "hc-key": "mc",
        "hc-a2": "MC",
        "name": "Monaco",
        "labelrank": "6",
        "country-abbrev": "Mco.",
        "subregion": "Western Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "MCO",
        "iso-a2": "MC",
        "woe-id": "23424892",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4039,
              8529
            ],
            [
              4038,
              8528
            ],
            [
              4037,
              8528
            ],
            [
              4038,
              8529
            ],
            [
              4039,
              8529
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AL",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.69,
        "hc-middle-y": 0.90,
        "hc-key": "al",
        "hc-a2": "AL",
        "name": "Albania",
        "labelrank": "6",
        "country-abbrev": "Alb.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "ALB",
        "iso-a2": "AL",
        "woe-id": "23424742",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4465,
                8422
              ],
              [
                4464,
                8422
              ],
              [
                4464,
                8423
              ],
              [
                4465,
                8422
              ]
            ]
          ],
          [
            [
              [
                4411,
                8467
              ],
              [
                4410,
                8472
              ],
              [
                4411,
                8476
              ],
              [
                4419,
                8488
              ],
              [
                4431,
                8484
              ],
              [
                4446,
                8472
              ],
              [
                4449,
                8459
              ],
              [
                4448,
                8439
              ],
              [
                4454,
                8429
              ],
              [
                4455,
                8423
              ],
              [
                4457,
                8423
              ],
              [
                4461,
                8423
              ],
              [
                4464,
                8423
              ],
              [
                4464,
                8422
              ],
              [
                4465,
                8421
              ],
              [
                4465,
                8421
              ],
              [
                4463,
                8418
              ],
              [
                4465,
                8419
              ],
              [
                4464,
                8417
              ],
              [
                4467,
                8415
              ],
              [
                4466,
                8414
              ],
              [
                4467,
                8415
              ],
              [
                4457,
                8392
              ],
              [
                4438,
                8380
              ],
              [
                4414,
                8413
              ],
              [
                4412,
                8458
              ],
              [
                4411,
                8462
              ],
              [
                4411,
                8467
              ]
            ]
          ],
          [
            [
              [
                4410,
                8475
              ],
              [
                4410,
                8474
              ],
              [
                4410,
                8474
              ],
              [
                4410,
                8475
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "UY",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.85,
        "hc-middle-y": 0.89,
        "hc-key": "uy",
        "hc-a2": "UY",
        "name": "Uruguay",
        "labelrank": "4",
        "country-abbrev": "Ury.",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "URY",
        "iso-a2": "UY",
        "woe-id": "23424979",
        "continent": "South America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              2092,
              5594
            ],
            [
              2080,
              5577
            ],
            [
              2086,
              5559
            ],
            [
              2087,
              5556
            ],
            [
              2092,
              5552
            ],
            [
              2084,
              5527
            ],
            [
              2051,
              5506
            ],
            [
              2012,
              5506
            ],
            [
              1954,
              5524
            ],
            [
              1933,
              5545
            ],
            [
              1928,
              5602
            ],
            [
              1924,
              5623
            ],
            [
              1933,
              5689
            ],
            [
              1958,
              5692
            ],
            [
              1990,
              5654
            ],
            [
              2002,
              5663
            ],
            [
              2092,
              5594
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CNM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.34,
        "hc-middle-y": 0.05,
        "hc-key": "cnm",
        "hc-a2": "CN",
        "name": "Cyprus No Mans Area",
        "labelrank": "9",
        "country-abbrev": null,
        "subregion": "Western Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "-99",
        "iso-a2": null,
        "woe-id": "-99",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4900,
                8199
              ],
              [
                4901,
                8199
              ],
              [
                4900,
                8198
              ],
              [
                4897,
                8199
              ],
              [
                4897,
                8199
              ],
              [
                4898,
                8199
              ],
              [
                4900,
                8199
              ]
            ]
          ],
          [
            [
              [
                4854,
                8203
              ],
              [
                4855,
                8204
              ],
              [
                4856,
                8203
              ],
              [
                4856,
                8204
              ],
              [
                4857,
                8204
              ],
              [
                4856,
                8203
              ],
              [
                4854,
                8203
              ]
            ]
          ],
          [
            [
              [
                4858,
                8204
              ],
              [
                4858,
                8204
              ],
              [
                4858,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4858,
                8204
              ]
            ]
          ],
          [
            [
              [
                4890,
                8198
              ],
              [
                4891,
                8197
              ],
              [
                4891,
                8196
              ],
              [
                4881,
                8203
              ],
              [
                4859,
                8204
              ],
              [
                4859,
                8204
              ],
              [
                4881,
                8204
              ],
              [
                4890,
                8198
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.52,
        "hc-key": "mn",
        "hc-a2": "MN",
        "name": "Mongolia",
        "labelrank": "3",
        "country-abbrev": "Mong.",
        "subregion": "Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "MNG",
        "iso-a2": "MN",
        "woe-id": "23424887",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7329,
              8683
            ],
            [
              7338,
              8686
            ],
            [
              7332,
              8690
            ],
            [
              7356,
              8690
            ],
            [
              7421,
              8650
            ],
            [
              7334,
              8628
            ],
            [
              7324,
              8596
            ],
            [
              7291,
              8593
            ],
            [
              7277,
              8566
            ],
            [
              7216,
              8579
            ],
            [
              7216,
              8555
            ],
            [
              7247,
              8527
            ],
            [
              7196,
              8481
            ],
            [
              7115,
              8475
            ],
            [
              7076,
              8454
            ],
            [
              7030,
              8455
            ],
            [
              6952,
              8483
            ],
            [
              6785,
              8491
            ],
            [
              6728,
              8549
            ],
            [
              6649,
              8579
            ],
            [
              6576,
              8586
            ],
            [
              6558,
              8637
            ],
            [
              6518,
              8678
            ],
            [
              6432,
              8712
            ],
            [
              6416,
              8735
            ],
            [
              6518,
              8799
            ],
            [
              6580,
              8787
            ],
            [
              6601,
              8767
            ],
            [
              6688,
              8756
            ],
            [
              6700,
              8786
            ],
            [
              6675,
              8804
            ],
            [
              6683,
              8845
            ],
            [
              6797,
              8815
            ],
            [
              6814,
              8789
            ],
            [
              6866,
              8771
            ],
            [
              6907,
              8784
            ],
            [
              6997,
              8764
            ],
            [
              7027,
              8741
            ],
            [
              7097,
              8734
            ],
            [
              7155,
              8751
            ],
            [
              7175,
              8777
            ],
            [
              7257,
              8760
            ],
            [
              7262,
              8696
            ],
            [
              7281,
              8680
            ],
            [
              7329,
              8683
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "RW",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.47,
        "hc-middle-y": 0.57,
        "hc-key": "rw",
        "hc-a2": "RW",
        "name": "Rwanda",
        "labelrank": "3",
        "country-abbrev": "Rwa.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "RWA",
        "iso-a2": "RW",
        "woe-id": "23424937",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4797,
              6745
            ],
            [
              4793,
              6748
            ],
            [
              4792,
              6755
            ],
            [
              4809,
              6771
            ],
            [
              4804,
              6785
            ],
            [
              4808,
              6792
            ],
            [
              4816,
              6797
            ],
            [
              4828,
              6793
            ],
            [
              4847,
              6809
            ],
            [
              4859,
              6789
            ],
            [
              4849,
              6758
            ],
            [
              4827,
              6747
            ],
            [
              4797,
              6745
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BO",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.57,
        "hc-key": "bo",
        "hc-a2": "BO",
        "name": "Bolivia",
        "labelrank": "3",
        "country-abbrev": "Bolivia",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "BOL",
        "iso-a2": "BO",
        "woe-id": "23424762",
        "continent": "South America"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                1490,
                6226
              ],
              [
                1489,
                6232
              ],
              [
                1495,
                6226
              ],
              [
                1492,
                6227
              ],
              [
                1490,
                6226
              ]
            ]
          ],
          [
            [
              [
                1481,
                6177
              ],
              [
                1475,
                6185
              ],
              [
                1494,
                6213
              ],
              [
                1508,
                6222
              ],
              [
                1479,
                6253
              ],
              [
                1492,
                6304
              ],
              [
                1482,
                6324
              ],
              [
                1493,
                6369
              ],
              [
                1459,
                6429
              ],
              [
                1503,
                6428
              ],
              [
                1556,
                6469
              ],
              [
                1596,
                6478
              ],
              [
                1601,
                6421
              ],
              [
                1638,
                6371
              ],
              [
                1683,
                6363
              ],
              [
                1727,
                6329
              ],
              [
                1773,
                6319
              ],
              [
                1791,
                6224
              ],
              [
                1848,
                6222
              ],
              [
                1853,
                6186
              ],
              [
                1884,
                6151
              ],
              [
                1870,
                6074
              ],
              [
                1836,
                6108
              ],
              [
                1749,
                6094
              ],
              [
                1734,
                6059
              ],
              [
                1728,
                5995
              ],
              [
                1684,
                6004
              ],
              [
                1675,
                5970
              ],
              [
                1663,
                5996
              ],
              [
                1607,
                6012
              ],
              [
                1579,
                5972
              ],
              [
                1556,
                5972
              ],
              [
                1539,
                6031
              ],
              [
                1517,
                6064
              ],
              [
                1524,
                6102
              ],
              [
                1504,
                6121
              ],
              [
                1481,
                6177
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.30,
        "hc-middle-y": 0.74,
        "hc-key": "cm",
        "hc-a2": "CM",
        "name": "Cameroon",
        "labelrank": "3",
        "country-abbrev": "Cam.",
        "subregion": "Middle Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "CMR",
        "iso-a2": "CM",
        "woe-id": "23424785",
        "continent": "Africa"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4263,
                6933
              ],
              [
                4197,
                6939
              ],
              [
                4196,
                6933
              ],
              [
                4151,
                6933
              ],
              [
                4144,
                6940
              ],
              [
                4138,
                6999
              ],
              [
                4103,
                7035
              ],
              [
                4111,
                7074
              ],
              [
                4170,
                7124
              ],
              [
                4195,
                7098
              ],
              [
                4213,
                7124
              ],
              [
                4225,
                7171
              ],
              [
                4284,
                7284
              ],
              [
                4304,
                7292
              ],
              [
                4306,
                7319
              ],
              [
                4285,
                7353
              ],
              [
                4294,
                7353
              ],
              [
                4292,
                7346
              ],
              [
                4300,
                7349
              ],
              [
                4322,
                7294
              ],
              [
                4320,
                7265
              ],
              [
                4342,
                7234
              ],
              [
                4291,
                7234
              ],
              [
                4283,
                7221
              ],
              [
                4325,
                7176
              ],
              [
                4336,
                7140
              ],
              [
                4299,
                7082
              ],
              [
                4326,
                6995
              ],
              [
                4358,
                6959
              ],
              [
                4361,
                6936
              ],
              [
                4360,
                6917
              ],
              [
                4307,
                6935
              ],
              [
                4263,
                6933
              ]
            ]
          ],
          [
            [
              [
                4296,
                7353
              ],
              [
                4296,
                7353
              ],
              [
                4295,
                7353
              ],
              [
                4296,
                7353
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.15,
        "hc-middle-y": 0.86,
        "hc-key": "cg",
        "hc-a2": "CG",
        "name": "Republic of Congo",
        "labelrank": "4",
        "country-abbrev": "Rep. Congo",
        "subregion": "Middle Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "COG",
        "iso-a2": "CG",
        "woe-id": "23424779",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4255,
              6672
            ],
            [
              4244,
              6681
            ],
            [
              4219,
              6657
            ],
            [
              4212,
              6674
            ],
            [
              4188,
              6699
            ],
            [
              4213,
              6707
            ],
            [
              4204,
              6760
            ],
            [
              4234,
              6760
            ],
            [
              4233,
              6778
            ],
            [
              4290,
              6754
            ],
            [
              4304,
              6827
            ],
            [
              4281,
              6842
            ],
            [
              4303,
              6885
            ],
            [
              4295,
              6901
            ],
            [
              4261,
              6897
            ],
            [
              4263,
              6933
            ],
            [
              4307,
              6935
            ],
            [
              4360,
              6917
            ],
            [
              4361,
              6936
            ],
            [
              4374,
              6983
            ],
            [
              4404,
              6993
            ],
            [
              4444,
              6984
            ],
            [
              4425,
              6933
            ],
            [
              4414,
              6830
            ],
            [
              4363,
              6768
            ],
            [
              4362,
              6723
            ],
            [
              4314,
              6665
            ],
            [
              4300,
              6686
            ],
            [
              4266,
              6662
            ],
            [
              4255,
              6672
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "EH",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.33,
        "hc-middle-y": 0.82,
        "hc-key": "eh",
        "hc-a2": "EH",
        "name": "Western Sahara",
        "labelrank": "7",
        "country-abbrev": "W. Sah.",
        "subregion": "Northern Africa",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "ESH",
        "iso-a2": "EH",
        "woe-id": "23424990",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3242,
              7649
            ],
            [
              3241,
              7653
            ],
            [
              3245,
              7674
            ],
            [
              3317,
              7675
            ],
            [
              3338,
              7708
            ],
            [
              3346,
              7751
            ],
            [
              3400,
              7805
            ],
            [
              3414,
              7852
            ],
            [
              3436,
              7884
            ],
            [
              3491,
              7884
            ],
            [
              3522,
              7894
            ],
            [
              3526,
              7914
            ],
            [
              3526,
              7900
            ],
            [
              3524,
              7850
            ],
            [
              3415,
              7850
            ],
            [
              3412,
              7753
            ],
            [
              3379,
              7736
            ],
            [
              3378,
              7671
            ],
            [
              3246,
              7671
            ],
            [
              3242,
              7649
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "RS",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.43,
        "hc-middle-y": 0.53,
        "hc-key": "rs",
        "hc-a2": "RS",
        "name": "Republic of Serbia",
        "labelrank": "5",
        "country-abbrev": "Serb.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "SRB",
        "iso-a2": "RS",
        "woe-id": "-90",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4391,
              8570
            ],
            [
              4391,
              8584
            ],
            [
              4384,
              8613
            ],
            [
              4402,
              8622
            ],
            [
              4424,
              8620
            ],
            [
              4465,
              8584
            ],
            [
              4462,
              8570
            ],
            [
              4505,
              8547
            ],
            [
              4497,
              8531
            ],
            [
              4518,
              8508
            ],
            [
              4502,
              8476
            ],
            [
              4489,
              8476
            ],
            [
              4478,
              8473
            ],
            [
              4483,
              8489
            ],
            [
              4450,
              8511
            ],
            [
              4439,
              8495
            ],
            [
              4414,
              8508
            ],
            [
              4401,
              8521
            ],
            [
              4402,
              8570
            ],
            [
              4391,
              8570
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "ME",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.42,
        "hc-middle-y": 0.47,
        "hc-key": "me",
        "hc-a2": "ME",
        "name": "Montenegro",
        "labelrank": "6",
        "country-abbrev": "Mont.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "MNE",
        "iso-a2": "ME",
        "woe-id": "20069817",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4401,
              8521
            ],
            [
              4414,
              8508
            ],
            [
              4439,
              8495
            ],
            [
              4429,
              8491
            ],
            [
              4431,
              8484
            ],
            [
              4419,
              8488
            ],
            [
              4411,
              8476
            ],
            [
              4410,
              8475
            ],
            [
              4410,
              8474
            ],
            [
              4404,
              8474
            ],
            [
              4411,
              8467
            ],
            [
              4411,
              8462
            ],
            [
              4412,
              8458
            ],
            [
              4392,
              8474
            ],
            [
              4383,
              8479
            ],
            [
              4381,
              8482
            ],
            [
              4381,
              8485
            ],
            [
              4380,
              8501
            ],
            [
              4401,
              8521
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BJ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.28,
        "hc-middle-y": 0.93,
        "hc-key": "bj",
        "hc-a2": "BJ",
        "name": "Benin",
        "labelrank": "5",
        "country-abbrev": "Benin",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "BEN",
        "iso-a2": "BJ",
        "woe-id": "23424764",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3903,
              7095
            ],
            [
              3875,
              7091
            ],
            [
              3866,
              7089
            ],
            [
              3865,
              7198
            ],
            [
              3856,
              7235
            ],
            [
              3837,
              7249
            ],
            [
              3842,
              7273
            ],
            [
              3860,
              7292
            ],
            [
              3892,
              7308
            ],
            [
              3907,
              7327
            ],
            [
              3933,
              7300
            ],
            [
              3941,
              7258
            ],
            [
              3905,
              7199
            ],
            [
              3903,
              7095
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.84,
        "hc-middle-y": 0.98,
        "hc-key": "tg",
        "hc-a2": "TG",
        "name": "Togo",
        "labelrank": "6",
        "country-abbrev": "Togo",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "TGO",
        "iso-a2": "TG",
        "woe-id": "23424965",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3866,
              7089
            ],
            [
              3860,
              7088
            ],
            [
              3851,
              7085
            ],
            [
              3829,
              7113
            ],
            [
              3823,
              7243
            ],
            [
              3805,
              7278
            ],
            [
              3828,
              7273
            ],
            [
              3842,
              7273
            ],
            [
              3837,
              7249
            ],
            [
              3856,
              7235
            ],
            [
              3865,
              7198
            ],
            [
              3866,
              7089
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.34,
        "hc-key": "la",
        "hc-a2": "LA",
        "name": "Laos",
        "labelrank": "4",
        "country-abbrev": "Laos",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "LAO",
        "iso-a2": "LA",
        "woe-id": "23424872",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7151,
              7632
            ],
            [
              7166,
              7670
            ],
            [
              7179,
              7679
            ],
            [
              7199,
              7663
            ],
            [
              7186,
              7706
            ],
            [
              7206,
              7712
            ],
            [
              7239,
              7680
            ],
            [
              7249,
              7652
            ],
            [
              7279,
              7656
            ],
            [
              7314,
              7622
            ],
            [
              7282,
              7593
            ],
            [
              7313,
              7573
            ],
            [
              7385,
              7504
            ],
            [
              7432,
              7438
            ],
            [
              7430,
              7416
            ],
            [
              7408,
              7401
            ],
            [
              7353,
              7402
            ],
            [
              7361,
              7455
            ],
            [
              7328,
              7486
            ],
            [
              7325,
              7518
            ],
            [
              7292,
              7555
            ],
            [
              7259,
              7543
            ],
            [
              7229,
              7551
            ],
            [
              7201,
              7522
            ],
            [
              7194,
              7602
            ],
            [
              7168,
              7601
            ],
            [
              7151,
              7632
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AF",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.42,
        "hc-middle-y": 0.52,
        "hc-key": "af",
        "hc-a2": "AF",
        "name": "Afghanistan",
        "labelrank": "3",
        "country-abbrev": "Afg.",
        "subregion": "Southern Asia",
        "region-wb": "South Asia",
        "iso-a3": "AFG",
        "iso-a2": "AF",
        "woe-id": "23424739",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6188,
              8284
            ],
            [
              6173,
              8280
            ],
            [
              6179,
              8276
            ],
            [
              6118,
              8268
            ],
            [
              6081,
              8237
            ],
            [
              6104,
              8204
            ],
            [
              6096,
              8160
            ],
            [
              6062,
              8160
            ],
            [
              6078,
              8132
            ],
            [
              6056,
              8122
            ],
            [
              6057,
              8079
            ],
            [
              6021,
              8074
            ],
            [
              5970,
              8040
            ],
            [
              5972,
              7998
            ],
            [
              5906,
              7981
            ],
            [
              5853,
              7982
            ],
            [
              5797,
              7999
            ],
            [
              5822,
              8037
            ],
            [
              5815,
              8057
            ],
            [
              5786,
              8062
            ],
            [
              5766,
              8122
            ],
            [
              5769,
              8221
            ],
            [
              5805,
              8202
            ],
            [
              5866,
              8246
            ],
            [
              5876,
              8284
            ],
            [
              5921,
              8289
            ],
            [
              5945,
              8282
            ],
            [
              5963,
              8282
            ],
            [
              6010,
              8279
            ],
            [
              6034,
              8296
            ],
            [
              6040,
              8328
            ],
            [
              6076,
              8310
            ],
            [
              6096,
              8263
            ],
            [
              6135,
              8293
            ],
            [
              6188,
              8284
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "UA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.70,
        "hc-middle-y": 0.44,
        "hc-key": "ua",
        "hc-a2": "UA",
        "name": "Ukraine",
        "labelrank": "3",
        "country-abbrev": "Ukr.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "UKR",
        "iso-a2": "UA",
        "woe-id": "23424976",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4471,
              8706
            ],
            [
              4475,
              8717
            ],
            [
              4480,
              8732
            ],
            [
              4481,
              8749
            ],
            [
              4519,
              8786
            ],
            [
              4500,
              8823
            ],
            [
              4560,
              8838
            ],
            [
              4667,
              8817
            ],
            [
              4734,
              8844
            ],
            [
              4791,
              8854
            ],
            [
              4810,
              8813
            ],
            [
              4837,
              8811
            ],
            [
              4861,
              8779
            ],
            [
              4912,
              8782
            ],
            [
              4996,
              8747
            ],
            [
              5001,
              8685
            ],
            [
              4973,
              8686
            ],
            [
              4960,
              8657
            ],
            [
              4894,
              8641
            ],
            [
              4864,
              8622
            ],
            [
              4896,
              8583
            ],
            [
              4849,
              8552
            ],
            [
              4808,
              8602
            ],
            [
              4834,
              8613
            ],
            [
              4771,
              8624
            ],
            [
              4751,
              8640
            ],
            [
              4713,
              8587
            ],
            [
              4687,
              8588
            ],
            [
              4668,
              8596
            ],
            [
              4685,
              8633
            ],
            [
              4720,
              8630
            ],
            [
              4686,
              8686
            ],
            [
              4638,
              8708
            ],
            [
              4606,
              8701
            ],
            [
              4567,
              8687
            ],
            [
              4495,
              8689
            ],
            [
              4486,
              8695
            ],
            [
              4471,
              8706
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SK",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.21,
        "hc-middle-y": 0.52,
        "hc-key": "sk",
        "hc-a2": "SK",
        "name": "Slovakia",
        "labelrank": "6",
        "country-abbrev": "Svk.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "SVK",
        "iso-a2": "SK",
        "woe-id": "23424877",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4480,
              8732
            ],
            [
              4475,
              8717
            ],
            [
              4471,
              8706
            ],
            [
              4421,
              8711
            ],
            [
              4406,
              8696
            ],
            [
              4345,
              8682
            ],
            [
              4324,
              8691
            ],
            [
              4313,
              8705
            ],
            [
              4316,
              8714
            ],
            [
              4348,
              8732
            ],
            [
              4368,
              8748
            ],
            [
              4457,
              8743
            ],
            [
              4480,
              8732
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "JK",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.22,
        "hc-middle-y": 0.49,
        "hc-key": "jk",
        "hc-a2": "JK",
        "name": "Siachen Glacier",
        "labelrank": "5",
        "country-abbrev": "Siachen",
        "subregion": "Southern Asia",
        "region-wb": "South Asia",
        "iso-a3": "-99",
        "iso-a2": "JK",
        "woe-id": "23424928",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6299,
              8216
            ],
            [
              6278,
              8201
            ],
            [
              6264,
              8222
            ],
            [
              6286,
              8215
            ],
            [
              6299,
              8216
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PK",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.53,
        "hc-middle-y": 0.57,
        "hc-key": "pk",
        "hc-a2": "PK",
        "name": "Pakistan",
        "labelrank": "2",
        "country-abbrev": "Pak.",
        "subregion": "Southern Asia",
        "region-wb": "South Asia",
        "iso-a3": "PAK",
        "iso-a2": "PK",
        "woe-id": "23424922",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6264,
              8222
            ],
            [
              6278,
              8201
            ],
            [
              6244,
              8177
            ],
            [
              6195,
              8188
            ],
            [
              6181,
              8172
            ],
            [
              6199,
              8126
            ],
            [
              6250,
              8087
            ],
            [
              6227,
              8070
            ],
            [
              6234,
              8047
            ],
            [
              6205,
              8001
            ],
            [
              6197,
              7967
            ],
            [
              6170,
              7926
            ],
            [
              6138,
              7916
            ],
            [
              6123,
              7929
            ],
            [
              6098,
              7882
            ],
            [
              6123,
              7871
            ],
            [
              6163,
              7800
            ],
            [
              6129,
              7780
            ],
            [
              6091,
              7783
            ],
            [
              6071,
              7767
            ],
            [
              6043,
              7776
            ],
            [
              6034,
              7800
            ],
            [
              6000,
              7830
            ],
            [
              5910,
              7819
            ],
            [
              5847,
              7820
            ],
            [
              5851,
              7860
            ],
            [
              5890,
              7875
            ],
            [
              5870,
              7937
            ],
            [
              5839,
              7948
            ],
            [
              5797,
              7999
            ],
            [
              5853,
              7982
            ],
            [
              5906,
              7981
            ],
            [
              5972,
              7998
            ],
            [
              5970,
              8040
            ],
            [
              6021,
              8074
            ],
            [
              6057,
              8079
            ],
            [
              6056,
              8122
            ],
            [
              6078,
              8132
            ],
            [
              6062,
              8160
            ],
            [
              6096,
              8160
            ],
            [
              6104,
              8204
            ],
            [
              6081,
              8237
            ],
            [
              6118,
              8268
            ],
            [
              6179,
              8276
            ],
            [
              6230,
              8254
            ],
            [
              6264,
              8222
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.75,
        "hc-middle-y": 0.51,
        "hc-key": "bg",
        "hc-a2": "BG",
        "name": "Bulgaria",
        "labelrank": "4",
        "country-abbrev": "Bulg.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "BGR",
        "iso-a2": "BG",
        "woe-id": "23424771",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4688,
              8529
            ],
            [
              4665,
              8481
            ],
            [
              4679,
              8463
            ],
            [
              4649,
              8467
            ],
            [
              4628,
              8453
            ],
            [
              4596,
              8435
            ],
            [
              4572,
              8447
            ],
            [
              4524,
              8439
            ],
            [
              4525,
              8454
            ],
            [
              4502,
              8476
            ],
            [
              4518,
              8508
            ],
            [
              4497,
              8531
            ],
            [
              4505,
              8547
            ],
            [
              4526,
              8534
            ],
            [
              4590,
              8525
            ],
            [
              4638,
              8545
            ],
            [
              4688,
              8529
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LI",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.58,
        "hc-middle-y": 0.51,
        "hc-key": "li",
        "hc-a2": "LI",
        "name": "Liechtenstein",
        "labelrank": "6",
        "country-abbrev": "Liech.",
        "subregion": "Western Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "LIE",
        "iso-a2": "LI",
        "woe-id": "23424879",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4097,
              8663
            ],
            [
              4100,
              8658
            ],
            [
              4099,
              8656
            ],
            [
              4096,
              8656
            ],
            [
              4097,
              8663
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AT",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.62,
        "hc-key": "at",
        "hc-a2": "AT",
        "name": "Austria",
        "labelrank": "4",
        "country-abbrev": "Aust.",
        "subregion": "Western Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "AUT",
        "iso-a2": "AT",
        "woe-id": "23424750",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4099,
              8656
            ],
            [
              4100,
              8658
            ],
            [
              4097,
              8663
            ],
            [
              4101,
              8669
            ],
            [
              4098,
              8673
            ],
            [
              4101,
              8672
            ],
            [
              4102,
              8674
            ],
            [
              4141,
              8668
            ],
            [
              4193,
              8679
            ],
            [
              4192,
              8696
            ],
            [
              4222,
              8720
            ],
            [
              4256,
              8728
            ],
            [
              4316,
              8714
            ],
            [
              4313,
              8705
            ],
            [
              4324,
              8691
            ],
            [
              4307,
              8682
            ],
            [
              4296,
              8648
            ],
            [
              4250,
              8630
            ],
            [
              4225,
              8636
            ],
            [
              4175,
              8656
            ],
            [
              4126,
              8648
            ],
            [
              4116,
              8648
            ],
            [
              4099,
              8656
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.51,
        "hc-key": "sz",
        "hc-a2": "SZ",
        "name": "Swaziland",
        "labelrank": "4",
        "country-abbrev": "Swz.",
        "subregion": "Southern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "SWZ",
        "iso-a2": "SZ",
        "woe-id": "23424993",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4865,
              5851
            ],
            [
              4867,
              5839
            ],
            [
              4868,
              5817
            ],
            [
              4862,
              5799
            ],
            [
              4835,
              5804
            ],
            [
              4826,
              5834
            ],
            [
              4849,
              5860
            ],
            [
              4865,
              5851
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "HU",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.74,
        "hc-middle-y": 0.42,
        "hc-key": "hu",
        "hc-a2": "HU",
        "name": "Hungary",
        "labelrank": "5",
        "country-abbrev": "Hun.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "HUN",
        "iso-a2": "HU",
        "woe-id": "23424844",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4384,
              8613
            ],
            [
              4336,
              8614
            ],
            [
              4310,
              8635
            ],
            [
              4301,
              8648
            ],
            [
              4296,
              8648
            ],
            [
              4307,
              8682
            ],
            [
              4324,
              8691
            ],
            [
              4345,
              8682
            ],
            [
              4406,
              8696
            ],
            [
              4421,
              8711
            ],
            [
              4471,
              8706
            ],
            [
              4486,
              8695
            ],
            [
              4495,
              8689
            ],
            [
              4471,
              8672
            ],
            [
              4450,
              8627
            ],
            [
              4424,
              8620
            ],
            [
              4402,
              8622
            ],
            [
              4384,
              8613
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "NE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.59,
        "hc-middle-y": 0.45,
        "hc-key": "ne",
        "hc-a2": "NE",
        "name": "Niger",
        "labelrank": "3",
        "country-abbrev": "Niger",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "NER",
        "iso-a2": "NE",
        "woe-id": "23424906",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3933,
              7300
            ],
            [
              3907,
              7327
            ],
            [
              3892,
              7308
            ],
            [
              3885,
              7335
            ],
            [
              3844,
              7351
            ],
            [
              3816,
              7410
            ],
            [
              3818,
              7424
            ],
            [
              3856,
              7438
            ],
            [
              3929,
              7441
            ],
            [
              3952,
              7482
            ],
            [
              3952,
              7587
            ],
            [
              4005,
              7598
            ],
            [
              4060,
              7653
            ],
            [
              4208,
              7755
            ],
            [
              4259,
              7742
            ],
            [
              4283,
              7720
            ],
            [
              4308,
              7735
            ],
            [
              4317,
              7677
            ],
            [
              4344,
              7632
            ],
            [
              4336,
              7616
            ],
            [
              4330,
              7501
            ],
            [
              4294,
              7456
            ],
            [
              4264,
              7403
            ],
            [
              4270,
              7377
            ],
            [
              4232,
              7353
            ],
            [
              4197,
              7364
            ],
            [
              4152,
              7360
            ],
            [
              4136,
              7343
            ],
            [
              4075,
              7364
            ],
            [
              4045,
              7350
            ],
            [
              3997,
              7384
            ],
            [
              3950,
              7368
            ],
            [
              3933,
              7300
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LU",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.48,
        "hc-middle-y": 0.60,
        "hc-key": "lu",
        "hc-a2": "LU",
        "name": "Luxembourg",
        "labelrank": "6",
        "country-abbrev": "Lux.",
        "subregion": "Western Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "LUX",
        "iso-a2": "LU",
        "woe-id": "23424881",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3999,
              8746
            ],
            [
              3988,
              8745
            ],
            [
              3982,
              8749
            ],
            [
              3980,
              8762
            ],
            [
              3991,
              8771
            ],
            [
              4003,
              8759
            ],
            [
              3999,
              8746
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AD",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.58,
        "hc-middle-y": 0.28,
        "hc-key": "ad",
        "hc-a2": "AD",
        "name": "Andorra",
        "labelrank": "6",
        "country-abbrev": "And.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "AND",
        "iso-a2": "AD",
        "woe-id": "23424744",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3855,
              8486
            ],
            [
              3864,
              8487
            ],
            [
              3864,
              8483
            ],
            [
              3858,
              8480
            ],
            [
              3855,
              8486
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CI",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.52,
        "hc-key": "ci",
        "hc-a2": "CI",
        "name": "Ivory Coast",
        "labelrank": "3",
        "country-abbrev": "I.C.",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "CIV",
        "iso-a2": "CI",
        "woe-id": "23424854",
        "continent": "Africa"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                3705,
                7046
              ],
              [
                3700,
                7047
              ],
              [
                3705,
                7047
              ],
              [
                3705,
                7046
              ]
            ]
          ],
          [
            [
              [
                3555,
                7018
              ],
              [
                3558,
                7075
              ],
              [
                3519,
                7100
              ],
              [
                3524,
                7141
              ],
              [
                3533,
                7177
              ],
              [
                3552,
                7172
              ],
              [
                3537,
                7212
              ],
              [
                3541,
                7241
              ],
              [
                3575,
                7241
              ],
              [
                3600,
                7263
              ],
              [
                3624,
                7251
              ],
              [
                3653,
                7223
              ],
              [
                3702,
                7232
              ],
              [
                3720,
                7215
              ],
              [
                3726,
                7166
              ],
              [
                3702,
                7114
              ],
              [
                3715,
                7048
              ],
              [
                3613,
                7044
              ],
              [
                3555,
                7018
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.89,
        "hc-middle-y": 0.71,
        "hc-key": "lr",
        "hc-a2": "LR",
        "name": "Liberia",
        "labelrank": "4",
        "country-abbrev": "Liberia",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "LBR",
        "iso-a2": "LR",
        "woe-id": "23424876",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3524,
              7141
            ],
            [
              3519,
              7100
            ],
            [
              3558,
              7075
            ],
            [
              3555,
              7018
            ],
            [
              3496,
              7048
            ],
            [
              3422,
              7116
            ],
            [
              3451,
              7149
            ],
            [
              3463,
              7177
            ],
            [
              3489,
              7171
            ],
            [
              3502,
              7127
            ],
            [
              3524,
              7141
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SL",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.19,
        "hc-middle-y": 0.77,
        "hc-key": "sl",
        "hc-a2": "SL",
        "name": "Sierra Leone",
        "labelrank": "4",
        "country-abbrev": "S.L.",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "SLE",
        "iso-a2": "SL",
        "woe-id": "23424946",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3463,
              7177
            ],
            [
              3451,
              7149
            ],
            [
              3422,
              7116
            ],
            [
              3372,
              7141
            ],
            [
              3361,
              7198
            ],
            [
              3388,
              7229
            ],
            [
              3431,
              7235
            ],
            [
              3463,
              7177
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.48,
        "hc-middle-y": 0.36,
        "hc-key": "bn",
        "hc-a2": "BN",
        "name": "Brunei",
        "labelrank": "6",
        "country-abbrev": "Brunei",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "BRN",
        "iso-a2": "BN",
        "woe-id": "23424773",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                7715,
                7036
              ],
              [
                7719,
                7037
              ],
              [
                7719,
                7039
              ],
              [
                7727,
                7016
              ],
              [
                7715,
                7036
              ]
            ]
          ],
          [
            [
              [
                7681,
                7027
              ],
              [
                7699,
                7031
              ],
              [
                7713,
                7038
              ],
              [
                7702,
                7005
              ],
              [
                7681,
                7027
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.54,
        "hc-middle-y": 0.40,
        "hc-key": "be",
        "hc-a2": "BE",
        "name": "Belgium",
        "labelrank": "2",
        "country-abbrev": "Belg.",
        "subregion": "Western Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "BEL",
        "iso-a2": "BE",
        "woe-id": "23424757",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3991,
              8771
            ],
            [
              3980,
              8762
            ],
            [
              3982,
              8749
            ],
            [
              3933,
              8765
            ],
            [
              3885,
              8807
            ],
            [
              3902,
              8816
            ],
            [
              3909,
              8817
            ],
            [
              3922,
              8811
            ],
            [
              3934,
              8817
            ],
            [
              3936,
              8815
            ],
            [
              3936,
              8817
            ],
            [
              3957,
              8821
            ],
            [
              3987,
              8794
            ],
            [
              3998,
              8778
            ],
            [
              3991,
              8771
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "IQ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.39,
        "hc-middle-y": 0.57,
        "hc-key": "iq",
        "hc-a2": "IQ",
        "name": "Iraq",
        "labelrank": "3",
        "country-abbrev": "Iraq",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "IRQ",
        "iso-a2": "IQ",
        "woe-id": "23424855",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5395,
              8003
            ],
            [
              5381,
              8006
            ],
            [
              5375,
              8004
            ],
            [
              5348,
              8003
            ],
            [
              5333,
              7970
            ],
            [
              5273,
              7974
            ],
            [
              5179,
              8046
            ],
            [
              5121,
              8078
            ],
            [
              5079,
              8085
            ],
            [
              5075,
              8100
            ],
            [
              5061,
              8134
            ],
            [
              5132,
              8189
            ],
            [
              5129,
              8256
            ],
            [
              5156,
              8279
            ],
            [
              5166,
              8289
            ],
            [
              5232,
              8280
            ],
            [
              5257,
              8235
            ],
            [
              5290,
              8228
            ],
            [
              5271,
              8157
            ],
            [
              5305,
              8118
            ],
            [
              5345,
              8096
            ],
            [
              5362,
              8072
            ],
            [
              5361,
              8042
            ],
            [
              5395,
              8003
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.28,
        "hc-middle-y": 0.41,
        "hc-key": "ge",
        "hc-a2": "GE",
        "name": "Georgia",
        "labelrank": "5",
        "country-abbrev": "Geo.",
        "subregion": "Western Asia",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "GEO",
        "iso-a2": "GE",
        "woe-id": "23424823",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5211,
              8437
            ],
            [
              5186,
              8435
            ],
            [
              5164,
              8430
            ],
            [
              5141,
              8448
            ],
            [
              5101,
              8446
            ],
            [
              5093,
              8488
            ],
            [
              5041,
              8516
            ],
            [
              5130,
              8507
            ],
            [
              5169,
              8484
            ],
            [
              5195,
              8491
            ],
            [
              5251,
              8460
            ],
            [
              5260,
              8428
            ],
            [
              5211,
              8437
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GM",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.51,
        "hc-key": "gm",
        "hc-a2": "GM",
        "name": "Gambia",
        "labelrank": "6",
        "country-abbrev": "Gambia",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "GMB",
        "iso-a2": "GM",
        "woe-id": "23424821",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3246,
              7353
            ],
            [
              3244,
              7363
            ],
            [
              3253,
              7373
            ],
            [
              3310,
              7380
            ],
            [
              3277,
              7356
            ],
            [
              3246,
              7353
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CH",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.13,
        "hc-middle-y": 0.57,
        "hc-key": "ch",
        "hc-a2": "CH",
        "name": "Switzerland",
        "labelrank": "4",
        "country-abbrev": "Switz.",
        "subregion": "Western Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "CHE",
        "iso-a2": "CH",
        "woe-id": "23424957",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4086,
              8679
            ],
            [
              4086,
              8679
            ],
            [
              4087,
              8678
            ],
            [
              4087,
              8678
            ],
            [
              4096,
              8672
            ],
            [
              4098,
              8673
            ],
            [
              4101,
              8669
            ],
            [
              4097,
              8663
            ],
            [
              4096,
              8656
            ],
            [
              4099,
              8656
            ],
            [
              4116,
              8648
            ],
            [
              4126,
              8648
            ],
            [
              4112,
              8629
            ],
            [
              4055,
              8626
            ],
            [
              4024,
              8613
            ],
            [
              4016,
              8621
            ],
            [
              4016,
              8631
            ],
            [
              4011,
              8636
            ],
            [
              4004,
              8630
            ],
            [
              3999,
              8627
            ],
            [
              3996,
              8638
            ],
            [
              4038,
              8676
            ],
            [
              4064,
              8676
            ],
            [
              4086,
              8679
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TD",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.46,
        "hc-middle-y": 0.68,
        "hc-key": "td",
        "hc-a2": "TD",
        "name": "Chad",
        "labelrank": "3",
        "country-abbrev": "Chad",
        "subregion": "Middle Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "TCD",
        "iso-a2": "TD",
        "woe-id": "23424777",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4300,
              7349
            ],
            [
              4309,
              7353
            ],
            [
              4296,
              7353
            ],
            [
              4295,
              7353
            ],
            [
              4293,
              7355
            ],
            [
              4294,
              7353
            ],
            [
              4285,
              7353
            ],
            [
              4270,
              7377
            ],
            [
              4264,
              7403
            ],
            [
              4294,
              7456
            ],
            [
              4330,
              7501
            ],
            [
              4336,
              7616
            ],
            [
              4344,
              7632
            ],
            [
              4317,
              7677
            ],
            [
              4308,
              7735
            ],
            [
              4341,
              7752
            ],
            [
              4612,
              7600
            ],
            [
              4617,
              7455
            ],
            [
              4587,
              7454
            ],
            [
              4571,
              7394
            ],
            [
              4555,
              7380
            ],
            [
              4560,
              7340
            ],
            [
              4584,
              7270
            ],
            [
              4570,
              7273
            ],
            [
              4503,
              7202
            ],
            [
              4458,
              7197
            ],
            [
              4441,
              7160
            ],
            [
              4379,
              7141
            ],
            [
              4372,
              7153
            ],
            [
              4336,
              7140
            ],
            [
              4325,
              7176
            ],
            [
              4283,
              7221
            ],
            [
              4291,
              7234
            ],
            [
              4342,
              7234
            ],
            [
              4320,
              7265
            ],
            [
              4322,
              7294
            ],
            [
              4300,
              7349
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KV",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.51,
        "hc-key": "kv",
        "hc-a2": "KV",
        "name": "Kosovo",
        "labelrank": "6",
        "country-abbrev": "Kos.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "-99",
        "iso-a2": "KV",
        "woe-id": "-90",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4449,
              8459
            ],
            [
              4446,
              8472
            ],
            [
              4431,
              8484
            ],
            [
              4429,
              8491
            ],
            [
              4439,
              8495
            ],
            [
              4450,
              8511
            ],
            [
              4483,
              8489
            ],
            [
              4478,
              8473
            ],
            [
              4464,
              8471
            ],
            [
              4449,
              8459
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LB",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.53,
        "hc-middle-y": 0.57,
        "hc-key": "lb",
        "hc-a2": "LB",
        "name": "Lebanon",
        "labelrank": "5",
        "country-abbrev": "Leb.",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "LBN",
        "iso-a2": "LB",
        "woe-id": "23424873",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4944,
              8123
            ],
            [
              4956,
              8154
            ],
            [
              4965,
              8183
            ],
            [
              4988,
              8166
            ],
            [
              4966,
              8135
            ],
            [
              4956,
              8123
            ],
            [
              4944,
              8123
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SX",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.96,
        "hc-middle-y": 0.19,
        "hc-key": "sx",
        "hc-a2": "SX",
        "name": "Somaliland",
        "labelrank": "5",
        "country-abbrev": "Solnd.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "-99",
        "iso-a2": "SX",
        "woe-id": "-99",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5437,
              7158
            ],
            [
              5403,
              7158
            ],
            [
              5302,
              7196
            ],
            [
              5281,
              7212
            ],
            [
              5253,
              7259
            ],
            [
              5262,
              7273
            ],
            [
              5272,
              7292
            ],
            [
              5308,
              7252
            ],
            [
              5358,
              7269
            ],
            [
              5381,
              7261
            ],
            [
              5413,
              7280
            ],
            [
              5465,
              7283
            ],
            [
              5467,
              7214
            ],
            [
              5437,
              7158
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SO",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.43,
        "hc-middle-y": 0.68,
        "hc-key": "so",
        "hc-a2": "SO",
        "name": "Somalia",
        "labelrank": "6",
        "country-abbrev": "Som.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "SOM",
        "iso-a2": "SO",
        "woe-id": "-90",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5437,
              7158
            ],
            [
              5467,
              7214
            ],
            [
              5465,
              7283
            ],
            [
              5543,
              7305
            ],
            [
              5532,
              7214
            ],
            [
              5485,
              7120
            ],
            [
              5474,
              7086
            ],
            [
              5439,
              7022
            ],
            [
              5375,
              6944
            ],
            [
              5325,
              6910
            ],
            [
              5258,
              6839
            ],
            [
              5222,
              6785
            ],
            [
              5204,
              6817
            ],
            [
              5203,
              6958
            ],
            [
              5233,
              7003
            ],
            [
              5303,
              7041
            ],
            [
              5336,
              7039
            ],
            [
              5437,
              7158
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "DJ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.57,
        "hc-middle-y": 0.54,
        "hc-key": "dj",
        "hc-a2": "DJ",
        "name": "Djibouti",
        "labelrank": "5",
        "country-abbrev": "Dji.",
        "subregion": "Eastern Africa",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "DJI",
        "iso-a2": "DJ",
        "woe-id": "23424797",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5262,
              7273
            ],
            [
              5229,
              7271
            ],
            [
              5223,
              7277
            ],
            [
              5226,
              7281
            ],
            [
              5223,
              7284
            ],
            [
              5221,
              7294
            ],
            [
              5241,
              7330
            ],
            [
              5252,
              7326
            ],
            [
              5266,
              7339
            ],
            [
              5275,
              7311
            ],
            [
              5272,
              7292
            ],
            [
              5262,
              7273
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "ER",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.31,
        "hc-middle-y": 0.18,
        "hc-key": "er",
        "hc-a2": "ER",
        "name": "Eritrea",
        "labelrank": "4",
        "country-abbrev": "Erit.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "ERI",
        "iso-a2": "ER",
        "woe-id": "23424806",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5266,
              7339
            ],
            [
              5252,
              7326
            ],
            [
              5241,
              7330
            ],
            [
              5187,
              7393
            ],
            [
              5086,
              7423
            ],
            [
              5041,
              7399
            ],
            [
              5036,
              7432
            ],
            [
              5052,
              7507
            ],
            [
              5092,
              7524
            ],
            [
              5104,
              7543
            ],
            [
              5147,
              7432
            ],
            [
              5197,
              7413
            ],
            [
              5266,
              7339
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BI",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.57,
        "hc-middle-y": 0.50,
        "hc-key": "bi",
        "hc-a2": "BI",
        "name": "Burundi",
        "labelrank": "6",
        "country-abbrev": "Bur.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "BDI",
        "iso-a2": "BI",
        "woe-id": "23424774",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4818,
              6679
            ],
            [
              4808,
              6701
            ],
            [
              4803,
              6722
            ],
            [
              4804,
              6733
            ],
            [
              4797,
              6745
            ],
            [
              4827,
              6747
            ],
            [
              4849,
              6758
            ],
            [
              4858,
              6725
            ],
            [
              4818,
              6679
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SR",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.85,
        "hc-middle-y": 0.20,
        "hc-key": "sr",
        "hc-a2": "SR",
        "name": "Suriname",
        "labelrank": "4",
        "country-abbrev": "Sur.",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "SUR",
        "iso-a2": "SR",
        "woe-id": "23424913",
        "continent": "South America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1869,
              7061
            ],
            [
              1879,
              7081
            ],
            [
              1979,
              7074
            ],
            [
              1973,
              7056
            ],
            [
              1962,
              7039
            ],
            [
              1977,
              6983
            ],
            [
              1956,
              6940
            ],
            [
              1910,
              6947
            ],
            [
              1892,
              6925
            ],
            [
              1840,
              7011
            ],
            [
              1869,
              7061
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "IL",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.55,
        "hc-middle-y": 0.17,
        "hc-key": "il",
        "hc-a2": "IL",
        "name": "Israel",
        "labelrank": "4",
        "country-abbrev": "Isr.",
        "subregion": "Western Asia",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "ISR",
        "iso-a2": "IL",
        "woe-id": "23424852",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4922,
              8055
            ],
            [
              4939,
              8092
            ],
            [
              4944,
              8123
            ],
            [
              4956,
              8123
            ],
            [
              4966,
              8135
            ],
            [
              4970,
              8117
            ],
            [
              4967,
              8109
            ],
            [
              4961,
              8105
            ],
            [
              4964,
              8072
            ],
            [
              4960,
              8062
            ],
            [
              4962,
              8055
            ],
            [
              4961,
              8052
            ],
            [
              4961,
              8051
            ],
            [
              4960,
              8049
            ],
            [
              4963,
              8046
            ],
            [
              4956,
              8021
            ],
            [
              4953,
              7987
            ],
            [
              4952,
              7985
            ],
            [
              4951,
              7985
            ],
            [
              4948,
              7994
            ],
            [
              4922,
              8055
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.24,
        "hc-middle-y": 0.55,
        "hc-key": "sn",
        "hc-a2": "SN",
        "name": "Senegal",
        "labelrank": "3",
        "country-abbrev": "Sen.",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "SEN",
        "iso-a2": "SN",
        "woe-id": "23424943",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3348,
              7338
            ],
            [
              3298,
              7338
            ],
            [
              3246,
              7325
            ],
            [
              3244,
              7343
            ],
            [
              3246,
              7353
            ],
            [
              3277,
              7356
            ],
            [
              3310,
              7380
            ],
            [
              3253,
              7373
            ],
            [
              3231,
              7415
            ],
            [
              3255,
              7458
            ],
            [
              3263,
              7483
            ],
            [
              3330,
              7490
            ],
            [
              3398,
              7419
            ],
            [
              3403,
              7377
            ],
            [
              3427,
              7327
            ],
            [
              3394,
              7324
            ],
            [
              3348,
              7338
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "GN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.57,
        "hc-middle-y": 0.38,
        "hc-key": "gn",
        "hc-a2": "GN",
        "name": "Guinea",
        "labelrank": "3",
        "country-abbrev": "Gin.",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "GIN",
        "iso-a2": "GN",
        "woe-id": "23424835",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3348,
              7338
            ],
            [
              3394,
              7324
            ],
            [
              3427,
              7327
            ],
            [
              3449,
              7308
            ],
            [
              3501,
              7330
            ],
            [
              3528,
              7287
            ],
            [
              3541,
              7241
            ],
            [
              3537,
              7212
            ],
            [
              3552,
              7172
            ],
            [
              3533,
              7177
            ],
            [
              3524,
              7141
            ],
            [
              3502,
              7127
            ],
            [
              3489,
              7171
            ],
            [
              3463,
              7177
            ],
            [
              3431,
              7235
            ],
            [
              3388,
              7229
            ],
            [
              3361,
              7198
            ],
            [
              3352,
              7226
            ],
            [
              3303,
              7272
            ],
            [
              3314,
              7292
            ],
            [
              3347,
              7301
            ],
            [
              3348,
              7338
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PL",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.47,
        "hc-key": "pl",
        "hc-a2": "PL",
        "name": "Poland",
        "labelrank": "3",
        "country-abbrev": "Pol.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "POL",
        "iso-a2": "PL",
        "woe-id": "23424923",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4370,
              8930
            ],
            [
              4365,
              8924
            ],
            [
              4374,
              8930
            ],
            [
              4459,
              8926
            ],
            [
              4461,
              8927
            ],
            [
              4481,
              8920
            ],
            [
              4483,
              8912
            ],
            [
              4501,
              8865
            ],
            [
              4483,
              8851
            ],
            [
              4500,
              8823
            ],
            [
              4519,
              8786
            ],
            [
              4481,
              8749
            ],
            [
              4480,
              8732
            ],
            [
              4457,
              8743
            ],
            [
              4368,
              8748
            ],
            [
              4359,
              8763
            ],
            [
              4293,
              8788
            ],
            [
              4245,
              8798
            ],
            [
              4235,
              8862
            ],
            [
              4220,
              8903
            ],
            [
              4230,
              8908
            ],
            [
              4218,
              8909
            ],
            [
              4217,
              8910
            ],
            [
              4218,
              8912
            ],
            [
              4332,
              8944
            ],
            [
              4370,
              8931
            ],
            [
              4370,
              8930
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MK",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.48,
        "hc-middle-y": 0.44,
        "hc-key": "mk",
        "hc-a2": "MK",
        "name": "Macedonia",
        "labelrank": "6",
        "country-abbrev": "Mkd.",
        "subregion": "Southern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "MKD",
        "iso-a2": "MK",
        "woe-id": "23424890",
        "continent": "Europe"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                4465,
                8421
              ],
              [
                4465,
                8421
              ],
              [
                4465,
                8421
              ],
              [
                4465,
                8421
              ]
            ]
          ],
          [
            [
              [
                4502,
                8476
              ],
              [
                4525,
                8454
              ],
              [
                4524,
                8439
              ],
              [
                4493,
                8430
              ],
              [
                4470,
                8421
              ],
              [
                4464,
                8427
              ],
              [
                4465,
                8422
              ],
              [
                4464,
                8423
              ],
              [
                4464,
                8423
              ],
              [
                4461,
                8423
              ],
              [
                4457,
                8423
              ],
              [
                4459,
                8431
              ],
              [
                4454,
                8429
              ],
              [
                4448,
                8439
              ],
              [
                4449,
                8459
              ],
              [
                4464,
                8471
              ],
              [
                4478,
                8473
              ],
              [
                4489,
                8476
              ],
              [
                4502,
                8476
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "PY",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.41,
        "hc-middle-y": 0.37,
        "hc-key": "py",
        "hc-a2": "PY",
        "name": "Paraguay",
        "labelrank": "4",
        "country-abbrev": "Para.",
        "subregion": "South America",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "PRY",
        "iso-a2": "PY",
        "woe-id": "23424917",
        "continent": "South America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              2013,
              5924
            ],
            [
              2013,
              5913
            ],
            [
              2007,
              5872
            ],
            [
              2008,
              5868
            ],
            [
              2008,
              5866
            ],
            [
              2006,
              5825
            ],
            [
              1978,
              5794
            ],
            [
              1884,
              5799
            ],
            [
              1910,
              5871
            ],
            [
              1822,
              5926
            ],
            [
              1789,
              5934
            ],
            [
              1728,
              5995
            ],
            [
              1734,
              6059
            ],
            [
              1749,
              6094
            ],
            [
              1836,
              6108
            ],
            [
              1870,
              6074
            ],
            [
              1884,
              6044
            ],
            [
              1882,
              6001
            ],
            [
              1935,
              6001
            ],
            [
              1963,
              5979
            ],
            [
              1974,
              5929
            ],
            [
              2013,
              5924
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BY",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.50,
        "hc-key": "by",
        "hc-a2": "BY",
        "name": "Belarus",
        "labelrank": "4",
        "country-abbrev": "Bela.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "BLR",
        "iso-a2": "BY",
        "woe-id": "23424765",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4483,
              8912
            ],
            [
              4538,
              8925
            ],
            [
              4562,
              8974
            ],
            [
              4589,
              8979
            ],
            [
              4602,
              8992
            ],
            [
              4683,
              8972
            ],
            [
              4721,
              8906
            ],
            [
              4752,
              8893
            ],
            [
              4712,
              8878
            ],
            [
              4734,
              8844
            ],
            [
              4667,
              8817
            ],
            [
              4560,
              8838
            ],
            [
              4500,
              8823
            ],
            [
              4483,
              8851
            ],
            [
              4501,
              8865
            ],
            [
              4483,
              8912
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LV",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.47,
        "hc-key": "lv",
        "hc-a2": "LV",
        "name": "Latvia",
        "labelrank": "5",
        "country-abbrev": "Lat.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "LVA",
        "iso-a2": "LV",
        "woe-id": "23424874",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4602,
              8992
            ],
            [
              4589,
              8979
            ],
            [
              4562,
              8974
            ],
            [
              4532,
              8992
            ],
            [
              4431,
              9002
            ],
            [
              4403,
              8989
            ],
            [
              4414,
              9043
            ],
            [
              4437,
              9050
            ],
            [
              4472,
              9021
            ],
            [
              4484,
              9054
            ],
            [
              4510,
              9061
            ],
            [
              4571,
              9041
            ],
            [
              4583,
              9017
            ],
            [
              4602,
              8992
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BF",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.60,
        "hc-middle-y": 0.44,
        "hc-key": "bf",
        "hc-a2": "BF",
        "name": "Burkina Faso",
        "labelrank": "3",
        "country-abbrev": "B.F.",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "BFA",
        "iso-a2": "BF",
        "woe-id": "23424978",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3842,
              7273
            ],
            [
              3828,
              7273
            ],
            [
              3805,
              7278
            ],
            [
              3718,
              7273
            ],
            [
              3720,
              7215
            ],
            [
              3702,
              7232
            ],
            [
              3653,
              7223
            ],
            [
              3624,
              7251
            ],
            [
              3637,
              7310
            ],
            [
              3657,
              7318
            ],
            [
              3673,
              7366
            ],
            [
              3702,
              7361
            ],
            [
              3715,
              7390
            ],
            [
              3740,
              7394
            ],
            [
              3787,
              7430
            ],
            [
              3818,
              7424
            ],
            [
              3816,
              7410
            ],
            [
              3844,
              7351
            ],
            [
              3885,
              7335
            ],
            [
              3892,
              7308
            ],
            [
              3860,
              7292
            ],
            [
              3842,
              7273
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SS",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.48,
        "hc-middle-y": 0.58,
        "hc-key": "ss",
        "hc-a2": "SS",
        "name": "South Sudan",
        "labelrank": "3",
        "country-abbrev": "S. Sud.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "SSD",
        "iso-a2": "SS",
        "woe-id": "-99",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4965,
              7012
            ],
            [
              4948,
              6994
            ],
            [
              4904,
              6986
            ],
            [
              4890,
              6997
            ],
            [
              4858,
              6984
            ],
            [
              4823,
              7025
            ],
            [
              4774,
              7015
            ],
            [
              4742,
              7045
            ],
            [
              4707,
              7084
            ],
            [
              4706,
              7106
            ],
            [
              4670,
              7133
            ],
            [
              4630,
              7184
            ],
            [
              4643,
              7192
            ],
            [
              4659,
              7246
            ],
            [
              4685,
              7251
            ],
            [
              4710,
              7216
            ],
            [
              4755,
              7219
            ],
            [
              4787,
              7209
            ],
            [
              4826,
              7245
            ],
            [
              4868,
              7227
            ],
            [
              4907,
              7275
            ],
            [
              4894,
              7312
            ],
            [
              4932,
              7320
            ],
            [
              4933,
              7267
            ],
            [
              4958,
              7242
            ],
            [
              4964,
              7214
            ],
            [
              4961,
              7175
            ],
            [
              4935,
              7173
            ],
            [
              4931,
              7150
            ],
            [
              4954,
              7145
            ],
            [
              4989,
              7105
            ],
            [
              5030,
              7028
            ],
            [
              5013,
              7044
            ],
            [
              4965,
              7012
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CF",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.56,
        "hc-middle-y": 0.53,
        "hc-key": "cf",
        "hc-a2": "CF",
        "name": "Central African Republic",
        "labelrank": "4",
        "country-abbrev": "C.A.R.",
        "subregion": "Middle Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "CAF",
        "iso-a2": "CF",
        "woe-id": "23424792",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4630,
              7184
            ],
            [
              4670,
              7133
            ],
            [
              4706,
              7106
            ],
            [
              4707,
              7084
            ],
            [
              4742,
              7045
            ],
            [
              4679,
              7057
            ],
            [
              4607,
              7029
            ],
            [
              4588,
              7036
            ],
            [
              4575,
              7011
            ],
            [
              4510,
              7020
            ],
            [
              4480,
              7048
            ],
            [
              4441,
              7017
            ],
            [
              4444,
              6984
            ],
            [
              4404,
              6993
            ],
            [
              4374,
              6983
            ],
            [
              4361,
              6936
            ],
            [
              4358,
              6959
            ],
            [
              4326,
              6995
            ],
            [
              4299,
              7082
            ],
            [
              4336,
              7140
            ],
            [
              4372,
              7153
            ],
            [
              4379,
              7141
            ],
            [
              4441,
              7160
            ],
            [
              4458,
              7197
            ],
            [
              4503,
              7202
            ],
            [
              4570,
              7273
            ],
            [
              4584,
              7270
            ],
            [
              4611,
              7230
            ],
            [
              4606,
              7188
            ],
            [
              4630,
              7184
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "NA",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.33,
        "hc-middle-y": 0.29,
        "hc-key": "na",
        "hc-a2": "NA",
        "name": "Namibia",
        "labelrank": "3",
        "country-abbrev": "Nam.",
        "subregion": "Southern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "NAM",
        "iso-a2": "NA",
        "woe-id": "23424987",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4595,
              6171
            ],
            [
              4623,
              6178
            ],
            [
              4657,
              6165
            ],
            [
              4600,
              6140
            ],
            [
              4591,
              6158
            ],
            [
              4513,
              6145
            ],
            [
              4509,
              6005
            ],
            [
              4476,
              6004
            ],
            [
              4472,
              5898
            ],
            [
              4466,
              5757
            ],
            [
              4437,
              5736
            ],
            [
              4381,
              5746
            ],
            [
              4365,
              5770
            ],
            [
              4351,
              5751
            ],
            [
              4314,
              5799
            ],
            [
              4294,
              5905
            ],
            [
              4289,
              5993
            ],
            [
              4208,
              6152
            ],
            [
              4206,
              6186
            ],
            [
              4253,
              6198
            ],
            [
              4279,
              6180
            ],
            [
              4430,
              6181
            ],
            [
              4440,
              6167
            ],
            [
              4508,
              6156
            ],
            [
              4595,
              6171
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "RO",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.60,
        "hc-key": "ro",
        "hc-a2": "RO",
        "name": "Romania",
        "labelrank": "3",
        "country-abbrev": "Rom.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "ROU",
        "iso-a2": "RO",
        "woe-id": "23424933",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4668,
              8596
            ],
            [
              4687,
              8588
            ],
            [
              4713,
              8587
            ],
            [
              4690,
              8565
            ],
            [
              4688,
              8529
            ],
            [
              4638,
              8545
            ],
            [
              4590,
              8525
            ],
            [
              4526,
              8534
            ],
            [
              4505,
              8547
            ],
            [
              4462,
              8570
            ],
            [
              4465,
              8584
            ],
            [
              4424,
              8620
            ],
            [
              4450,
              8627
            ],
            [
              4471,
              8672
            ],
            [
              4495,
              8689
            ],
            [
              4567,
              8687
            ],
            [
              4606,
              8701
            ],
            [
              4617,
              8698
            ],
            [
              4663,
              8639
            ],
            [
              4668,
              8596
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "ZW",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.63,
        "hc-middle-y": 0.51,
        "hc-key": "zw",
        "hc-a2": "ZW",
        "name": "Zimbabwe",
        "labelrank": "3",
        "country-abbrev": "Zimb.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "ZWE",
        "iso-a2": "ZW",
        "woe-id": "23425004",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4657,
              6165
            ],
            [
              4705,
              6155
            ],
            [
              4716,
              6159
            ],
            [
              4754,
              6202
            ],
            [
              4755,
              6202
            ],
            [
              4777,
              6214
            ],
            [
              4781,
              6233
            ],
            [
              4833,
              6249
            ],
            [
              4918,
              6208
            ],
            [
              4917,
              6144
            ],
            [
              4906,
              6101
            ],
            [
              4913,
              6079
            ],
            [
              4890,
              6031
            ],
            [
              4851,
              5988
            ],
            [
              4818,
              5991
            ],
            [
              4787,
              5997
            ],
            [
              4744,
              6020
            ],
            [
              4735,
              6061
            ],
            [
              4684,
              6100
            ],
            [
              4657,
              6165
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "KH",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.25,
        "hc-middle-y": 0.55,
        "hc-key": "kh",
        "hc-a2": "KH",
        "name": "Cambodia",
        "labelrank": "3",
        "country-abbrev": "Camb.",
        "subregion": "South-Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "KHM",
        "iso-a2": "KH",
        "woe-id": "23424776",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              7343,
              7251
            ],
            [
              7296,
              7271
            ],
            [
              7287,
              7298
            ],
            [
              7260,
              7372
            ],
            [
              7283,
              7400
            ],
            [
              7353,
              7402
            ],
            [
              7408,
              7401
            ],
            [
              7430,
              7416
            ],
            [
              7440,
              7325
            ],
            [
              7385,
              7274
            ],
            [
              7343,
              7251
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SD",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.50,
        "hc-key": "sd",
        "hc-a2": "SD",
        "name": "Sudan",
        "labelrank": "3",
        "country-abbrev": "Sudan",
        "subregion": "Northern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "SDN",
        "iso-a2": "SD",
        "woe-id": "-90",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5038,
              7696
            ],
            [
              5054,
              7652
            ],
            [
              5052,
              7620
            ],
            [
              5067,
              7570
            ],
            [
              5104,
              7543
            ],
            [
              5092,
              7524
            ],
            [
              5052,
              7507
            ],
            [
              5036,
              7432
            ],
            [
              5041,
              7399
            ],
            [
              5030,
              7339
            ],
            [
              5013,
              7334
            ],
            [
              4989,
              7263
            ],
            [
              4980,
              7269
            ],
            [
              4964,
              7214
            ],
            [
              4958,
              7242
            ],
            [
              4933,
              7267
            ],
            [
              4932,
              7320
            ],
            [
              4894,
              7312
            ],
            [
              4907,
              7275
            ],
            [
              4868,
              7227
            ],
            [
              4826,
              7245
            ],
            [
              4787,
              7209
            ],
            [
              4755,
              7219
            ],
            [
              4710,
              7216
            ],
            [
              4685,
              7251
            ],
            [
              4659,
              7246
            ],
            [
              4643,
              7192
            ],
            [
              4630,
              7184
            ],
            [
              4606,
              7188
            ],
            [
              4611,
              7230
            ],
            [
              4584,
              7270
            ],
            [
              4560,
              7340
            ],
            [
              4555,
              7380
            ],
            [
              4571,
              7394
            ],
            [
              4587,
              7454
            ],
            [
              4617,
              7455
            ],
            [
              4612,
              7600
            ],
            [
              4612,
              7619
            ],
            [
              4645,
              7620
            ],
            [
              4642,
              7696
            ],
            [
              4851,
              7696
            ],
            [
              5038,
              7696
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "TN",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.22,
        "hc-middle-y": 0.18,
        "hc-key": "tn",
        "hc-a2": "TN",
        "name": "Tunisia",
        "labelrank": "3",
        "country-abbrev": "Tun.",
        "subregion": "Northern Africa",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "TUN",
        "iso-a2": "TN",
        "woe-id": "23424967",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4182,
              8126
            ],
            [
              4185,
              8099
            ],
            [
              4139,
              8059
            ],
            [
              4145,
              8039
            ],
            [
              4121,
              8013
            ],
            [
              4104,
              8084
            ],
            [
              4081,
              8101
            ],
            [
              4052,
              8154
            ],
            [
              4075,
              8183
            ],
            [
              4084,
              8273
            ],
            [
              4120,
              8288
            ],
            [
              4168,
              8206
            ],
            [
              4135,
              8156
            ],
            [
              4167,
              8150
            ],
            [
              4182,
              8126
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LY",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.53,
        "hc-middle-y": 0.49,
        "hc-key": "ly",
        "hc-a2": "LY",
        "name": "Libya",
        "labelrank": "3",
        "country-abbrev": "Libya",
        "subregion": "Northern Africa",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "LBY",
        "iso-a2": "LY",
        "woe-id": "23424882",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4121,
              8013
            ],
            [
              4145,
              8039
            ],
            [
              4139,
              8059
            ],
            [
              4185,
              8099
            ],
            [
              4182,
              8126
            ],
            [
              4242,
              8116
            ],
            [
              4302,
              8096
            ],
            [
              4332,
              8053
            ],
            [
              4376,
              8046
            ],
            [
              4432,
              8014
            ],
            [
              4454,
              8024
            ],
            [
              4457,
              8072
            ],
            [
              4476,
              8102
            ],
            [
              4509,
              8117
            ],
            [
              4558,
              8105
            ],
            [
              4558,
              8094
            ],
            [
              4621,
              8080
            ],
            [
              4627,
              8068
            ],
            [
              4616,
              8011
            ],
            [
              4628,
              7973
            ],
            [
              4642,
              7696
            ],
            [
              4645,
              7620
            ],
            [
              4612,
              7619
            ],
            [
              4612,
              7600
            ],
            [
              4341,
              7752
            ],
            [
              4308,
              7735
            ],
            [
              4283,
              7720
            ],
            [
              4259,
              7742
            ],
            [
              4208,
              7755
            ],
            [
              4193,
              7785
            ],
            [
              4143,
              7806
            ],
            [
              4121,
              7855
            ],
            [
              4135,
              7870
            ],
            [
              4133,
              7971
            ],
            [
              4121,
              8013
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "ML",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.61,
        "hc-middle-y": 0.46,
        "hc-key": "ml",
        "hc-a2": "ML",
        "name": "Mali",
        "labelrank": "3",
        "country-abbrev": "Mali",
        "subregion": "Western Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "MLI",
        "iso-a2": "ML",
        "woe-id": "23424891",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3624,
              7251
            ],
            [
              3600,
              7263
            ],
            [
              3575,
              7241
            ],
            [
              3541,
              7241
            ],
            [
              3528,
              7287
            ],
            [
              3501,
              7330
            ],
            [
              3449,
              7308
            ],
            [
              3427,
              7327
            ],
            [
              3403,
              7377
            ],
            [
              3398,
              7419
            ],
            [
              3417,
              7448
            ],
            [
              3450,
              7444
            ],
            [
              3626,
              7446
            ],
            [
              3593,
              7812
            ],
            [
              3652,
              7812
            ],
            [
              3849,
              7662
            ],
            [
              3874,
              7628
            ],
            [
              3918,
              7612
            ],
            [
              3915,
              7586
            ],
            [
              3952,
              7587
            ],
            [
              3952,
              7482
            ],
            [
              3929,
              7441
            ],
            [
              3856,
              7438
            ],
            [
              3818,
              7424
            ],
            [
              3787,
              7430
            ],
            [
              3740,
              7394
            ],
            [
              3715,
              7390
            ],
            [
              3702,
              7361
            ],
            [
              3673,
              7366
            ],
            [
              3657,
              7318
            ],
            [
              3637,
              7310
            ],
            [
              3624,
              7251
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BT",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.53,
        "hc-middle-y": 0.65,
        "hc-key": "bt",
        "hc-a2": "BT",
        "name": "Bhutan",
        "labelrank": "5",
        "country-abbrev": "Bhutan",
        "subregion": "Southern Asia",
        "region-wb": "South Asia",
        "iso-a3": "BTN",
        "iso-a2": "BT",
        "woe-id": "23424770",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6734,
              7901
            ],
            [
              6769,
              7941
            ],
            [
              6821,
              7918
            ],
            [
              6842,
              7887
            ],
            [
              6769,
              7877
            ],
            [
              6734,
              7901
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "BW",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.32,
        "hc-middle-y": 0.62,
        "hc-key": "bw",
        "hc-a2": "BW",
        "name": "Botswana",
        "labelrank": "4",
        "country-abbrev": "Bwa.",
        "subregion": "Southern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "BWA",
        "iso-a2": "BW",
        "woe-id": "23424755",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4657,
              6165
            ],
            [
              4684,
              6100
            ],
            [
              4735,
              6061
            ],
            [
              4744,
              6020
            ],
            [
              4787,
              5997
            ],
            [
              4748,
              5978
            ],
            [
              4707,
              5941
            ],
            [
              4700,
              5917
            ],
            [
              4667,
              5898
            ],
            [
              4656,
              5864
            ],
            [
              4631,
              5856
            ],
            [
              4572,
              5877
            ],
            [
              4561,
              5850
            ],
            [
              4524,
              5817
            ],
            [
              4492,
              5815
            ],
            [
              4498,
              5845
            ],
            [
              4472,
              5898
            ],
            [
              4476,
              6004
            ],
            [
              4509,
              6005
            ],
            [
              4513,
              6145
            ],
            [
              4591,
              6158
            ],
            [
              4600,
              6140
            ],
            [
              4657,
              6165
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MD",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.39,
        "hc-key": "md",
        "hc-a2": "MD",
        "name": "Moldova",
        "labelrank": "6",
        "country-abbrev": "Mda.",
        "subregion": "Eastern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "MDA",
        "iso-a2": "MD",
        "woe-id": "23424885",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4668,
              8596
            ],
            [
              4663,
              8639
            ],
            [
              4617,
              8698
            ],
            [
              4606,
              8701
            ],
            [
              4638,
              8708
            ],
            [
              4686,
              8686
            ],
            [
              4720,
              8630
            ],
            [
              4685,
              8633
            ],
            [
              4668,
              8596
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "JP",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.74,
        "hc-middle-y": 0.57,
        "hc-key": "jp",
        "hc-a2": "JP",
        "name": "Japan",
        "labelrank": "2",
        "country-abbrev": "Japan",
        "subregion": "Eastern Asia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "JPN",
        "iso-a2": "JP",
        "woe-id": "23424856",
        "continent": "Asia"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                8123,
                8179
              ],
              [
                8060,
                8167
              ],
              [
                8032,
                8155
              ],
              [
                8053,
                8214
              ],
              [
                8109,
                8223
              ],
              [
                8151,
                8216
              ],
              [
                8158,
                8262
              ],
              [
                8199,
                8282
              ],
              [
                8193,
                8310
              ],
              [
                8217,
                8320
              ],
              [
                8208,
                8372
              ],
              [
                8188,
                8390
              ],
              [
                8178,
                8436
              ],
              [
                8189,
                8447
              ],
              [
                8259,
                8389
              ],
              [
                8276,
                8357
              ],
              [
                8266,
                8321
              ],
              [
                8284,
                8290
              ],
              [
                8290,
                8247
              ],
              [
                8311,
                8225
              ],
              [
                8296,
                8193
              ],
              [
                8285,
                8209
              ],
              [
                8240,
                8183
              ],
              [
                8200,
                8187
              ],
              [
                8191,
                8142
              ],
              [
                8157,
                8153
              ],
              [
                8155,
                8185
              ],
              [
                8124,
                8179
              ],
              [
                8138,
                8169
              ],
              [
                8140,
                8128
              ],
              [
                8121,
                8140
              ],
              [
                8096,
                8109
              ],
              [
                8076,
                8137
              ],
              [
                8123,
                8179
              ]
            ]
          ],
          [
            [
              [
                8018,
                8111
              ],
              [
                7986,
                8126
              ],
              [
                7964,
                8162
              ],
              [
                7999,
                8131
              ],
              [
                8011,
                8152
              ],
              [
                8052,
                8145
              ],
              [
                8075,
                8117
              ],
              [
                8077,
                8057
              ],
              [
                8042,
                8052
              ],
              [
                8024,
                8074
              ],
              [
                8018,
                8111
              ]
            ]
          ],
          [
            [
              [
                8252,
                8461
              ],
              [
                8188,
                8487
              ],
              [
                8152,
                8474
              ],
              [
                8192,
                8456
              ],
              [
                8160,
                8447
              ],
              [
                8130,
                8489
              ],
              [
                8131,
                8515
              ],
              [
                8161,
                8515
              ],
              [
                8136,
                8567
              ],
              [
                8111,
                8585
              ],
              [
                8121,
                8598
              ],
              [
                8197,
                8550
              ],
              [
                8262,
                8530
              ],
              [
                8284,
                8508
              ],
              [
                8255,
                8500
              ],
              [
                8252,
                8461
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "AU",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.58,
        "hc-middle-y": 0.40,
        "hc-key": "au",
        "hc-a2": "AU",
        "name": "Australia",
        "labelrank": "2",
        "country-abbrev": "Auz.",
        "subregion": "Australia and New Zealand",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "AUS",
        "iso-a2": "AU",
        "woe-id": "-90",
        "continent": "Oceania"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                8333,
                5284
              ],
              [
                8374,
                5268
              ],
              [
                8437,
                5290
              ],
              [
                8411,
                5244
              ],
              [
                8375,
                5208
              ],
              [
                8320,
                5175
              ],
              [
                8299,
                5188
              ],
              [
                8311,
                5258
              ],
              [
                8333,
                5284
              ]
            ]
          ],
          [
            [
              [
                8694,
                6222
              ],
              [
                8709,
                6172
              ],
              [
                8708,
                6116
              ],
              [
                8784,
                6070
              ],
              [
                8786,
                5994
              ],
              [
                8822,
                5977
              ],
              [
                8815,
                5959
              ],
              [
                8841,
                5926
              ],
              [
                8858,
                5879
              ],
              [
                8883,
                5888
              ],
              [
                8863,
                5858
              ],
              [
                8859,
                5795
              ],
              [
                8840,
                5739
              ],
              [
                8747,
                5602
              ],
              [
                8714,
                5585
              ],
              [
                8604,
                5468
              ],
              [
                8565,
                5406
              ],
              [
                8505,
                5393
              ],
              [
                8427,
                5356
              ],
              [
                8384,
                5366
              ],
              [
                8398,
                5390
              ],
              [
                8332,
                5353
              ],
              [
                8307,
                5372
              ],
              [
                8259,
                5383
              ],
              [
                8247,
                5418
              ],
              [
                8261,
                5440
              ],
              [
                8254,
                5482
              ],
              [
                8195,
                5461
              ],
              [
                8173,
                5474
              ],
              [
                8221,
                5474
              ],
              [
                8254,
                5514
              ],
              [
                8250,
                5537
              ],
              [
                8219,
                5496
              ],
              [
                8191,
                5492
              ],
              [
                8266,
                5576
              ],
              [
                8247,
                5575
              ],
              [
                8157,
                5505
              ],
              [
                8151,
                5602
              ],
              [
                8096,
                5618
              ],
              [
                8069,
                5639
              ],
              [
                7996,
                5631
              ],
              [
                7932,
                5609
              ],
              [
                7897,
                5610
              ],
              [
                7816,
                5575
              ],
              [
                7785,
                5545
              ],
              [
                7672,
                5545
              ],
              [
                7606,
                5507
              ],
              [
                7542,
                5504
              ],
              [
                7508,
                5539
              ],
              [
                7542,
                5570
              ],
              [
                7565,
                5633
              ],
              [
                7560,
                5688
              ],
              [
                7568,
                5716
              ],
              [
                7560,
                5799
              ],
              [
                7540,
                5859
              ],
              [
                7560,
                5869
              ],
              [
                7571,
                5833
              ],
              [
                7579,
                5858
              ],
              [
                7566,
                5906
              ],
              [
                7587,
                5981
              ],
              [
                7684,
                6048
              ],
              [
                7737,
                6055
              ],
              [
                7851,
                6095
              ],
              [
                7907,
                6152
              ],
              [
                7908,
                6186
              ],
              [
                7939,
                6212
              ],
              [
                7952,
                6176
              ],
              [
                7965,
                6222
              ],
              [
                7989,
                6222
              ],
              [
                7996,
                6264
              ],
              [
                8022,
                6288
              ],
              [
                8055,
                6292
              ],
              [
                8090,
                6322
              ],
              [
                8125,
                6285
              ],
              [
                8173,
                6270
              ],
              [
                8167,
                6296
              ],
              [
                8201,
                6352
              ],
              [
                8233,
                6391
              ],
              [
                8203,
                6396
              ],
              [
                8218,
                6421
              ],
              [
                8255,
                6412
              ],
              [
                8247,
                6378
              ],
              [
                8290,
                6383
              ],
              [
                8292,
                6425
              ],
              [
                8309,
                6400
              ],
              [
                8371,
                6378
              ],
              [
                8418,
                6404
              ],
              [
                8432,
                6373
              ],
              [
                8390,
                6327
              ],
              [
                8372,
                6272
              ],
              [
                8452,
                6206
              ],
              [
                8484,
                6207
              ],
              [
                8502,
                6169
              ],
              [
                8533,
                6179
              ],
              [
                8577,
                6273
              ],
              [
                8589,
                6368
              ],
              [
                8613,
                6414
              ],
              [
                8619,
                6458
              ],
              [
                8632,
                6436
              ],
              [
                8641,
                6376
              ],
              [
                8651,
                6365
              ],
              [
                8657,
                6292
              ],
              [
                8678,
                6305
              ],
              [
                8702,
                6275
              ],
              [
                8694,
                6222
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "NZ",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.16,
        "hc-middle-y": 0.84,
        "hc-key": "nz",
        "hc-a2": "NZ",
        "name": "New Zealand",
        "labelrank": "2",
        "country-abbrev": "N.Z.",
        "subregion": "Australia and New Zealand",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "NZL",
        "iso-a2": "NZ",
        "woe-id": "23424916",
        "continent": "Oceania"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                9020,
                5119
              ],
              [
                8928,
                5062
              ],
              [
                8905,
                5063
              ],
              [
                8854,
                5041
              ],
              [
                8882,
                5077
              ],
              [
                8857,
                5091
              ],
              [
                8903,
                5125
              ],
              [
                8969,
                5160
              ],
              [
                9025,
                5178
              ],
              [
                9104,
                5220
              ],
              [
                9177,
                5278
              ],
              [
                9207,
                5292
              ],
              [
                9196,
                5262
              ],
              [
                9229,
                5277
              ],
              [
                9214,
                5242
              ],
              [
                9102,
                5172
              ],
              [
                9052,
                5152
              ],
              [
                9020,
                5119
              ]
            ]
          ],
          [
            [
              [
                9407,
                5343
              ],
              [
                9293,
                5269
              ],
              [
                9253,
                5251
              ],
              [
                9243,
                5263
              ],
              [
                9295,
                5309
              ],
              [
                9271,
                5332
              ],
              [
                9311,
                5354
              ],
              [
                9347,
                5395
              ],
              [
                9359,
                5440
              ],
              [
                9355,
                5524
              ],
              [
                9390,
                5480
              ],
              [
                9369,
                5432
              ],
              [
                9384,
                5418
              ],
              [
                9394,
                5456
              ],
              [
                9404,
                5436
              ],
              [
                9392,
                5401
              ],
              [
                9423,
                5387
              ],
              [
                9466,
                5397
              ],
              [
                9407,
                5343
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "CU",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.66,
        "hc-middle-y": 0.61,
        "hc-key": "cu",
        "hc-a2": "CU",
        "name": "Cuba",
        "labelrank": "3",
        "country-abbrev": "Cuba",
        "subregion": "Caribbean",
        "region-wb": "Latin America & Caribbean",
        "iso-a3": "CUB",
        "iso-a2": "CU",
        "woe-id": "23424793",
        "continent": "North America"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              1332,
              7622
            ],
            [
              1216,
              7613
            ],
            [
              1240,
              7637
            ],
            [
              1196,
              7643
            ],
            [
              1190,
              7682
            ],
            [
              1135,
              7699
            ],
            [
              1099,
              7699
            ],
            [
              1062,
              7724
            ],
            [
              998,
              7688
            ],
            [
              1006,
              7710
            ],
            [
              1048,
              7735
            ],
            [
              1141,
              7741
            ],
            [
              1215,
              7712
            ],
            [
              1249,
              7676
            ],
            [
              1318,
              7644
            ],
            [
              1332,
              7622
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "FI",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.58,
        "hc-middle-y": 0.53,
        "hc-key": "fi",
        "hc-a2": "FI",
        "name": "Finland",
        "labelrank": "3",
        "country-abbrev": "Fin.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "FIN",
        "iso-a2": "FI",
        "woe-id": "23424812",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4562,
              9149
            ],
            [
              4456,
              9128
            ],
            [
              4388,
              9148
            ],
            [
              4373,
              9241
            ],
            [
              4399,
              9245
            ],
            [
              4451,
              9297
            ],
            [
              4461,
              9319
            ],
            [
              4430,
              9330
            ],
            [
              4403,
              9401
            ],
            [
              4320,
              9436
            ],
            [
              4344,
              9444
            ],
            [
              4367,
              9426
            ],
            [
              4429,
              9420
            ],
            [
              4449,
              9457
            ],
            [
              4493,
              9469
            ],
            [
              4526,
              9456
            ],
            [
              4526,
              9436
            ],
            [
              4526,
              9409
            ],
            [
              4564,
              9392
            ],
            [
              4547,
              9364
            ],
            [
              4574,
              9339
            ],
            [
              4575,
              9302
            ],
            [
              4608,
              9269
            ],
            [
              4595,
              9259
            ],
            [
              4644,
              9231
            ],
            [
              4639,
              9217
            ],
            [
              4562,
              9149
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "SE",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.41,
        "hc-middle-y": 0.50,
        "hc-key": "se",
        "hc-a2": "SE",
        "name": "Sweden",
        "labelrank": "3",
        "country-abbrev": "Swe.",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "SWE",
        "iso-a2": "SE",
        "woe-id": "23424954",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4430,
              9330
            ],
            [
              4382,
              9329
            ],
            [
              4354,
              9264
            ],
            [
              4284,
              9216
            ],
            [
              4272,
              9165
            ],
            [
              4329,
              9126
            ],
            [
              4317,
              9097
            ],
            [
              4276,
              9081
            ],
            [
              4267,
              9055
            ],
            [
              4283,
              9033
            ],
            [
              4322,
              9051
            ],
            [
              4324,
              9028
            ],
            [
              4286,
              9031
            ],
            [
              4274,
              8995
            ],
            [
              4226,
              8993
            ],
            [
              4212,
              8964
            ],
            [
              4178,
              8965
            ],
            [
              4171,
              9010
            ],
            [
              4120,
              9071
            ],
            [
              4124,
              9094
            ],
            [
              4150,
              9133
            ],
            [
              4126,
              9244
            ],
            [
              4142,
              9267
            ],
            [
              4175,
              9268
            ],
            [
              4165,
              9288
            ],
            [
              4185,
              9313
            ],
            [
              4182,
              9340
            ],
            [
              4225,
              9370
            ],
            [
              4217,
              9383
            ],
            [
              4262,
              9420
            ],
            [
              4308,
              9414
            ],
            [
              4320,
              9436
            ],
            [
              4403,
              9401
            ],
            [
              4430,
              9330
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "MG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.46,
        "hc-middle-y": 0.49,
        "hc-key": "mg",
        "hc-a2": "MG",
        "name": "Madagascar",
        "labelrank": "3",
        "country-abbrev": "Mad.",
        "subregion": "Eastern Africa",
        "region-wb": "Sub-Saharan Africa",
        "iso-a3": "MDG",
        "iso-a2": "MG",
        "woe-id": "23424883",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              5485,
              6214
            ],
            [
              5388,
              5932
            ],
            [
              5368,
              5889
            ],
            [
              5302,
              5866
            ],
            [
              5267,
              5888
            ],
            [
              5263,
              5947
            ],
            [
              5248,
              5994
            ],
            [
              5260,
              6030
            ],
            [
              5296,
              6081
            ],
            [
              5284,
              6179
            ],
            [
              5304,
              6227
            ],
            [
              5365,
              6246
            ],
            [
              5408,
              6270
            ],
            [
              5437,
              6335
            ],
            [
              5453,
              6333
            ],
            [
              5474,
              6390
            ],
            [
              5496,
              6349
            ],
            [
              5509,
              6256
            ],
            [
              5499,
              6236
            ],
            [
              5480,
              6252
            ],
            [
              5485,
              6214
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "VU",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.46,
        "hc-middle-y": 0.27,
        "hc-key": "vu",
        "hc-a2": "VU",
        "name": "Vanuatu",
        "labelrank": "4",
        "country-abbrev": "Van.",
        "subregion": "Melanesia",
        "region-wb": "East Asia & Pacific",
        "iso-a3": "VUT",
        "iso-a2": "VU",
        "woe-id": "23424907",
        "continent": "Oceania"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              9452,
              6164
            ],
            [
              9459,
              6221
            ],
            [
              9433,
              6212
            ],
            [
              9430,
              6250
            ],
            [
              9414,
              6258
            ],
            [
              9449,
              6300
            ],
            [
              9467,
              6275
            ],
            [
              9466,
              6200
            ],
            [
              9458,
              6165
            ],
            [
              9474,
              6123
            ],
            [
              9471,
              6094
            ],
            [
              9452,
              6164
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "IS",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.67,
        "hc-middle-y": 0.50,
        "hc-key": "is",
        "hc-a2": "IS",
        "name": "Iceland",
        "labelrank": "3",
        "country-abbrev": "Iceland",
        "subregion": "Northern Europe",
        "region-wb": "Europe & Central Asia",
        "iso-a3": "ISL",
        "iso-a2": "IS",
        "woe-id": "23424845",
        "continent": "Europe"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              3273,
              9314
            ],
            [
              3299,
              9340
            ],
            [
              3362,
              9335
            ],
            [
              3401,
              9354
            ],
            [
              3436,
              9338
            ],
            [
              3463,
              9308
            ],
            [
              3433,
              9282
            ],
            [
              3318,
              9247
            ],
            [
              3274,
              9259
            ],
            [
              3217,
              9262
            ],
            [
              3247,
              9282
            ],
            [
              3232,
              9321
            ],
            [
              3181,
              9319
            ],
            [
              3237,
              9351
            ],
            [
              3266,
              9335
            ],
            [
              3273,
              9314
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "LK",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.61,
        "hc-middle-y": 0.80,
        "hc-key": "lk",
        "hc-a2": "LK",
        "name": "Sri Lanka",
        "labelrank": "3",
        "country-abbrev": "Sri L.",
        "subregion": "Southern Asia",
        "region-wb": "South Asia",
        "iso-a3": "LKA",
        "iso-a2": "LK",
        "woe-id": "23424778",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6514,
              7161
            ],
            [
              6523,
              7227
            ],
            [
              6544,
              7210
            ],
            [
              6583,
              7142
            ],
            [
              6584,
              7104
            ],
            [
              6545,
              7078
            ],
            [
              6528,
              7086
            ],
            [
              6514,
              7161
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "EG",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.27,
        "hc-middle-y": 0.50,
        "hc-key": "eg",
        "hc-a2": "EG",
        "name": "Egypt",
        "labelrank": "2",
        "country-abbrev": "Egypt",
        "subregion": "Northern Africa",
        "region-wb": "Middle East & North Africa",
        "iso-a3": "EGY",
        "iso-a2": "EG",
        "woe-id": "23424802",
        "continent": "Africa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              4951,
              7985
            ],
            [
              4936,
              7917
            ],
            [
              4900,
              7949
            ],
            [
              4872,
              8003
            ],
            [
              4879,
              7965
            ],
            [
              4912,
              7914
            ],
            [
              4988,
              7773
            ],
            [
              4996,
              7732
            ],
            [
              5038,
              7696
            ],
            [
              4851,
              7696
            ],
            [
              4642,
              7696
            ],
            [
              4628,
              7973
            ],
            [
              4616,
              8011
            ],
            [
              4627,
              8068
            ],
            [
              4699,
              8057
            ],
            [
              4756,
              8036
            ],
            [
              4797,
              8062
            ],
            [
              4836,
              8060
            ],
            [
              4855,
              8045
            ],
            [
              4922,
              8055
            ],
            [
              4948,
              7994
            ],
            [
              4951,
              7985
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "id": "NP",
      "properties": {
        "hc-group": "admin0",
        "hc-middle-x": 0.35,
        "hc-middle-y": 0.42,
        "hc-key": "np",
        "hc-a2": "NP",
        "name": "Nepal",
        "labelrank": "3",
        "country-abbrev": "Nepal",
        "subregion": "Southern Asia",
        "region-wb": "South Asia",
        "iso-a3": "NPL",
        "iso-a2": "NP",
        "woe-id": "23424911",
        "continent": "Asia"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              6704,
              7922
            ],
            [
              6715,
              7878
            ],
            [
              6690,
              7864
            ],
            [
              6639,
              7872
            ],
            [
              6592,
              7902
            ],
            [
              6531,
              7908
            ],
            [
              6432,
              7960
            ],
            [
              6435,
              7995
            ],
            [
              6452,
              8012
            ],
            [
              6486,
              8017
            ],
            [
              6543,
              7973
            ],
            [
              6561,
              7976
            ],
            [
              6634,
              7923
            ],
            [
              6651,
              7931
            ],
            [
              6704,
              7922
            ]
          ]
        ]
      }
    }
  ]
}